var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

const cartQuantityRequests = {}

function updateCartQuantityControls(id, quantity) {
    const inputs = $('.nmb.' + id)
    const min = Number(inputs.first().attr('min')) || 1
    const max = Number($('#max_' + id).attr('max'))
    const atMinimum = quantity <= min
    const atMaximum = Number.isFinite(max) && quantity >= max

    inputs.closest('.prod-qty-sel').each(function () {
        const controls = $(this).find('.prod-qty-sel-btn')
        controls.eq(0).css({
            pointerEvents: atMinimum ? 'none' : '',
            opacity: atMinimum ? '0.5' : ''
        }).attr('aria-disabled', atMinimum ? 'true' : 'false')
        controls.eq(1).css({
            pointerEvents: atMaximum ? 'none' : '',
            opacity: atMaximum ? '0.5' : ''
        }).attr('aria-disabled', atMaximum ? 'true' : 'false')
    })
}

function syncCartQuantity(cart) {
    cart.items.forEach(function (item) {
        $('.nmb.' + item.variant_id).val(item.quantity)
        updateCartQuantityControls(item.variant_id, item.quantity)
        const linePrice = item.final_line_price.toString()
        $('.subtotal.' + item.variant_id).html('MXN $ ' + linePrice.slice(0, -2) + '.' + linePrice.slice(-2))
    })

    setComision(cart)
}

async function processCartQuantity(id) {
    const request = cartQuantityRequests[id]
    if (!request || request.pending) return

    const checkoutButton = document.querySelector('#tc-button')
    request.pending = true
    if (checkoutButton) checkoutButton.style.opacity = '0.5'

    const targetQuantity = request.desired
    try {
        const cart = await $.ajax({
            method: 'POST',
            url: '/cart/change.js',
            data: { id: id, quantity: targetQuantity },
            dataType: 'json'
        })
        syncCartQuantity(cart)

        const item = cart.items.find(function (cartItem) {
            return cartItem.variant_id === Number(id)
        })
        const actualQuantity = item ? item.quantity : 0
        if (request.desired === targetQuantity) {
            request.desired = actualQuantity === targetQuantity ? null : actualQuantity
        }
    } catch (error) {
        const cart = await $.getJSON('/cart.js')
        syncCartQuantity(cart)
        request.desired = null
    } finally {
        request.pending = false
        if (request.desired === null) {
            delete cartQuantityRequests[id]
            if (checkoutButton) checkoutButton.style.opacity = ''
        } else {
            processCartQuantity(id)
        }
    }
}

function queueCartQuantity(id, quantity) {
    const request = cartQuantityRequests[id] || { pending: false, desired: null }
    request.desired = quantity
    cartQuantityRequests[id] = request
    $('.subtotal.' + id).html('-')
    $('#cart_subtotal, #cart_total_price').html('-')
    processCartQuantity(id)
}

Shopify.removeItem = function (id) {
    const input = document.querySelector('#updates_' + id)
    if (!input) return

    const min = Number(input.getAttribute('min')) || 1
    const queuedQuantity = cartQuantityRequests[id]?.desired
    const quantity = queuedQuantity ?? (Number(input.value) || min)
    if (quantity > min) {
        const nextQuantity = quantity - 1
        $('.nmb.' + id).val(nextQuantity)
        updateCartQuantityControls(id, nextQuantity)
        queueCartQuantity(id, nextQuantity)
    }
}


//Función para agregar productos dentro del carrito y actualizar el precio
//El input de cantidad debe tener el id updates_{{ item.product.id }}
//@param int {{ item.variant.id }} id de la variante del producto
//@param int {{ item.product.id }} id del producto
//onclick="Shopify.addItem({{ item.variant.id }}, {{ item.product.id }})"

Shopify.addItem = function (id) {
    const input = document.querySelector('#updates_' + id)
    if (!input) return

    const queuedQuantity = cartQuantityRequests[id]?.desired
    const currentQuantity = queuedQuantity ?? (Number(input.value) || 0)
    const max = Number($('#max_' + id).attr('max'))
    if (Number.isFinite(max) && currentQuantity >= max) return

    const nextQuantity = currentQuantity + 1
    $('.nmb.' + id).val(nextQuantity)
    updateCartQuantityControls(id, nextQuantity)
    queueCartQuantity(id, nextQuantity)
}

$(function () {
    $('.nmb[id^="updates_"]').each(function () {
        updateCartQuantityControls(this.id.replace('updates_', ''), Number(this.value) || 1)
    })
})

function changeLoginForm() {
    if ($('#login').hasClass('d-none')) {
        $('#login').removeClass('d-none')
        $('#forgot').addClass('d-none')
    } else {
        $('#login').addClass('d-none')
        $('#forgot').removeClass('d-none')
    }
}

Shopify.deleteItem = async function (id, selector) {

    let qty = 0
    await $.ajax({
        method: 'POST',
        url: '/cart/change.js',
        data: { id: id, quantity: qty },
        dataType: 'json'
    }).done(() => {
        jQuery.getJSON('/cart.js', function (cart) {
            console.log('Se borro el item')
            items = cart.items
            $(".item_" + selector).css("display", "none")
            var count = cart.item_count
            items.forEach(function (value) {

                p = (value.final_line_price).toString()
                $("#subtotal_" + value.id).html('MXN $ ' + p.slice(0, -2) + '.' + p.slice(-2))

            });
            p = (cart.items_subtotal_price).toString()
            $("#cart_total_price").html('MXN $ ' + p.slice(0, -2) + '.' + p.slice(-2))
            //console.log(count)
            console.log('delete item llama función')
            if (count == 0) {
                const checkoutButtton = document.querySelector('#tc-button')
                checkoutButtton.style.pointerEvents = 'none'
                checkoutButtton.style.opacity = '0.5'
                window.location.reload(true)
            }
        });
        setComision()
    })
}

function addToComision(id, price) {
    console.log('Cargó la comisión')
    console.log(price)
    let formData;
    formData = {
        'items': [{
            'id': id,
            'quantity': 1
        }]
    };
    $.ajax({
        url: "/cart/add.js",
        dataType: 'json',
        type: 'POST',
        data: formData,
        success: function (itemData) { },
        error: function (XMLHttpRequest) {

        }
    }).done(() => {
        jQuery.getJSON('/cart.js', function (cart) {
            total_cart = parseFloat((cart.items_subtotal_price).toString()) / 100
            total_cart_no_comision = total_cart - price
            console.log(total_cart)
            console.log(price)
            p = (cart.items_subtotal_price).toString()
            $("#cart_total_price").text('MXN ' + Shopify.formatMoney(total_cart_no_comision * 100))
            console.log(total_cart + '-' + price + '=' + total_cart_no_comision)
            $('#cart_subtotal').text('MXN ' + Shopify.formatMoney(total_cart_no_comision * 100))
            $('#cart_comision').text('MXN ' + Shopify.formatMoney(price * 100))


        });
    })
}

function setComision(cartData) {
    var total_cart
    var addComision = true
    var min
    var max
    var total_cart_no_comision
    var price
    const updateComision = function (cart) {
        var commissionPending = false
        total_cart = parseFloat((cart.items_subtotal_price).toString()) / 100
        items = cart.items
        items.forEach(function (value) {
            if (value.product_type == 'Planes') {
                addComision = false
                $('#comision').css('display', 'none')
                $('#cart_subtotal, #cart_total_price').text('MXN ' + Shopify.formatMoney(total_cart * 100))
            }
            if (value.product_type == 'Comisión de Servicio') {
                $('#comision').css('display', 'none')
                console.log(value)
                comision_variants.forEach(function (e) {
                    if (e.id == value.variant_id) {
                        console.log(e.min)
                        min = e.min
                        max = e.max
                    }
                })
                price = parseFloat(value.price / 100)
                total_cart_no_comision = total_cart - price
                console.log('Ya existe comision ' + total_cart_no_comision)
                if (total_cart_no_comision <= max && total_cart_no_comision >= min) {
                    addComision = false
                    console.log('comisión correcta ' + min)
                    $('#cart_subtotal, #cart_total_price').text('MXN ' + Shopify.formatMoney(total_cart_no_comision * 100))
                    $('#cart_comision').text(Shopify.formatMoney(price * 100))
                } else {
                    console.log('Entra a borrar la comision')
                    Shopify.deleteItem(value.variant_id, value.product_id)
                    addComision = false
                }
            }
        });
        console.log(total_cart)
        if (addComision) {
            for (const variant in comision_variants) {
                if (total_cart <= comision_variants[variant].max && total_cart >= comision_variants[variant].min) {
                    price = parseFloat(comision_variants[variant].price)
                    console.log('entra con ' + comision_variants[variant].min)
                    commissionPending = true
                    addToComision(comision_variants[variant].id, price)

                    $('#comision').css('display', 'none')


                }
            }
        }
        if (addComision && !commissionPending) {
            $('#cart_subtotal, #cart_total_price').text('MXN ' + Shopify.formatMoney(total_cart * 100))
        }
        if (total_cart == 0) {
            $('#cart_subtotal, #cart_total_price').text('MXN $0.00')
            $('#comision').css('display', 'none')
        }
    }
    if (cartData) {
        updateComision(cartData)
    } else {
        jQuery.getJSON('/cart.js', updateComision)
    }
    const checkoutButtton = document.querySelector('#tc-button')
    if (checkoutButtton) {
        checkoutButtton.style.pointerEvents = 'all'
        checkoutButtton.style.opacity = '1'
    }
}

var currentCollectionId

function setCurrentCollectionId(id) {
    currentCollectionId = id
    localStorage.setItem('currentEditingCollection', id)
}


function safeElementClickById(id) {
    const element = document.getElementById(id)
    if (element) {
        element.click()
    }
}

async function changeDashboardEvent(id) {
    var url_string = window.location.href;
    var url = new URL(url_string);
    var metafields
    metafields = await getCollectionMetafield(id)

    //console.log('metaifleds de col')
    //console.log(metafields)
    var existMetafield = false
    for (let i = 0; i < metafields.length; i++) {
        if (metafields[i].key == "_funcionalidades_completas_") {
            existMetafield = true
            if (metafields[i].value) {
                $('#tab_Sitio-Web').removeClass('d-none')
            } else {
                $('#tab_Sitio-Web').addClass('d-none')
                var section = url.searchParams.get("section");
                if (section == 'Sitio-Web') {
                    section = 'Resumen'
                }
                setTimeout(function () {
                    safeElementClickById('tab_' + section)
                }, 100);
            }
        }
    }
    if (!existMetafield) {
        $('#tab_Sitio-Web').addClass('d-none')
        var section = url.searchParams.get("section");
        if (section == 'Sitio-Web') {
            section = 'Resumen'
        }
        setTimeout(function () {
            safeElementClickById('tab_' + section)
        }, 100);
    }
    $('.eventCollection').css("display", "none")
    $('.' + id).css("display", "block")
    $('#image-current-event').attr('src', $('#image-' + id).attr('src'))
    $('#title-current-event').text($('#title-' + id).text())
    addVariableToURL('table', id)
    setCurrentCollectionId(id)
}

async function changeCreateTab(tab) {
    var canGoOn = true
    var minLength = true
    var nmb = tab - 1
    var fields = document.getElementsByClassName('cm-field-' + nmb)
    console.log(fields)
    for (let i = 0; i < fields.length; i++) {
        console.log(fields[i].value)
        if (fields[i].value == "" || fields[i].value == null || fields[i].value == undefined) {
            canGoOn = false
        } else {
            if (fields[i].value.length < 3) {
                minLength = false
                canGoOn = false
            }
        }
    }
    if (canGoOn) {
        if (tab == 5) {
            createNewEvent()
            //addNewGiftTable()
        } else {
            if (tab == 4) {
                if (!$('#CM_se_link').val().includes('https://www.google.com/maps/place/') && !$('#CM_se_link').val().includes('https://maps.app.goo.gl/')) {
                    $('#tab-error-' + tab).text('El link de ubicación debe comenzar con "https://www.google.com/maps/place/" o con "https://maps.app.goo.gl/"')
                    $('#tab-' + tab).slideDown()
                } else {
                    safeElementClickById('create_event_tab_' + tab)
                    $('#tab-' + tab).slideUp()
                    const createTab = document.getElementById('create_event_tab_' + tab)
                    if (createTab) {
                        createTab.classList.remove('d-none')
                    }
                }
            } else {
                safeElementClickById('create_event_tab_' + tab)
                $('#tab-' + tab).slideUp()
                const createTab = document.getElementById('create_event_tab_' + tab)
                if (createTab) {
                    createTab.classList.remove('d-none')
                }
            }
        }
    } else {
        if (!minLength) {
            $('#tab-error-' + tab).text('Cada campo debe tener mínimo 3 caracteres')
        } else {
            $('#tab-error-' + tab).text('Completa todos los campos requeridos y verifica que estén bien escritos.')
        }
        $('#tab-' + tab).slideDown()
    }
}

function replaceUrlParam(url, paramName, paramValue) {
    if (paramValue == null) {
        paramValue = '';
    }
    var pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
    if (url.search(pattern) >= 0) {
        return url.replace(pattern, '$1' + paramValue + '$2');
    }
    url = url.replace(/[?#]$/, '');
    return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
}

function addVariableToURL(variable, value) {
    var current_url = window.location.href;
    current_url = replaceUrlParam(current_url, variable, value)
    var origin = window.location.origin;
    current_url = current_url.replace(origin, '')
    window.history.pushState('Account', 'Title', current_url);
    if (variable == 'page') {
        location.reload()
    }
}

function goToAnchor(e, variable, value) {
    addVariableToURL(variable, value)
}

function plus(id) {
    if ($('#qty_' + id).attr('max') != '') {
        if ((parseInt($('#qty_' + id).text()) + 1) <= parseInt($('#qty_' + id).attr('max'))) {
            $('#qty_' + id).text(parseInt($('#qty_' + id).text()) + 1)
        }
    } else {
        $('#qty_' + id).text(parseInt($('#qty_' + id).text()) + 1)
    }
}

function minus(id) {
    if ($('#qty_' + id).text() > 1) {
        $('#qty_' + id).text(parseInt($('#qty_' + id).text()) - 1)
    }
}

async function addToCart(id, qty, product_id, colId, handle) {
    if (qty == 0) {
        qty = $('#qty_' + product_id).text()
    }
    const collectionId = colId == "" ? window.localStorage('collectionId') : colId
    formData = {
        'items': [{
            'id': id,
            'quantity': qty,
            'properties': {
                "collection_id": collectionId,
                "collection_handle": handle,
                "max": parseInt($('#qty_' + product_id).attr('max'))
            }
        }]
    };
    // var data = await getProductData(product_id)
    // $('#atc_image').attr('src', data.data.product.featuredImage.url)
    // $('#atc_brand').text(data.data.product.vendor)
    // $('#atc_title').text(data.data.product.title)
    // $('#atc_price').text(Shopify.formatMoney(parseFloat(data.data.product.priceRangeV2.maxVariantPrice.amount) * 100))
    const currentProductElement = document.querySelector(`[data-product-id="${product_id}"]`)
    const productTitle = currentProductElement.getAttribute('data-product-title')
    const productPrice = currentProductElement.getAttribute('data-product-price')
    const productVendor = currentProductElement.getAttribute('data-product-vendor')
    const productImage = currentProductElement.getAttribute('data-product-image')
    $('#atc_brand').text(productVendor)
    $('#atc_title').text(productTitle)
    $('#atc_price').text(productPrice)
    $('#atc_image').attr('src', productImage)
    $.ajax({
        url: "/cart/add.js",
        dataType: 'json',
        type: 'POST',
        data: formData,
        success: function (itemData) {
            console.log('bien')
            $('.modal-fix.added').css({
                "display": "flex",
                "opacity": "1"
            })
            $('.modal.added').css('opacity', '1')
            jQuery.getJSON('/cart.js', function (cart) {
                var items = cart.items
                var item_count = 0
                items.forEach(function (value) {
                    if (value.product_type != "Comisión de Servicio") {
                        item_count += value.quantity
                    }
                })
                $('#cart_count').text(item_count)
                setTimeout(() => {
                    //location.reload()
                }, 2000)
            });
        },
        error: function (XMLHttpRequest) {
            console.log('mal')
        }
    });

}

function showAddressModal(index) {
    $('.modal-fix.address-' + index).css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.address-' + index).css('opacity', '1')
}

var cen_1 = true

function selectAllProducts(e) {
    if (cen_1) {
        if (e.classList.contains('selected')) {
            $('.product-check').removeClass('w--redirected-checked')
            $('.product-check-input').prop('checked', false);
            cen_1 = false
            e.classList.remove('selected')
            $('#col-products-count').text(0)
        } else {
            $('.product-check').addClass('w--redirected-checked')
            $('.product-check-input').prop('checked', true);
            cen_1 = false
            e.classList.add('selected')
            $('#col-products-count').text($('.product-check-input').length)
        }
    } else {
        cen_1 = true
    }
}




//Funciones para agregar un producto o varios a una mesa

/* 
Si el valor recibido es 0, se agregarán los productos seleccionados
Si el valor recibido es 1, se agregarán todos los productos
Si el valor recibido coincide con el id de un producto, se agregará ese producto
*/
let ATT_product_id

function showAddToTableModal(value) {
    $('#att-form').slideDown()
    $('#att-done').slideUp()
    $('.modal-fix.addToTable').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.addToTable').css('opacity', '1')
    ATT_product_id = value
}

async function addToTable() {
    generalLoader.on()
    $('.loader-msg').text('Agregando productos a tu mesa')
    const errorMessageDiv = document.querySelector('#att-error')
    $('#att-error').slideUp()
    console.log(errorMessageDiv)
    errorMessageDiv.innerHTML = "<div>Hay un error en el formulario, por favor intenta nuevamente.</div>"
    const collection = $('#ATT_collection').val()
    let currentSelection = ATT_product_id
    console.log(collection)
    const checks = document.querySelectorAll('.product-check')
    let products = []
    Array.from(checks).forEach((check) => {
        const productId = check.getAttribute('productid')
        const quantity = document.querySelector(`#qty_${productId}`)
        // console.log(ATT_product_id === parseInt(productId))
        // console.log(ATT_product_id, parseInt(productId))
        if (ATT_product_id === 0) {
            if (check.classList.contains('w--redirected-checked')) {
                products.push({
                    "id": productId,
                    "cuantos": quantity.textContent ?? 1,
                    "recibidos": 0
                })
            }
        } else if (ATT_product_id === 1) {
            products.push({
                "id": productId,
                "cuantos": quantity.textContent ?? 1,
                "recibidos": 0
            })
        } else if (ATT_product_id === parseInt(productId)) {
            products.push({
                "id": productId,
                "cuantos": quantity.textContent ?? 1,
                "recibidos": 0
            })
        }
    })
    if (products.length === 0) {
        errorMessageDiv.innerHTML = '<div>Debes seleccionar al menos 1 regalo para agregar</div>'
        $('#att-error').slideDown()
        generalLoader.off()
        return
    }
    const url = `https://api-zepika.panorama.works/public/api/v2/dashboard/gifts/add-selected-gifts`
    const body = {
        "collection_id": collection,
        "products": products
    }
    const response = await fetchData(url, 'POST', body)
    if (!response.status) {
        errorMessageDiv.innerHTML = '<div>Ha ocurrido un error al agregar tu productos, intenta más tarde</div>'
        $('#att-error').slideDown()
        generalLoader.off()
        return
    }
    $('.btd').attr('href', '/account?Dashboard=1&table=' + collection)
    $('#att-form').slideUp()
    $('#att-done').slideDown()
    generalLoader.off()
    return

    var repited = false
    var saved_products = []
    var productId
    var qty
    var price
    var productsArray = []
    var metafields = await getCollectionMetafield(collection)
    console.log(metafields)
    metafields.forEach(metafield => {
        if (metafield.key == 'productos') {
            saved_products = JSON.parse(metafield.value)
            if (saved_products.length > 0) {
                if (saved_products[0] == null) {
                    saved_products = []
                }
            }
        }
    })
    console.log(saved_products)
    if (ATT_product_id == 0) {

        for (let j = 0; j < checks.length; j++) {
            if (checks[j].classList.contains('w--redirected-checked')) {
                productId = checks[j].getAttribute('productId')
                repited = false
                for (const i in saved_products) {
                    if (saved_products[i].id == productId) {
                        repited = true
                    }
                }
                if (!repited) {
                    if (saved_products.length < 1000) {
                        qty = $('#qty_' + productId).text()
                        if (qty == 0 || qty == '0') { qty == '1' }
                        saved_products.push({
                            "id": productId,
                            "cuantos": qty,
                            "recibidos": 0
                        })
                        products.push("gid://shopify/Product/" + productId)
                        if (products.length == 250) {
                            await addProductsToCollection(collection, products)
                            products = []
                        }
                    } else {
                        $('#limitMessage').removeClass('d-none')
                        $('#limitOk').addClass('d-none')
                    }
                }
            }
        }
        await addProductsToCollection(collection, products)
        var data = { "key": "productos", "value": JSON.stringify(saved_products), "type": "json", "namespace": "custom" }
        await addCollectionMetafield(collection, data)
    } else {
        if (ATT_product_id == 1) {

            for (let j = 0; j < checks.length; j++) {
                productId = checks[j].getAttribute('productId')
                repited = false
                for (const i in saved_products) {
                    if (saved_products[i].id == productId) {
                        repited = true
                    }
                }
                if (!repited) {
                    if (saved_products.length < 1000) {
                        qty = $('#qty_' + productId).text()
                        if (qty == 0 || qty == '0') { qty == '1' }
                        saved_products.push({
                            "id": productId,
                            "cuantos": qty,
                            "recibidos": 0
                        })
                        products.push("gid://shopify/Product/" + productId)
                        if (products.length == 250) {
                            await addProductsToCollection(collection, products)
                            products = []
                        }
                    } else {
                        $('#limitMessage').removeClass('d-none')
                        $('#limitOk').addClass('d-none')
                    }
                }
            }
            await addProductsToCollection(collection, products)
            var data = { "key": "productos", "value": JSON.stringify(saved_products), "type": "json", "namespace": "custom" }
            await addCollectionMetafield(collection, data)
        } else {
            for (const i in saved_products) {
                if (saved_products[i].id == ATT_product_id) {
                    repited = true
                }
            }
            if (!repited) {
                if (saved_products.length < 1000) {
                    qty = $('#qty_' + ATT_product_id).text()
                    if (qty == 0 || qty == '0') { qty == '1' }
                    saved_products.push({
                        "id": ATT_product_id,
                        "cuantos": qty,
                        "recibidos": 0
                    })
                    products.push("gid://shopify/Product/" + ATT_product_id)
                    await addProductsToCollection(collection, products)
                    var data = { "key": "productos", "value": JSON.stringify(saved_products), "type": "json", "namespace": "custom" }
                    await addCollectionMetafield(collection, data);
                } else {
                    $('#limitMessage').removeClass('d-none')
                    $('#limitOk').addClass('d-none')
                }
            }
        }
    }
    setTimeout(() => {
        $('.btd').attr('href', '/account?Dashboard=1&table=' + collection)
        $('#att-form').slideUp()
        $('#att-done').slideDown()
        generalLoader.off()
    }, 1500)
}


let replicarMesaColId

function showreplicarModal(value) {
    $('#replicar-form').slideDown()
    $('#replicar-done').slideUp()
    $('.modal-fix.replicar').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.replicar').css('opacity', '1')
    replicarMesaColId = value
}


async function replicarMesa() {
    generalLoader.on()
    $('.loader-msg').text('Agregando productos a tu mesa')
    const modalTitle = document.querySelector('#replicar-done h2')
    modalTitle.innerHTML = "productos agregados exitosamente"
    const mesaId = $('#replicar_collection').val()
    const url = `https://api-zepika.panorama.works/public/api/v2/dashboard/gifts/replicate-in-table`
    const body = {
        "collection_target": parseInt(mesaId),
        "collection_origin": parseInt(replicarMesaColId)
    }
    const response = await fetchData(url, 'POST', body)
    //const response = { "status": true, "message": "Products added successfully" }
    if (!response.status) {
        $('#replicar-form').slideUp()
        $('#replicar-done').slideDown()
        modalTitle.innerHTML = "Ha ocurrido un error, por favor intenta más tarde"
        generalLoader.off()
        return
    }
    $('#replicar-form').slideUp()
    $('#replicar-done').slideDown()
    generalLoader.off()
    return
    var saved_products = []
    var objectData
    var productsArray = []
    var products = []

    var metafields = await getCollectionMetafield(mesaId)
    console.log(metafields)
    metafields.forEach(metafield => {
        if (metafield.key == 'productos') {
            saved_products = JSON.parse(metafield.value)
            if (saved_products.length > 0) {
                if (saved_products[0] == null) {
                    saved_products = []
                }
            }
        }
    })
    var colProducts = await getCollectionProducts(replicarMesaColId)
    colProducts = colProducts.data.collection.products.edges
    for (let j = 0; j < colProducts.length; j++) {
        var productId = colProducts[j].node.id
        var repited = false
        for (const i in saved_products) {
            if (saved_products[i].id == productId.replace('gid://shopify/Product/', '')) {
                repited = true
                break
            }
        }
        if (!repited) {
            saved_products.push({
                "id": productId.replace('gid://shopify/Product/', ''),
                "cuantos": 1,
                "recibidos": 0
            })
            products.push(productId)
        }
    }
    addProductsToCollection(mesaId, products)
    var data = { "key": "productos", "value": JSON.stringify(saved_products), "type": "json", "namespace": "custom" }
    addCollectionMetafield(mesaId, data)
    $('#replicar-form').slideUp()
    $('#replicar-done').slideDown()
    generalLoader.off()
}


/*Funciones para crear un producto*/
var CP_collection_id

function showCreateProductModal(value) {
    $('#CP_done').slideUp()
    $('#CP_form').slideDown()
    $('#CP_error').slideUp()
    $('.modal-fix.createProduct').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.createProduct').css('opacity', '1')
    CP_collection_id = value
}
var base64Image
const input = document.getElementById('product_imagen');
if (input) {
    input.addEventListener('change', async function () {
        const file = this.files[0];
        const reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onload = async function () {
            base64Image = reader.result.split(',')[1];
        }
    });
}

const imageToBase64 = async (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = error => reject(error);
    });
}

async function createProduct() {
    generalLoader.on()
    $('.loader-msg').text('Creando producto')
    $('#CP_error').slideUp()
    $('#CP_error').html('<div>Por favor, completa todos los campos.</div>')
    const title = $('#CP_name').val()
    const type = $('#prodctTypeSelection').text().trim().replace(/\n/g, '')
    const description = $('#CP_description').val()
    const price = $('#CP_price').val()
    const want = $('#CP_want').val()
    const inputImage = document.getElementById('product_imagen').files
    const base64Image = inputImage.length > 0 ? await imageToBase64(inputImage[0]) : ''

    if (title != '' && type != 'Categoría del Producto' && description.trim() != '' && price != '' && want != '' && want > 0 && base64Image != '' && base64Image != undefined && description.length > 3) {
        const payload = {
            "title": title,
            "body_html": description.trim(),
            "product_type": type,
            "price": price,
            "image": base64Image,
            "collection_id": CP_collection_id.toString(),
            "quantity": want
        }
        const product = await fetch('https://api-zepika.panorama.works/public/api/v1/products/create-new-product', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        })
        const productData = await product.json()
        console.log(productData)
        if (productData.status === false) {
            const errorMessageDiv = document.querySelector('#CP_error')
            const { data } = productData
            if (data?.body_html) {
                const [error] = data.body_html
                const errorTranslate = error === 'The body html field is required.' ? 'La descripción del producto no puede estar vacia' : error
                errorMessageDiv.innerHTML = `<div>${errorTranslate}</div>`
            }
            if (data?.price) {
                const [error] = data.price
                const errorTranslate = error === 'The price field must be at least 3 characters.' ? 'El precio debe tener al menos 3 caracteres' : error
                errorMessageDiv.innerHTML = `<div>${errorTranslate}</div>`

            }
            generalLoader.off()
            $('#CP_error').slideDown()
            return
        }
        if (productData.status) {
            $('#CP_done').slideDown()
            $('#CP_form').slideUp()
            $('#CP_error').slideUp()
            generalLoader.off()
            setTimeout(() => {
                location.reload()
            }, 1500)
            return
        }

    }
    $('#CP_error').slideDown()
    generalLoader.off()
}
// async function createProduct() {
//     generalLoader.on()
//     $('.loader-msg').text('Creando producto')
//     const title = $('#CP_name').val()
//     const type = $('#prodctTypeSelection').text()
//     const description = $('#CP_description').val()
//     const price = $('#CP_price').val()
//     const want = $('#CP_want').val()
//     let product
//     let saved_products
//     const products = []
//     if (title != '' && type != '' && description != '' && price != '' && want != '' && want > 0 && base64Image != '' && base64Image != undefined) {
//         const payload = {
//             "title": title,
//             "description": description,
//             "type": type,
//             "price": price,
//             "base64Image": base64Image,
//             "CP_collection_id": CP_collection_id,
//             "want": want
//         }
//         console.log(payload)
//         //product = await createNewProduct(title, description, type, price, base64Image, CP_collection_id, want)
//         $('#CP_done').slideDown()
//         $('#CP_form').slideUp()
//         $('#CP_error').slideUp()
//         // setTimeout(() => {
//         //     // location.reload()
//         //     generalLoader.off()
//         // }, 3000)
//     } else {
//         $('#CP_error').slideDown()
//         // generalLoader.off()
//     }
// }

async function changeProductmodality(value, orderId, prodId) {
    $('.' + orderId + '' + prodId).removeClass('w--redirected-checked')
    $('#' + value + '_' + orderId + '' + prodId).addClass('w--redirected-checked')
    var order = await getOrderData('gid://shopify/Order/' + orderId)
    for (const metafield of order.data.node.metafields.edges) {
        if (metafield.node.key == 'informaci_n_de_productos') {
            var note = JSON.parse(metafield.node.value)
        }
    }
    note.forEach(product => {
        if (product.id == prodId) {
            product.modalidad = value
        }
    })
    addOrdernMetafield(orderId, { "key": "informaci_n_de_productos", "value": JSON.stringify(note), "type": "json", "namespace": "custom" })
}

/* Funciones para crear un evento/collection */

/*
  metafields = {"namespace": "custom","key": "objetos_de_invitacion","type": "list.metaobject_reference","value": "[\""+collectionObjects[0]+"\",\""+collectionObjects[1]+"\",\""+collectionObjects[2]+"\"]"}
  addCollectionMetafield(collectionId,metafields)
*/


var guests = []
var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

function addGuest() {
    if ($('#CM_guest_name').val() != '' && $('#CM_guest_last_name').val() != '' && $('#CM_guest_email').val() != '') {
        if (emailRegex.test($('#CM_guest_email').val())) {
            $('#tab-2').slideUp()
            guests.push({ "name": $('#CM_guest_name').val(), "lastname": $('#CM_guest_last_name').val(), "email": $('#CM_guest_email').val(), "admin": $('#CM_guest_admin').prop("checked") })
            console.log(guests)
            $('#CM_guest_name').val('')
            $('#CM_guest_last_name').val('')
            $('#CM_guest_email').val('')
            $('#CM_guest_dad').val('')
            $('#CM_guest_mom').val('')
            $('#CM_guest_admin').prop("checked", false);
        } else {
            $('#tab-error-2').text('El correo debe ser válido.')
            $('#tab-2').slideDown()
        }
    } else {
        $('#tab-error-2').text('Completa todos los campos.')
        $('#tab-2').slideDown()
    }
}

var subEvents = []
var subEventCount = 0

function addEventSubEvent() {
    if (!$('#CM_se_link').val().includes('https://www.google.com/maps/place/') && !$('#CM_se_link').val().includes('https://maps.app.goo.gl/')) {
        $('#tab-error-4').text('El link de ubicación debe comenzar con "https://www.google.com/maps/place/" o con "https://maps.app.goo.gl/"')
        $('#tab-4').slideDown()
    } else {
        var date = $('#CM_se_date').val() + ':00'
        date = date.split(' ')
        date = date[0].split('-')[2] + '-' + date[0].split('-')[1] + '-' + date[0].split('-')[0] + 'T' + date[1]
        var hour = (parseInt(date.substring(11, 13)) + 6)
        var formatedDate = date.substring(0, 10)
        if (hour < 0) {
            hour = 24 + hour
            formatedDate = restarUnDia(date.substring(0, 10))
        }
        if (hour >= 24) {
            hour = hour - 24
            formatedDate = sumarUnDia(date.substring(0, 10))
        }
        if (hour < 10) {
            hour = '0' + hour
        }
        formatedDate = formatedDate + 'T'
        date = formatedDate + hour + date.substring(13)
        if (date.length < 19) {
            date = date + ':00'
        }
        console.log('la hora después ' + date)
        subEvents.push({ "id": subEventCount, "Nombre": $('#CM_se_name').val(), "Fecha": date, "Lugar": $('#CM_se_place').val(), "Link": $('#CM_se_link').val(), "Vestimenta": $('#CM_se_outfit').val(), "requiere": $('#CM_se_invitacion').prop("checked") })
        $('#CM_se_name').val('')
        $('#CM_se_date').val('')
        $('#CM_se_place').val('')
        $('#CM_se_link').val('')
        $('#CM_se_outfit').val('')
        subEventCount++
    }
}

function base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}

async function createNewEvent() {
    let loaderShouldStayOn = true
    let tableImageUploadError = null

    try {
        const tableImageFile = getSelectedTableImageFile()
        generalLoader.on()
        $('.loader-msg').text('Creando mesa de regalos')
        //Agregar al último invitado
    if ($('#CM_guest_name').val() != '' && $('#CM_guest_last_name').val() != '' && $('#CM_guest_email').val() != '' && emailRegex.test($('#CM_guest_email').val())) {
        guests.push({ "name": $('#CM_guest_name').val().replaceAll("'", ""), "lastname": $('#CM_guest_last_name').val().replaceAll("'", ""), "email": $('#CM_guest_email').val(), "admin": $('#CM_guest_admin').prop("checked") })
    }
    //Agregar el último sub-evento
    if ($('#CM_se_name').val() != '') {
        var date = $('#CM_se_date').val() + ':00'
        date = date.split(' ')
        date = date[0].split('-')[2] + '-' + date[0].split('-')[1] + '-' + date[0].split('-')[0] + 'T' + date[1]
        var hour = (parseInt(date.substring(11, 13)) + 6)
        var formatedDate = date.substring(0, 10)
        if (hour < 0) {
            hour = 24 + hour
            formatedDate = restarUnDia(date.substring(0, 10))
        }
        if (hour >= 24) {
            hour = hour - 24
            formatedDate = sumarUnDia(date.substring(0, 10))
        }
        if (hour < 10) {
            hour = '0' + hour
        }
        formatedDate = formatedDate + 'T'
        date = formatedDate + hour + date.substring(13)
        if (date.length < 19) {
            date = date + ':00'
        }
        console.log('la hora después ' + date)
        subEvents.push({ "id": subEventCount, "Nombre": $('#CM_se_name').val(), "Fecha": date, "Lugar": $('#CM_se_place').val(), "Link": $('#CM_se_link').val(), "Vestimenta": $('#CM_se_outfit').val(), "requiere": $('#CM_se_invitacion').prop("checked") })
    }
    console.log('subevents')
    console.log(subEvents)
    $('#CM_error_list').empty()
    //Variables del evento
    var name = $('#event-name')
    var type = $('#event-type')
    var plan = $('#event-plan')
    var mainDate = $('#mainEventDate').val()
    var partes = mainDate.split('-'); // dividimos la fecha en sus partes
    var mainDateForm = partes[2] + '-' + partes[1] + '-' + partes[0];
    //Variables del banco
    var banco_titular = $('#cm-banco-titular')
    var banco_banco = $('#cm-banco-banco')
    var banco_cuenta = $('#cm-banco-cuenta')
    var banco_clabe = $('#cm-banco-clabe')
    //Variables de la dirección
    var address_name = normalizeAddressValue($('#CM_forname-new').val())
    var address_last_name = normalizeAddressValue($('#CM_surname-new').val())
    var address_address1 = normalizeAddressValue($('#CM_address1--new').val())
    var address_colonia = normalizeAddressValue($('#CM_address2--new').val())
    var address_postcode = normalizeAddressValue($('#CM_postcode-new').val())
    var address_city = normalizeAddressValue($('#CM_city-new').val())
    var address_country = normalizeAddressValue($('#CM_country-new').val())
    var address_province = normalizeAddressValue($('#CM_province-new').val())
    var address_tel = normalizeAddressValue($('#CM_phone-new').val())
    var address_id = $('#address_id').attr('addressId')
    var addressMetaObject = await createGeneralMetaobject({ "type": "direccion_de_envio", "fields": [{ "key": "nombre_de_quien_recibe", "value": [address_name, address_last_name].filter(Boolean).join(' ') }, { "key": "calle_y_numeros", "value": address_address1 }, { "key": "colonia", "value": address_colonia }, { "key": "codigo_postal", "value": address_postcode }, { "key": "alcaldia_o_municipio", "value": address_city }, { "key": "estado", "value": address_province }, { "key": "telefono", "value": address_tel }, { "key": "pais", "value": address_country }] })
    //Variables para los invitados
    var newUser
    //Variables secundarias
    var customer_id = $('#user_id').attr('userId')
    var email = $('#user_id').attr('email')
    var customerName = $('#user_id').attr('name')
    //,address_name,address_last_name,address_address1,address_address2,address_postcode,address_city,address_country,address_province,address_tel
    var metafields_data = [type]
    var customer_metafields
    var metafields = []
    var empty_fields = []
    var incomplete_fields = false
    var saved_events = []
    var saved_tables = []
    var custom_collection
    var subEvents_metafields = []
    var festejados_ids = []
    var festejados_names = []
    festejados_names.push(customerName.replaceAll("'", ""))
    metafields_data.forEach(metafield => {
        metafields.push({ "key": metafield.attr('metafieldKey'), "value": metafield.attr('metafieldType') == 'date_time' ? metafield.val().replace(' ', 'T') + ':00' : metafield.val(), "type": metafield.attr('metafieldType'), "namespace": "custom" })
    })
    metafields.push({ "key": "status_de_mesa", "value": true, "type": "boolean", "namespace": "custom" })
    metafields.push({ "key": "fecha_del_evento", "value": mainDateForm, "type": "date", "namespace": "custom" })
    metafields.push({ "key": "productos", "value": JSON.stringify([null]), "type": "json", "namespace": "custom" })
    metafields.push({ "key": "direcci_n_de_env_o", "value": addressMetaObject, "type": "metaobject_reference", "namespace": "custom" })
    console.log(metafields)

    custom_collection = await createCustomCollection(name.val(), metafields)
    if (tableImageFile) {
        try {
            await updateCollImage(custom_collection.id, tableImageFile)
        } catch (error) {
            console.error('La mesa se creó, pero no se pudo cargar su imagen:', error)
            tableImageUploadError = error
        }
    }
    //subEvents.push({"id":subEventCount,"Nombre":$('#CM_se_name').val(),"Fecha":$('#CM_se_date').val().replace(' ','T')+':00',"Lugar":$('#CM_se_place').val(),"Link":$('#CM_se_link').val(),"Vestimenta":$('#CM_se_outfit').val(),"Descripcion":$('#CM_se_description').val()})
    console.log(subEvents)
    var iCount = 0
    for (const subEvent in subEvents) {
        var se_ubicacion = await createEventUbication(subEvents[subEvent].Lugar, subEvents[subEvent].Link)
        if (iCount == 0) {
            saved_events.push(await createCollectionEvents(subEvents[subEvent].Nombre, 'Principal', subEvents[subEvent].Fecha, '', '', subEvents[subEvent].Vestimenta, se_ubicacion, subEvents[subEvent].requiere))
        } else {
            saved_events.push(await createCollectionEvents(subEvents[subEvent].Nombre, 'Secundario', subEvents[subEvent].Fecha, '', '', subEvents[subEvent].Vestimenta, se_ubicacion, subEvents[subEvent].requiere))
        }
        iCount++
    }
    console.log(saved_events)
    await addCollectionMetafield(custom_collection.id, { "namespace": "custom", "key": "eventos", "type": "list.metaobject_reference", "value": JSON.stringify(saved_events) })
    var retiros
    var planData = await getOrderData('gid://shopify/Order/' + plan.val())
    var planTitle = planData.data.node.lineItems.edges[0].node.product.title
    console.log(planTitle)
    if (planTitle == "Básico") {
        await addCollectionMetafield(custom_collection.id, { "key": "_funcionalidades_completas_", "value": false, "type": "boolean", "namespace": "custom" })
        retiros = 3
    }
    if (planTitle == "Premium") {
        await addCollectionMetafield(custom_collection.id, { "key": "_funcionalidades_completas_", "value": true, "type": "boolean", "namespace": "custom" })
        retiros = 5
    }
    if (planTitle == "Mixto") {
        await addCollectionMetafield(custom_collection.id, { "key": "_funcionalidades_completas_", "value": false, "type": "boolean", "namespace": "custom" })
        retiros = 0
    }
    if (planTitle == "Comisión 3%") {
        await addCollectionMetafield(custom_collection.id, { "key": "_funcionalidades_completas_", "value": false, "type": "boolean", "namespace": "custom" })
        retiros = 3
    }
    if (planTitle != "Mixto") {
        var retirosArray = []
        for (let j = 0; j < retiros; j++) {
            var data = { "type": "mesa_de_regalos_retiros", "fields": [] }
            retirosArray.push(await createGeneralMetaobject(data))
        }
        await addCollectionMetafield(custom_collection.id, { "namespace": "custom", "key": "mesa_de_regalos_retiros", "type": "list.metaobject_reference", "value": JSON.stringify(retirosArray) })
    }
    var pageMetafields = []
    pageMetafields.push({ "namespace": "custom", "key": "collection", "type": "collection_reference", "value": 'gid://shopify/Collection/' + custom_collection.id })
    pageMetafields.push({ "namespace": "custom", "key": "tipo_de_p_gina", "type": "single_line_text_field", "value": 'Wedsite' })
    var pagina = await createTableHomePage(custom_collection.title + ' Home')
    pageMetafields.push({ "namespace": "custom", "key": "wedsite_p_ginas", "type": "list.metaobject_reference", "value": JSON.stringify([pagina]) })


    var invitacion = await createInvitationPage(JSON.stringify(saved_events))
    pageMetafields.push({ "namespace": "custom", "key": "wedsite_invitaciones", "type": "list.metaobject_reference", "value": JSON.stringify([invitacion]) })

    var styles = await createTableStyles()
    pageMetafields.push({ "namespace": "custom", "key": "wedsite_dise_o", "type": "metaobject_reference", "value": styles })
    var styles2 = await createTableStyles()
    pageMetafields.push({ "namespace": "custom", "key": "invitaci_n_dise_o", "type": "metaobject_reference", "value": styles2 })
    var page = await createPage(custom_collection.title, pageMetafields)
    await addCollectionMetafield(custom_collection.id, { "namespace": "custom", "key": "mesa_de_regales_p_gina", "type": "page_reference", "value": 'gid://shopify/OnlineStorePage/' + page.id })
    customer_metafields = await getCustomerMetafield(customer_id)
    var saved_bankData = []
    var mainCustomerEvents = []
    if (customer_metafields.length > 0) {
        customer_metafields.forEach(metafield => {
            if (metafield.key == "mis_mesas") {
                saved_tables = JSON.parse(metafield.value)
            }
            if (metafield.key == "mis_eventos") {
                mainCustomerEvents = JSON.parse(metafield.value)
            }
            if (metafield.key == "datos_bancarios") {
                saved_bankData = JSON.parse(metafield.value)
            }
        })
    }
    for (let i = 0; i < saved_events.length; i++) {
        mainCustomerEvents.push(await createGuestInvitationObject(saved_events[i], 'Confirmado', $('#mcName').attr('name'), 'Familia', 1, 1))
    }

    var table_reference = await createTableReference("gid://shopify/Collection/" + custom_collection.id, 'Administrador')
    var bank_reference = await createBankData(banco_titular.val(), banco_clabe.val(), banco_banco.val(), banco_cuenta.val())
    saved_tables.push(table_reference)
    console.log(table_reference)
    var customerData = await getCustomerData("gid://shopify/Customer/" + customer_id)
    var customerTags = customerData.data.customer.tags
    customerTags.push(custom_collection.id + "-admin")
    customerTags.push(custom_collection.id + "-i")
    await addCollectionMetafield(custom_collection.id, { "key": "datos_bancarios", "value": bank_reference, "type": "metaobject_reference", "namespace": "custom" })
    await updateCustomerTag("gid://shopify/Customer/" + customer_id, customerTags)
    await addCustomerMetafield(customer_id, { "key": "mis_mesas", "value": JSON.stringify(saved_tables), "type": "list.metaobject_reference", "namespace": "custom" })
    await addCustomerMetafield(customer_id, { "key": "mis_eventos", "value": JSON.stringify(mainCustomerEvents), "type": "list.metaobject_reference", "namespace": "custom" })
    //await updateCustomerAddress(address_id,customer_id,address_name.val(),address_last_name.val(),address_address1.val(),address_address2.val(),address_postcode.val(),address_city.val(),address_country.val(),address_province.val(),address_tel.val())
    console.log(guests)
    var celebrated_count = 0
    for (const guest of guests) {
        var active
        console.log(guest)
        var newUser_metafields = []
        if (guest.name != '' && guest.email != '' && guest.lastname != '') {
            if (guest.admin) {
                newUser_metafields.push({ "namespace": "custom", "key": "mis_mesas", "type": "list.metaobject_reference", "value": JSON.stringify([table_reference]) })
                tag = '-admin'
            } else {
                if (celebrated_count == 0) {
                    var celebrated_reference = await createTableReference("gid://shopify/Collection/" + custom_collection.id, 'Festejado')
                }
                newUser_metafields.push({ "namespace": "custom", "key": "mis_mesas", "type": "list.metaobject_reference", "value": JSON.stringify([celebrated_reference]) })
                celebrated_count++
                tag = '-f'
            }
            var eventsObjects = []
            for (let i = 0; i < saved_events.length; i++) {
                eventsObjects.push(await createGuestInvitationObject(saved_events[i], 'Confirmado', $('#mcName').attr('name'), 'Familia', 1, 1))
            }
            newUser_metafields.push({ "namespace": "custom", "key": "mis_eventos", "type": "list.metaobject_reference", "value": JSON.stringify(eventsObjects) })
            await verifyCustomer(guest.email, guest.name.replaceAll("'", ""), guest.lastname.replaceAll("'", "")).then(async function (newUser) {
                if (newUser.status) {
                    var hasMetafield = false
                    var hasMetafield2 = false
                    var metafieldValue
                    var metafieldValue2
                    var CustomerId
                    var newTags = []
                    var cId = await getCustomerData(newUser.customer.id)
                    console.log(cId)
                    active = false
                    CustomerId = 'gid://shopify/Customer/' + cId.data.customer.legacyResourceId
                    mainId = 'gid://shopify/Customer/' + cId.data.customer.legacyResourceId
                    if (cId.data.customer.tags.length > 0) {
                        newTags = cId.data.customer.tags
                    }
                    newTags.push(custom_collection.id + tag)
                    newTags.push(custom_collection.id + '-i')
                    await updateCustomerTag(CustomerId, newTags)
                    if (cId.data.customer.metafields.edges.length > 0) {
                        for (metafield of cId.data.customer.metafields.edges) {
                            if (metafield.node.key == "mis_mesas") {
                                hasMetafield = true
                                metafieldValue = JSON.parse(metafield.node.value)
                            }
                            if (metafield.node.key == "mis_eventos") {
                                hasMetafield2 = true
                                metafieldValue2 = JSON.parse(metafield.node.value)
                            }
                        }
                    }
                    if (hasMetafield) {
                        data = JSON.parse(newUser_metafields[0].value)
                        for (let i = 0; i < metafieldValue.length; i++) {
                            data.push(metafieldValue[i])
                        }
                        await addCustomerMetafield(cId.data.customer.legacyResourceId, { "namespace": "custom", "key": "mis_mesas", "type": "list.metaobject_reference", "value": JSON.stringify(data) })
                    } else {
                        console.log(newUser_metafields)
                        await addCustomerMetafield(cId.data.customer.legacyResourceId, { "namespace": "custom", "key": "mis_mesas", "type": "list.metaobject_reference", "value": newUser_metafields[0].value })
                    }
                    if (hasMetafield2) {
                        data = JSON.parse(newUser_metafields[1].value)
                        for (let i = 0; i < metafieldValue2.length; i++) {
                            data.push(metafieldValue2[i])
                        }
                        await addCustomerMetafield(cId.data.customer.legacyResourceId, { "namespace": "custom", "key": "mis_eventos", "type": "list.metaobject_reference", "value": JSON.stringify(data) })
                    } else {
                        console.log(newUser_metafields)
                        await addCustomerMetafield(cId.data.customer.legacyResourceId, { "namespace": "custom", "key": "mis_eventos", "type": "list.metaobject_reference", "value": newUser_metafields[1].value })
                    }
                    sendEmail(guest.email, custom_collection.title, mainId, active, guest.name.replaceAll("'", "") + ' ' + guest.lastname.replaceAll("'", ""), $('#mcName').attr('name'))
                    festejados_names.push(guest.name.replaceAll("'", "") + ' ' + guest.lastname.replaceAll("'", ""))
                }
            })
        }
    }
    await addCollectionMetafield(custom_collection.id, { "namespace": "custom", "key": "festejados", "type": "list.single_line_text_field", "value": JSON.stringify(festejados_names) })
    addOrdernMetafield(plan.val(), { "namespace": "custom", "key": "mesa_de_regalos", "type": "collection_reference", "value": "gid://shopify/Collection/" + custom_collection.id })
    $('#CM_error').css('display', 'none')
    const imageWarning = document.getElementById('CM_image_upload_warning')
    if (imageWarning) {
        imageWarning.textContent = tableImageUploadError
            ? 'La mesa se creó, pero no se pudo cargar la imagen. Podrás intentar cambiarla desde tu Dashboard.'
            : ''
        imageWarning.hidden = !tableImageUploadError
    }
    $('#cm_general_Container').slideUp()
    $('#CM_done').slideDown()
    loaderShouldStayOn = false
    setTimeout(() => {
        location.reload()
        if (typeof generalLoader !== 'undefined') {
            generalLoader.off()
        }
    }, 10000)
    } catch (error) {
        console.error('Error al crear la mesa:', error)
        $('#CM_error').text('Hubo un problema al crear la mesa. Revisa tu conexión e intenta de nuevo.')
        $('#CM_error').css('display', 'block')
    } finally {
        if (loaderShouldStayOn && typeof generalLoader !== 'undefined') {
            generalLoader.off()
        }
    }
}




function parseDate(dateString) {
    var tokens = dateString.split(/[-: ]/g).slice(0, 6).map(function (token) { return parseInt(token, 10); });
    tokens[1] -= 1; // Subtract 1 from month.
    return newInstance(Date, tokens);
}

function formatDate(date) {
    function pad(val, pattern) { return (pattern + val).substr(-pattern.length); }
    return date.getFullYear() + '-' + pad(date.getMonth() + 1, '00') + '-' + pad(date.getDate(), '00') + ' ' +
        pad(date.getHours(), '00') + ':' + pad(date.getMinutes(), '00') + ':' + pad(date.getSeconds(), '00');
}

function localDateToUTC(localDate) {
    return new Date(localDate.getUTCFullYear(), localDate.getUTCMonth(), localDate.getUTCDate(),
        localDate.getUTCHours(), localDate.getUTCMinutes(), localDate.getUTCSeconds());
}

function newInstance(clazz, arguments, scope) {
    return new (Function.prototype.bind.apply(clazz, [scope].concat(arguments)));
}


/* Funciones para modificar la información en el tab de configuración */
var subEventsCollection
var subEventsId
var subEventElement

function showEventModal(colId, eventNmb, e, funcionalidades, event_id) {
    console.log(eventNmb)
    $('#editEventDone').slideUp()
    $('#editEventFail').slideUp()
    $('#editEventForm').slideDown()
    if (!funcionalidades) {
        $('#checkEditEvent').addClass('d-none')
    }
    $('.modal-fix.editEvent').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.editEvent').css('opacity', '1')
    subEventElement = e
    if (eventNmb == 999) {
        $('#mde_name').addClass('d-none')
    } else {
        $('#mde_name').removeClass('d-none')
    }
    var name = $('#se_name_' + colId + "" + eventNmb).text()
    console.log('name' + $('#se_name_' + colId + "" + eventNmb).text())
    var description = $('#se_description_' + colId + "" + eventNmb).text()
    var outfit = $('#se_outfit_' + colId + "" + eventNmb).text()
    var place = $('#se_place_' + colId + "" + eventNmb).text()
    var link = $('#se_link_' + colId + "" + eventNmb).text()
    var date = $('#se_date_' + colId + "" + eventNmb).attr('date')


    var onlyDate = date.split("T")[0]
    var onlyHour = date.split("T")[1]
    var onlyHour = onlyHour.split("+")[0]
    var formattedHour = onlyHour.split(":")[0]
    formattedHour = formattedHour - 6

    console.log('formattedHour: ' + formattedHour)

    if (formattedHour >= 0 & formattedHour < 10) {
        formattedHour = formattedHour.toString().padStart(2, 0)
    }

    console.log('formattedHour2.0: ' + formattedHour)

    var formattedDate = onlyDate + " " + formattedHour + ":" + onlyHour.split(":")[1]

    console.log('DATE FORMATTED: ' + formattedDate)
    console.log("DATE ORIGINAL: " + $('#se_date_' + colId + "" + eventNmb).attr('date'));
    var inv = $('#se_invitacion_' + colId + "" + eventNmb).text().trim()
    $('#mde_name').val(name.trim())
    $('#mde_description').val(description.trim())
    $('#mde_place').val(place.trim())
    $('#mde_outfit').val(outfit.trim())
    $('#mde_link').val(link.trim())
    $('#mde_date').val(formattedDate.trim())
    $('#mde_event_id').val(event_id)
    console.log(inv)
    if (inv == "Sí") {
        $("#mde_invitacion").prop("checked", true);
    } else {
        $("#mde_invitacion").prop("checked", false);
    }
    subEventsCollection = colId
    subEventsId = eventNmb
}

function sumarUnDia(fecha) {
    let nuevaFecha = new Date(fecha);
    nuevaFecha.setDate(nuevaFecha.getDate() + 1);
    return nuevaFecha.toISOString().split('T')[0]; // Formato YYYY-MM-DD
}

// Función para restar un día a la fecha
function restarUnDia(fecha) {
    let nuevaFecha = new Date(fecha);
    nuevaFecha.setDate(nuevaFecha.getDate() - 1);
    return nuevaFecha.toISOString().split('T')[0]; // Formato YYYY-MM-DD
}

function isValidGoogleMapsURL(url) {
    return url.startsWith("https://maps");
}

async function updateSubEvent(event) {
    event.preventDefault();
    generalLoader.on()
    $('.loader-msg').text('Actualizando evento.')

    var link = $('#mde_link').val().trim();

    if ($('#mde_place').val().trim() === "" ||
        link === "" ||
        $('#mde_name').val().trim() === "" ||
        $('#mde_date').val().trim() === "" ||
        $('#mde_description').val().trim() === "" ||
        $('#mde_outfit').val().trim() === "") {

        $('#editEventFail').text("Por favor, llena todos los campos").slideDown();
        generalLoader.off();
        return;
    }

    if (!isValidGoogleMapsURL(link)) {
        $('#editEventFail').text("El campo 'Link a Google Maps' debe ser un link de Google Maps válido").slideDown();
        generalLoader.off();
        return;
    }

    if ($('#mde_place').val() != "" && $('#mde_link').val() != "" && $('#mde_name').val() != "" && $('#mde_date').val() != "" && $('#mde_description').val() != "" && $('#mde_outfit').val() != "") {
        console.log('la hora antes ' + $('#mde_date').val())
        var date = $('#mde_date').val().replace('T', ' ').replace('+00:00', '')
        date = date.replace(' ', 'T')
        var hour = (parseInt(date.substring(11, 13)) + 6)
        var formatedDate = date.substring(0, 10)
        if (hour < 0) {
            hour = 24 + hour
            formatedDate = restarUnDia(date.substring(0, 10))
        }
        if (hour >= 24) {
            hour = hour - 24
            formatedDate = sumarUnDia(date.substring(0, 10))
        }
        if (hour < 10) {
            hour = '0' + hour
        }
        formatedDate = formatedDate + 'T'
        date = formatedDate + hour + date.substring(13)
        if (date.length < 19) {
            date = date + ':00'
        }
        console.log('la hora después ' + date)
        if ($('#mde_invitacion').prop("checked")) {
            var requiere = "true"
        } else {
            var requiere = "false"
        }
        //await updateMetaObject(subEventElement.getAttribute('ubicacion'), [{ "key": "nombre_de_ubicacion", "value": $('#mde_place').val() }, { "key": "link_a_google_maps", "value": $('#mde_link').val() }])
        //await updateMetaObject(subEventElement.getAttribute('objectid').replaceAll('"', ''), [{ "key": "nombre_del_evento", "value": $('#mde_name').val() }, { "key": "fecha_y_hora", "value": date }, { "key": "descripcion", "value": $('#mde_description').val() }, { "key": "codigo_de_vestimenta", "value": $('#mde_outfit').val() }, { "key": "requiere_invitacion", "value": requiere }])
        $('#editEventDone').slideDown()
        $('#editEventFail').slideUp()
        $('#editEventForm').slideUp()
    } else {
        $('#editEventFail').slideDown()
    }
    setTimeout(() => {
        generalLoader.off()
        location.reload()
    }, 5000)
}

async function updateCurrentEvent(event) {
    event.preventDefault();
    generalLoader.on()
    $('.loader-msg').text('Actualizando evento.')

    let link = $('#mde_link').val().trim();

    if ($('#mde_place').val().trim() === "" ||
        link === "" ||
        $('#mde_name').val().trim() === "" ||
        $('#mde_date').val().trim() === "" ||
        $('#mde_description').val().trim() === "" ||
        $('#mde_outfit').val().trim() === "") {

        $('#editEventFail').text("Por favor, llena todos los campos").slideDown();
        generalLoader.off();
        return;
    }

    if (!isValidGoogleMapsURL(link)) {
        $('#editEventFail').text("El campo 'Link a Google Maps' debe ser un link de Google Maps válido").slideDown();
        generalLoader.off();
        return;
    }

    if ($('#mde_place').val() != "" && $('#mde_link').val() != "" && $('#mde_name').val() != "" && $('#mde_date').val() != "" && $('#mde_description').val() != "" && $('#mde_outfit').val() != "") {
        console.log('la hora antes ' + $('#mde_date').val())
        var date = $('#mde_date').val().replace('T', ' ').replace('+00:00', '')
        date = date.replace(' ', 'T')
        var hour = (parseInt(date.substring(11, 13)) + 6)
        var formatedDate = date.substring(0, 10)
        if (hour < 0) {
            hour = 24 + hour
            formatedDate = restarUnDia(date.substring(0, 10))
        }
        if (hour >= 24) {
            hour = hour - 24
            formatedDate = sumarUnDia(date.substring(0, 10))
        }
        if (hour < 10) {
            hour = '0' + hour
        }
        formatedDate = formatedDate + 'T'
        date = formatedDate + hour + date.substring(13)
        if (date.length < 19) {
            date = date + ':00'
        }
        console.log('la hora después ' + date)
        if ($('#mde_invitacion').prop("checked")) {
            var requiere = "true"
        } else {
            var requiere = "false"
        }
        await updateMetaObject(subEventElement.getAttribute('ubicacion'), [{ "key": "nombre_de_ubicacion", "value": $('#mde_place').val() }, { "key": "link_a_google_maps", "value": $('#mde_link').val() }])
        await updateMetaObject(subEventElement.getAttribute('objectid').replaceAll('"', ''), [{ "key": "nombre_del_evento", "value": $('#mde_name').val() }, { "key": "fecha_y_hora", "value": date }, { "key": "descripcion", "value": $('#mde_description').val() }, { "key": "codigo_de_vestimenta", "value": $('#mde_outfit').val() }, { "key": "requiere_invitacion", "value": requiere }])
        $('#editEventDone').slideDown()
        $('#editEventFail').slideUp()
        $('#editEventForm').slideUp()
    } else {
        $('#editEventFail').slideDown()
    }
    setTimeout(() => {
        generalLoader.off()
        location.reload()
    }, 5000)
}


async function getFileId(file) {
    var fileFields = await createFileUrl(file.name)
    console.log(fileFields)
    var url = fileFields.data.stagedUploadsCreate.stagedTargets[0].url
    var parameters = fileFields.data.stagedUploadsCreate.stagedTargets[0].parameters

    const formData = new FormData()

    parameters.forEach(({ name, value }) => {
        formData.append(name, value)
    })

    formData.append('file', file)

    const response = await fetch(url, {
        method: 'POST',
        body: formData
    })
    if (response.ok) {
        const key = parameters.find(p => p.name === 'key')
        var createdAt = await createFile(url + key.value)
        console.log(createdAt)
        createdAt = createdAt.data.fileCreate.files[0].createdAt
        var fileId = await getLastFile(createdAt)
        fileId = fileId.data.files.edges[0].node.id
        console.log('el fileId es ' + fileId)
    }
    return fileId
}

var bankCollection
var bankElement

function showBankModal(colId, e) {
    $('#bankDataForm').slideDown()
    $('#bankDataDone').slideUp()
    $('#bankDataFail').slideUp()
    $('.modal-fix.editBank').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.editBank').css('opacity', '1')
    var titular = normalizeAddressValue($('#bank_titular_' + colId).text())
    var banco = normalizeAddressValue($('#bank_banco_' + colId).text())
    var clabe = normalizeAddressValue($('#bank_clabe_' + colId).text())
    var cuenta = normalizeAddressValue($('#bank_cuenta_' + colId).text())
    bankElement = e
    $('#banco-titular').val(titular)
    $('#banco-banco').val(banco)
    $('#banco-cuenta').val(cuenta)
    $('#banco-clabe').val(clabe)
    bankCollection = colId
}

async function updateBankData() {
    var titular = normalizeAddressValue($('#banco-titular').val())
    var banco = normalizeAddressValue($('#banco-banco').val())
    var cuenta = normalizeAddressValue($('#banco-cuenta').val())
    var clabe = normalizeAddressValue($('#banco-clabe').val())

    if (!titular || !banco || !cuenta) {
        var missingFields = []
        if (!titular) missingFields.push({ label: 'titular', selector: '#banco-titular' })
        if (!banco) missingFields.push({ label: 'banco', selector: '#banco-banco' })
        if (!cuenta) missingFields.push({ label: 'número de cuenta', selector: '#banco-cuenta' })
        $('#bankDataFail div').text('Completa los siguientes campos: ' + missingFields.map(field => field.label).join(', ') + '.')
        $('#bankDataFail').slideDown()
        $(missingFields[0].selector).trigger('focus')
        return
    }

    if (!bankElement || !bankElement.getAttribute('objectid')) {
        console.error('No se encontró el metaobjeto de datos bancarios para actualizar')
        $('#bankDataFail div').text('No se pudieron guardar los cambios. Intenta nuevamente.')
        $('#bankDataFail').slideDown()
        return
    }

    $('#bankDataFail').slideUp()
    generalLoader.on()
    $('.loader-msg').text('Actualizando datos bancarios')
    try {
        var response = await updateMetaObject(bankElement.getAttribute('objectid'), [{ "key": "titular", "value": titular }, { "key": "banco", "value": banco }, { "key": "no_cuenta", "value": cuenta }, { "key": "clabe", "value": clabe }])
        if (!response?.data?.metaobjectUpdate?.metaobject?.id) {
            throw new Error('La API no confirmó la actualización de los datos bancarios')
        }
        $('#bankDataForm').slideUp()
        $('#bankDataDone').slideDown()
        setTimeout(() => {
            generalLoader.off()
            location.reload()
        }, 2000)
    } catch (error) {
        console.error('No se pudieron actualizar los datos bancarios', error)
        $('#bankDataFail div').text('No se pudieron guardar los cambios. Intenta nuevamente.')
        $('#bankDataFail').slideDown()
        generalLoader.off()
    }
}

var celebratedId
var celebratedNormalId
var celebratedColId
var oldName

function showCelebratedModal(userId, inputsId, colId) {
    $('#editCelebratedForm').slideDown()
    $('#editCelebratedDone').slideUp()
    $('.modal-fix.Celebrated').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.Celebrated').css('opacity', '1')
    celebratedColId = colId
    console.log(celebratedColId)
    var name = $('#ec_name_' + inputsId).text()
    var last_name = $('#ec_last_name_' + inputsId).text()
    var email = $('#ec_email_' + inputsId).text()
    var edit = $('#ec_edit_' + inputsId).text()
    celebratedNormalId = $('#ec_id_' + inputsId).attr('userId')
    $('#ef_name').val(name)
    $('#ef_last_name').val(last_name)
    $('#ef_email').val(email)
    if (edit == 'Sí') {
        $('#ef_edit').prop("checked", true);
    } else {
        $('#ef_edit').prop("checked", false);
    }
    celebratedId = userId
    oldName = $('#ef_name').val()
}

async function updateCelebrated() {
    generalLoader.on()
    $('.loader-msg').text('Actualizando información')
    var name = $('#ef_name').val()
    var last_name = $('#ef_last_name').val()
    var email = $('#ef_email').val()
    updateCustomer('gid://shopify/Customer/' + celebratedId, name, last_name, email)
    var customerData = await getCustomerData('gid://shopify/Customer/' + celebratedId)
    var tags = []
    if (customerData.data.customer.tags.length > 0) {
        tags = customerData.data.customer.tags
    }
    tags.splice(tags.indexOf(celebratedColId + '-f'), 1)
    tags.splice(tags.indexOf(celebratedColId + '-admin'), 1)
    if ($('#ef_edit').is(":checked")) {
        tags.push(celebratedColId + '-admin')
    } else {
        tags.push(celebratedColId + '-f')
    }
    var colMetafields = await getCollectionMetafield(celebratedColId)
    for (const met of colMetafields) {
        if (met.key == 'festejados') {
            var festejados_names = JSON.parse(met.value)
        }
    }
    festejados_names.splice(festejados_names.indexOf(oldName), 1)
    festejados_names.push(name)
    await addCollectionMetafield(celebratedColId, { "namespace": "custom", "key": "festejados", "type": "list.single_line_text_field", "value": JSON.stringify(festejados_names) })
    await updateCustomerTag('gid://shopify/Customer/' + celebratedId, tags)
    $('#editCelebratedForm').slideUp()
    $('#editCelebratedDone').slideDown()
    setTimeout(() => {
        generalLoader.off()
        location.reload()
    }, 2000)
}

async function setCelebratedData(collection) {
    var admins = await getGuestsData('query: "tag:' + collection + '-admin"')
    var festejados = await getGuestsData('query: "tag:' + collection + '-f"')
    let i = 0
    for (const festejado of admins.data.customers.edges) {
        var tel = ''
        var buttons = ''
        if ($('#isAdmin' + collection).attr('data') == 'true') {
            if (i == 0) {
                buttons = `<div class="cta-grid">
                  <a href="#" onclick="showCelebratedModal('${festejado.node.legacyResourceId}','${collection}${festejado.node.legacyResourceId}','${collection}')" class="btn sec-btn w-button">Editar</a>
                </div>`
            } else {
                buttons = `<div class="cta-grid">
                <a href="#" onclick="showCelebratedModal('${festejado.node.legacyResourceId}','${collection}${festejado.node.legacyResourceId}','${collection}')" class="btn sec-btn w-button">Editar</a>
                <a href="#" onclick="deleteCelebratedModal('${festejado.node.legacyResourceId}','${collection}${festejado.node.legacyResourceId}','${collection}','${festejado.node.displayName}')" class="btn prim-btn w-button">Borrar</a>
              </div>`
            }
        }
        if (festejado.node.phone != null) {
            tel = `<div class="cont">
      <div class="flex ver mini-gap">
        <h4>Teléfono</h4>
        <div id="ec_tel_${collection}${festejado.node.legacyResourceId}" class="med-par inconsolata light-grey-txt">${festejado.node.phone}</div>
      </div>
    </div>`
        }
        // console.log('buttons')
        // console.log(buttons)
        $('#festejados_cont_' + collection).append(`<div id="w-node-_744b783b-4eee-95e1-fd5c-93d0851d433c-d588d782" class="cont celebrated-${collection}${festejado.node.legacyResourceId}">
            <div class="flex ver small-gap">
              <div style="display:none;" id="ec_id_${collection}${festejado.node.legacyResourceId}" userId="${festejado.node.legacyResourceId}"></div>
              <div class="cont">
                <div class="flex ver mini-gap">
                  <div class="med-par inconsolata"><span id="ec_name_${collection}${festejado.node.legacyResourceId}">${festejado.node.firstName}</span> <span id="ec_last_name_${collection}${festejado.node.legacyResourceId}">${festejado.node.lastName}</span></div>
                </div>
              </div>
              <div class="cont">
                <div class="flex ver mini-gap">
                  <h4>Email</h4>
                  <div id="ec_email_${collection}${festejado.node.legacyResourceId}" class="med-par inconsolata light-grey-txt">${festejado.node.email}</div>
                </div>
              </div>
              ${tel}
              <div class="cont">
                <div class="flex ver mini-gap">
                  <h4>¿Tiene acceso para editar?</h4>
                  <div id="ec_edit_${collection}${festejado.node.legacyResourceId}" class="med-par inconsolata light-grey-txt">Sí</div>
                </div>
              </div>
            </div>
          </div>
          <div class="cont celebrated-${collection}${festejado.node.legacyResourceId}">
            <div class="flex ver right">
              ${buttons}
            </div>
          </div>`)
        i++
    }
    for (const festejado of festejados.data.customers.edges) {
        var buttons = ''
        var tel = ''
        if ($('#isAdmin' + collection).attr('data') == 'true') {
            buttons = `<div class="cta-grid">
                  <a href="#" onclick="showCelebratedModal('${festejado.node.legacyResourceId}','${collection}${festejado.node.legacyResourceId}','${collection}')" class="btn sec-btn w-button">Editar</a>
                  <a href="#" onclick="deleteCelebratedModal('${festejado.node.legacyResourceId}','${collection}${festejado.node.legacyResourceId}','${collection}','${festejado.node.displayName}')" class="btn prim-btn w-button">Borrar</a>
                </div>`
        }
        if (festejado.node.phone != null) {
            tel = `<div class="cont">
        <div class="flex ver mini-gap">
          <h4>Teléfono</h4>
          <div id="ec_tel_${collection}${festejado.node.legacyResourceId}" class="med-par inconsolata light-grey-txt">${festejado.node.phone}</div>
        </div>
      </div>`
        }
        // console.log('buttons')
        // console.log(buttons)
        $('#festejados_cont_' + collection).append(`<div id="w-node-_744b783b-4eee-95e1-fd5c-93d0851d433c-d588d782" class="cont celebrated-${collection}${festejado.node.legacyResourceId}">
              <div class="flex ver small-gap">
                <div style="display:none;" id="ec_id_${collection}${festejado.node.legacyResourceId}" userId="${festejado.node.legacyResourceId}"></div>
                <div class="cont">
                  <div class="flex ver mini-gap">
                    <div class="med-par inconsolata"><span id="ec_name_${collection}${festejado.node.legacyResourceId}">${festejado.node.firstName}</span> <span id="ec_last_name_${collection}${festejado.node.legacyResourceId}">${festejado.node.lastName}</span></div>
                  </div>
                </div>
                <div class="cont">
                  <div class="flex ver mini-gap">
                    <h4>Email</h4>
                    <div id="ec_email_${collection}${festejado.node.legacyResourceId}" class="med-par inconsolata light-grey-txt">${festejado.node.email}</div>
                  </div>
                </div>
                ${tel}
                <div class="cont">
                  <div class="flex ver mini-gap">
                    <h4>¿Tiene acceso para editar?</h4>
                    <div id="ec_edit_${collection}${festejado.node.legacyResourceId}" class="med-par inconsolata light-grey-txt">No</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="cont celebrated-${collection}${festejado.node.legacyResourceId}">
              <div class="flex ver right">
                ${buttons}
              </div>
            </div>`)
    }
}

var dcId
var dcElement
var dcColId
var dcName

function deleteCelebratedModal(id, element, colId, name) {
    $('#deleteCelebratedName').text(name)
    $('#deleteCelebratedDone').slideUp()
    $('#deleteCelebratedForm').slideDown()
    $('.modal-fix.deleteCelebrated').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.deleteCelebrated').css('opacity', '1')
    dcId = id
    dcElement = element
    dcColId = colId
    dcName = name
}

async function deleteCelebrated() {
    if ($('#deleteCelebratedCheck').hasClass('w--redirected-checked')) {
        generalLoader.on()
        $('.loader-msg').text('Eliminando festejado')
        var id = dcId
        var element = dcElement
        var colId = dcColId
        var name = dcName
        $('.celebrated-' + element).remove()
        var metafields = await getCustomerMetafield(id)
        var newEvents = []
        for (met of metafields) {
            if (met.key == "mis_mesas") {
                newEvents = JSON.parse(met.value)
            }
        }
        for (const event of newEvents) {
            var eventData = await getMetaObjectData(event)
            if (eventData.data.metaobject.fields[0].value.includes(colId)) {
                newEvents.splice(newEvents.indexOf(event), 1)
            }
        }
        await addCustomerMetafield(id, { "namespace": "custom", "key": "mis_mesas", "type": "list.metaobject_reference", "value": JSON.stringify(newEvents) })
        var customerData = await getCustomerData('gid://shopify/Customer/' + id)
        var tags = []
        if (customerData.data.customer.tags.length > 0) {
            tags = customerData.data.customer.tags
        }
        tags.splice(tags.indexOf(colId + '-f'), 1)
        tags.splice(tags.indexOf(colId + '-admin'), 1)
        await updateCustomerTag('gid://shopify/Customer/' + id, tags)
        var colMetafields = await getCollectionMetafield(colId)
        for (const met of colMetafields) {
            if (met.key == 'festejados') {
                var festejados_names = JSON.parse(met.value)
            }
        }
        festejados_names.splice(festejados_names.indexOf(name), 1)
        await addCollectionMetafield(colId, { "namespace": "custom", "key": "festejados", "type": "list.single_line_text_field", "value": JSON.stringify(festejados_names) })
        $('#deleteCelebratedDone').slideDown()
        $('#deleteCelebratedForm').slideUp()
        generalLoader.off()
    }
}

var addCelebratedColId
var colTitleCelebrated

function showAddCelebratedModal(colId, title) {
    $('#af_name').val('')
    $('#af_email').val('')
    $('#festejadoForm').slideDown()
    $('#festejadoDone').slideUp()
    $('#festejadoFail').slideUp()
    $('.modal-fix.addCelebrated').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.addCelebrated').css('opacity', '1')
    addCelebratedColId = colId
    colTitleCelebrated = title
}

async function addCelebrated() {
    generalLoader.on()
    $('.loader-msg').text('Agregando festejado')
    
    // Validar campos del formulario
    const name = $('#af_name').val()
    const email = $('#af_email').val()
    const lastname = $('#af_lastname').val()
    const isAdmin = $('#af_edit').is(":checked")
    
    if (name == '' || email == '' || lastname == '') {
        generalLoader.off()
        $('#festejadoFail').slideDown()
        return
    }

    try {
        // 1. Verificar si el usuario existe en Shopify
        const newUser = await verifyCustomer(email, name.replaceAll("'", ""), lastname.replaceAll("'", ""))
        
        if (!newUser.status) {
            generalLoader.off()
            $('#festejadoFail').slideDown()
            return
        }

        // 2. Obtener datos completos del usuario con sus metafields
        const customerData = await getCustomerData(newUser.customer.id)
        console.log('Customer data:', customerData)
        
        const CustomerId = 'gid://shopify/Customer/' + customerData.data.customer.legacyResourceId
        const customerLegacyId = customerData.data.customer.legacyResourceId
        
        // 3. Revisar si el usuario ya tiene la mesa agregada
        let hasMesasMetafield = false
        let existingMesas = []
        let hasEventosMetafield = false
        let existingEventos = []
        let alreadyHasTable = false
        
        if (customerData.data.customer.metafields.edges.length > 0) {
            for (const metafield of customerData.data.customer.metafields.edges) {
                if (metafield.node.key == "mis_mesas") {
                    hasMesasMetafield = true
                    existingMesas = JSON.parse(metafield.node.value)
                    
                    // Verificar si ya tiene esta mesa específica
                    for (const mesaId of existingMesas) {
                        const mesaData = await getMetaObjectData(mesaId)
                        const mesaCollectionId = mesaData.data.metaobject.fields[0].value.replace("gid://shopify/Collection/", "")
                        if (mesaCollectionId == addCelebratedColId) {
                            alreadyHasTable = true
                            break
                        }
                    }
                }
                if (metafield.node.key == "mis_eventos") {
                    hasEventosMetafield = true
                    existingEventos = JSON.parse(metafield.node.value)
                }
            }
        }
        
        // Si ya tiene la mesa, mostrar error
        if (alreadyHasTable) {
            generalLoader.off()
            $('#festejadoFail div').text('Este usuario ya está agregado a esta mesa')
            $('#festejadoFail').slideDown()
            setTimeout(() => {
                $('#festejadoFail div').text('Por favor, completa los campos')
            }, 3000)
            return
        }
        
        // 4. Crear el metaobjeto de referencia a la mesa con el rol apropiado
        const rol = isAdmin ? 'Administrador' : 'Festejado'
        const tag = isAdmin ? '-admin' : '-f'
        const tableReference = await createTableReference("gid://shopify/Collection/" + addCelebratedColId, rol)
        
        console.log('Table reference created:', tableReference)
        
        // 5. Actualizar o crear el metafield "mis_mesas"
        if (hasMesasMetafield) {
            existingMesas.push(tableReference)
            await addCustomerMetafield(customerLegacyId, {
                "namespace": "custom",
                "key": "mis_mesas",
                "type": "list.metaobject_reference",
                "value": JSON.stringify(existingMesas)
            })
        } else {
            await addCustomerMetafield(customerLegacyId, {
                "namespace": "custom",
                "key": "mis_mesas",
                "type": "list.metaobject_reference",
                "value": JSON.stringify([tableReference])
            })
        }
        
        // 6. Crear objetos de invitación para los eventos de la mesa
        const eventsObjects = []
        const savedEventsData = $('#se_data_ids' + addCelebratedColId).attr('data')
        
        if (savedEventsData && savedEventsData.trim() !== '') {
            try {
                const saved_events = JSON.parse(savedEventsData)
                for (let i = 0; i < saved_events.length; i++) {
                    eventsObjects.push(await createGuestInvitationObject(saved_events[i], 'Confirmado', $('#mcName').attr('name'), 'Familia', 1, 1))
                }
            } catch (parseError) {
                console.error('Error al parsear eventos guardados:', parseError)
                console.log('Datos recibidos:', savedEventsData)
            }
        } else {
            console.warn('No se encontraron eventos guardados para esta mesa o el atributo está vacío')
        }
        
        // 7. Actualizar o crear el metafield "mis_eventos" solo si hay eventos
        if (eventsObjects.length > 0) {
            if (hasEventosMetafield) {
                const allEventos = [...existingEventos, ...eventsObjects]
                await addCustomerMetafield(customerLegacyId, {
                    "namespace": "custom",
                    "key": "mis_eventos",
                    "type": "list.metaobject_reference",
                    "value": JSON.stringify(allEventos)
                })
            } else {
                await addCustomerMetafield(customerLegacyId, {
                    "namespace": "custom",
                    "key": "mis_eventos",
                    "type": "list.metaobject_reference",
                    "value": JSON.stringify(eventsObjects)
                })
            }
        } else {
            console.log('No hay eventos para agregar al usuario')
        }
        
        // 8. Actualizar tags del usuario
        const newTags = customerData.data.customer.tags.length > 0 ? customerData.data.customer.tags : []
        newTags.push(addCelebratedColId + tag)
        newTags.push(addCelebratedColId + '-i')
        await updateCustomerTag(CustomerId, newTags)
        
        // 9. Actualizar la lista de festejados en la colección
        const colMetafields = await getCollectionMetafield(addCelebratedColId)
        let festejados_names = []
        for (const met of colMetafields) {
            if (met.key == 'festejados') {
                festejados_names = JSON.parse(met.value)
                break
            }
        }
        festejados_names.push(name + ' ' + lastname)
        await addCollectionMetafield(addCelebratedColId, {
            "namespace": "custom",
            "key": "festejados",
            "type": "list.single_line_text_field",
            "value": JSON.stringify(festejados_names)
        })
        
        // 10. Enviar email de notificación
        const active = newUser.customer_status == 'active'
        sendEmail(email, colTitleCelebrated, CustomerId, active, name.replaceAll("'", ""), $('#mcName').attr('name'))
        
        // Mostrar mensaje de éxito
        $('#festejadoForm').slideUp()
        $('#festejadoDone').slideDown()
        $('#festejadoFail').slideUp()
        
        setTimeout(() => {
            generalLoader.off()
            location.reload()
        }, 2000)
        
    } catch (error) {
        console.error('Error al agregar festejado:', error)
        generalLoader.off()
        $('#festejadoFail div').text('Ocurrió un error al agregar el festejado')
        $('#festejadoFail').slideDown()
        setTimeout(() => {
            $('#festejadoFail div').text('Por favor, completa los campos')
        }, 3000)
    }
}




async function deleteEvent(id) {
    generalLoader.on()
    $('.loader-msg').text('Eliminando evento')
    const gid = `gid://shopify/Metaobject/${id}`;
    const response = await deletelMetaobject(gid);
    console.log(response);
    // await deletelMetaobject(e.getAttribute('objectid').replaceAll('"', ''))
    setTimeout(() => {
        generalLoader.off()
        location.reload()
    }, 2000)
}

function showAddEventModal(colId, funcionalidades) {
    $('#addEventForm').slideDown()
    $('#addEventDone').slideUp()
    $('#addEventFail').slideUp()
    if (!funcionalidades) {
        $('#checkAddEvent').addClass('d-none')
    }
    $('.modal-fix.addEvent').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.addEvent').css('opacity', '1')
    subEventsCollection = colId
}

async function addSubEvent(event) {
    event.preventDefault();

    generalLoader.on();
    $('.loader-msg').text('Agregando evento');

    var link = $('#mdae_link').val().trim();

    if ($('#mdae_place').val().trim() === "" ||
        link === "" ||
        $('#mdae_name').val().trim() === "" ||
        $('#mdae_date').val().trim() === "" ||
        $('#mdae_description').val().trim() === "" ||
        $('#mdae_outfit').val().trim() === "") {

        $('#addEventFail').text("Por favor, llena todos los campos").slideDown();
        generalLoader.off();
        return;
    }

    // Validar que el link sea un enlace de Google Maps
    if (!isValidGoogleMapsURL(link)) {
        $('#addEventFail').text("El campo 'Link a Google Maps' debe ser un link de Google Maps válido").slideDown();
        generalLoader.off();
        return;
    }

    $('#addEventFail').slideUp();

    var metafields = await getCollectionMetafield(subEventsCollection);
    var events = [];

    for (let i = 0; i < metafields.length; i++) {
        if (metafields[i].key == "eventos") {
            events = JSON.parse(metafields[i].value);
        }
    }

    var se_ubicacion = await createEventUbication($('#mdae_place').val(), $('#mdae_link').val());
    var requiere = $('#mdae_invitacion').prop("checked") ? "true" : "false";

    var date = $('#mdae_date').val().replace(' ', 'T') + ':00';
    var hour = parseInt(date.substring(11, 13)) + 6;
    var formatedDate = date.substring(0, 10);

    if (hour < 0) {
        hour = 24 + hour;
        formatedDate = restarUnDia(date.substring(0, 10));
    }
    if (hour >= 24) {
        hour = hour - 24;
        formatedDate = sumarUnDia(date.substring(0, 10));
    }
    if (hour < 10) {
        hour = '0' + hour;
    }

    formatedDate = formatedDate + 'T';
    date = formatedDate + hour + date.substring(13);
    if (date.length < 19) {
        date = date + ':00';
    }

    console.log('la hora después ' + date);

    events.push(await createCollectionEvents($('#mdae_name').val(), 'Secundario', date, '', $('#mdae_description').val(), $('#mdae_outfit').val(), se_ubicacion, requiere));
    await addCollectionMetafield(subEventsCollection, { "namespace": "custom", "key": "eventos", "type": "list.metaobject_reference", "value": JSON.stringify(events) });

    $('#addEventDone').slideDown();
    $('#addEventFail').slideUp();
    $('#addEventForm').slideUp();
    console.log(events);

    var invitacionId = JSON.parse($('#invitacion_id' + subEventsCollection).text());
    await updateMetaObject(invitacionId[0], { "key": "eventos", "value": JSON.stringify(events) });

    setTimeout(() => {
        generalLoader.off();
        location.reload();
    }, 2000);
}


function onChangeTxtCardNumber2(e) {
    var cardNumber = txtCardNumber2.value;

    // Do not allow users to write invalid characters
    var formattedCardNumber = cardNumber.replace(/[^\d]/g, "");
    formattedCardNumber = formattedCardNumber.substring(0, 16);

    // Split the card number is groups of 4
    var cardNumberSections = formattedCardNumber.match(/\d{1,4}/g);
    if (cardNumberSections !== null) {
        formattedCardNumber = cardNumberSections.join(' ');
    }


    // If the formmattedCardNumber is different to what is shown, change the value
    if (cardNumber !== formattedCardNumber) {
        txtCardNumber2.value = formattedCardNumber;
    }
}

function onChangeTxtCardNumber(e) {
    var cardNumber = txtCardNumber.value;

    // Do not allow users to write invalid characters
    var formattedCardNumber = cardNumber.replace(/[^\d]/g, "");
    formattedCardNumber = formattedCardNumber.substring(0, 16);

    // Split the card number is groups of 4
    var cardNumberSections = formattedCardNumber.match(/\d{1,4}/g);
    if (cardNumberSections !== null) {
        formattedCardNumber = cardNumberSections.join(' ');
    }


    // If the formmattedCardNumber is different to what is shown, change the value
    if (cardNumber !== formattedCardNumber) {
        txtCardNumber.value = formattedCardNumber;
    }
}
var globalItemCount = []
var globalItemCountColId

async function saveNewQtys() {
    generalLoader.on()
    $('.loader-msg').text('Guardando Cambios')
    var totalMoney = parseFloat($('.table_total_' + globalItemCountColId)[0].textContent.replace('$', '').replace(',', ''))
    var totalQty = parseInt($('.regalos_want_' + globalItemCountColId)[0].textContent)
    for (let i = 0; i < globalItemCount.length; i++) {
        await updateWantQty(globalItemCountColId, globalItemCount[i].id, globalItemCount[i].qty)
        var diference = parseInt(globalItemCount[i].qty) - parseInt(globalItemCount[i].prev)
        var money = diference * globalItemCount[i].price
        totalMoney += money
        totalQty += diference
    }
    $('.table_total_' + globalItemCountColId).text(Shopify.formatMoney(totalMoney * 100))
    $('.regalos_want_' + globalItemCountColId).text(thousandFormat(totalQty))
    globalItemCount = []
    $('#saveNewQtyBtn').addClass('d-none')
    setTimeout(() => {
        generalLoader.off()
    }, 1000)
}

function thousandFormat(numero) {
    numero = parseInt(numero)
    if (numero >= 1000) {
        return numero.toLocaleString();
    } else {
        return numero.toString();
    }
}

$(document).ready(function () {
    flatpickr("#event-date", {
        enableTime: true,
        minDate: "today"
    });
    flatpickr("#CM_se_date", {
        enableTime: true,
        minDate: "today",
        dateFormat: "d-m-Y H:i"
    });
    flatpickr("#mde_date", {
        enableTime: true,
        minDate: "today"
    });
    flatpickr("#mdae_date", {
        enableTime: true,
        minDate: "today"
    });
    flatpickr("#mainEventDate", {
        dateFormat: "d-m-Y",
        minDate: "today"
    });
    flatpickr("#mec_date", { dateFormat: "d-m-Y", });
    flatpickr("#date-input", { dateFormat: "d-m-Y", });
    $('.want-input').on('change', function (e) {
        $('#saveNewQtyBtn').removeClass('d-none')
        globalItemCount.push({ "id": $(this).attr('product'), "qty": $(this).val(), "price": parseFloat($(this).attr('price')) / 100, "prev": $(this).attr('qty') })
        globalItemCountColId = $(this).attr('collection')
    });
    $('#event-plan').on('change', hideRequireBtn)
    if ($('#back_button')) {
        //$('#back_button').attr('href',document.referrer)
    }
    if ($('#backBtn2')) {
        //$('#backBtn2').attr('href',document.referrer)
    }
    var dateclass = 'classdate';

    var wfdc = $('.' + dateclass);

    wfdc.each(function () {
        var wfdctxt = $(this).text();

        var monthsEn = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
            'Sunday'
        ];

        var monthsEs = [
            'Enero',
            'Febrero',
            'Marzo',
            'Abril',
            'Mayo',
            'Junio',
            'Julio',
            'Agosto',
            'Septiembre',
            'Octubre',
            'Noviembre',
            'Diciembre',
            'Lunes',
            'Martes',
            'Miércoles',
            'Jueves',
            'Viernes',
            'Sábado',
            'Domingo'
        ];
        $('.search-day').each(function () {
            if (parseInt($(this).text()) < 10) {
                $(this).text($(this).text().replace('0', ''))
            }
        })

        for (var i = 0; i < monthsEn.length; i++) {
            wfdctxt = wfdctxt.replace(monthsEn[i], monthsEs[i]);
        }

        $(this).text(wfdctxt);
    });
    if ($('.cm-field-4')) {
        $('.cm-field-4').on('input', function () {
            checkAddressInputs()
        })
    }
})

function checkAddressInputs() {
    var pasa = true
    $('.cm-field-4').each(function () {
        if (!$(this).val()) {
            pasa = false
        }
    })
    if (pasa) {
        $('#cmBtnTerminar').val('Terminar')
    } else {
        $('#cmBtnTerminar').val('Completa los campos para terminar')
    }
}

async function hideRequireBtn() {
    var planData = await getOrderData('gid://shopify/Order/' + $('#event-plan').val())
    var value = planData.data.node.lineItems.edges[0].node.product.title
    if (value != 'Premium') {
        $('#require_check').addClass('d-none')
    }
}


async function updateWantQty(colId, productId, qty) {
    var products
    var metafields = await getCollectionMetafield(colId)
    for (const met of metafields) {
        if (met.key == "productos") {
            products = JSON.parse(met.value)
        }
    }
    result = products.filter((product) => ('' + product.id).replace('gid://shopify/Product/', '') === productId)
    if (result[0].recibidos <= qty) {
        var modifiedData = result[0]
        modifiedData.cuantos = qty
        products[products.indexOf(result[0])] = modifiedData
    }
    await addCollectionMetafield(colId, { "namespace": "custom", "key": "productos", "type": "json", "value": JSON.stringify(products) })
}

//Funciones para la sección de invitados

var guestColl

function showGuestModal(colId) {
    guestColl = colId
    var pasa = false
    var events = JSON.parse($('#se_data' + guestColl).attr('data'))
    for (let i = 0; i < events.length; i++) {
        if (events[i].requiere_invitacion) {
            pasa = true
        }
    }
    if (pasa) {
        $('#mci-text').text('Crea y edita tu lista de invitados')
        $('#mci-content').removeClass('d-none')
    } else {
        $('#mci-text').text('No puedes agregar invitados debido a que no tienes un evento que requiera invitación.')
        $('#mci-content').addClass('d-none')
    }
    $('.modal-fix.addGuest').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.addGuest').css('opacity', '1')
}
async function showManualGuestModal() {
    $('#manualGuestForm').slideDown()
    $('#manualGuestDone').slideUp()
    $('#manualGuestError').slideUp()
    $('.modal-fix.manualGuest').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.manualGuest').css('opacity', '1')
    $('#mim_name').val('')
    $('#mim_lastName').val('')
    $('#mim_email').val('')
    $('#mim_tel').val('')
    $('#companions-cont').empty()
    $('#guest-event-container').empty()
    $('#mim_celebrated').empty()
    $('#mim_celebrated').append(`<option value="Seleccionar festejado" disabled selected>Seleccionar festejado</option>`)
    var festejados = []
    var festejadosData = ''
    var adminsData = ''
    var cursor = ''
    var query
    do {
        query = 'query: "tag:' + guestColl + '-f"'
        if (festejadosData != '') {
            cursor = festejadosData.data.customers.pageInfo.endCursor
            query = 'query: "tag:' + guestColl + '-f", after:"' + cursor + '"'
        }
        festejadosData = await getGuestsData(query)
        for (let i = 0; i < festejadosData.data.customers.edges.length; i++) {
            festejados.push(festejadosData.data.customers.edges[i])
        }
    } while (festejadosData.data.customers.pageInfo.hasNextPage)
    do {
        query = 'query: "tag:' + guestColl + '-admin"'
        if (adminsData != '') {
            cursor = adminsData.data.customers.pageInfo.endCursor
            query = 'query: "tag:' + guestColl + '-admin", after:"' + cursor + '"'
        }
        adminsData = await getGuestsData(query)
        for (let i = 0; i < adminsData.data.customers.edges.length; i++) {
            festejados.push(adminsData.data.customers.edges[i])
        }
    } while (adminsData.data.customers.pageInfo.hasNextPage)
    for (let i = 0; i < festejados.length; i++) {
        $('#mim_celebrated').append(`<option value="${festejados[i].node.displayName}">${festejados[i].node.displayName}</option>`)
    }
    var events = JSON.parse($('#se_data' + guestColl).attr('data'))
    var eventsids = JSON.parse($('#se_data_ids' + guestColl).attr('data'))
    for (let i = 0; i < events.length; i++) {
        if (events[i].requiere_invitacion) {
            $('#guest-event-container').append(`<div class="event-invite-grid">
                        <label id="w-node-a78daa43-b702-7faa-ff83-b02a6e53d2bf-f13f242c" class="w-checkbox check">
                          <div name="${events[i].nombre_del_evento}" eventnmb="${i}" eventId="${eventsids[i]}" class="w-checkbox-input w-checkbox-input--inputType-custom check-btn events-check"></div>
                          <input eventnmb="${i}" type="checkbox" id="checkbox" class="events-check-input" name="checkbox" data-name="Checkbox" style="opacity:0;position:absolute;z-index:-1">
                          <span class="check-label w-form-label" for="checkbox">${events[i].nombre_del_evento}</span>
                        </label>
                        <div id="w-node-f15189a6-6e08-0800-6768-1c10d1aa9c8d-f13f242c">
                          <input id="eventnmb${i}" type="number" class="input w-node-ac55f77c-38e7-2187-4677-d4c887e9d31a-f13f242c w-input ticket-input" maxlength="256" name="Tel-fono" data-name="Teléfono" min="0" disabled placeholder="Boletos">
                        </div>
                        <div id="w-node-_01237c90-c33b-e446-dfb4-c2a4a77a1330-f13f242c">
                          <input id="eventcnf${i}" type="number" class="input w-node-ac55f77c-38e7-2187-4677-d4c887e9d31a-f13f242c w-input ticket-input" maxlength="256" name="Tel-fono" data-name="Teléfono" min="0" disabled placeholder="Confirmados">
                        </div>
                      </div>`)
        }
    }
    $('.events-check-input').each(function () {
        $(this).on('change', function () {
            if ($(this).prop('checked')) {
                $('#eventnmb' + $(this).attr('eventnmb')).prop('disabled', false)
                $('#eventnmb' + $(this).attr('eventnmb')).val($('#mim_tickets').val())
                $('#eventcnf' + $(this).attr('eventnmb')).prop('disabled', false)
            } else {
                $('#eventnmb' + $(this).attr('eventnmb')).prop('disabled', true)
                $('#eventnmb' + $(this).attr('eventnmb')).val(0)
                $('#eventcnf' + $(this).attr('eventnmb')).prop('disabled', true)
                $('#eventcnf' + $(this).attr('eventnmb')).val(0)
            }
        })
    })
    if ($('#mim_tickets').length > 0) {
        $('#mim_tickets').on('change', function () {
            $('.ticket-input').each(function () {
                if (!$(this).prop('disabled')) {
                    $(this).val($('#mim_tickets').val())
                }
            })
        })
    }
}

function showFileGuestModal() {
    $('#guestFile-form').slideDown()
    $('#guestFile-done').slideUp()
    $('#guestFile-error').slideUp()
    $('.modal-fix.fileGuest').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.fileGuest').css('opacity', '1')
}

var companionCount = 0

function addCompanion() {
    $('#companions-cont').append(`<div id="companion-${companionCount}" class="d-none companion-container">
              <div class="flex ver gap">
                <div class="grid two-col small-gap">
                  <input type="text" class="input w-node-ebe51262-634a-65cd-7d37-ac114ffa1a56-f13f242c w-input extra-guest name" maxlength="256" name="Nombre" data-name="Nombre" placeholder="Nombre" required="">
                  <input type="text" class="input w-node-a6391023-fe1c-28ff-d18d-a16b35fa63b6-f13f242c w-input extra-guest last-name" maxlength="256" name="Apellido" data-name="Apellido" placeholder="Apellido" required="">
                  <input type="email" class="input w-node-_57935c3f-a3d4-7dce-2272-a329bbc74b0b-f13f242c w-input extra-guest email" maxlength="256" name="Email" data-name="Email" placeholder="Email">
                  <input type="tel" class="input w-node-ac55f77c-38e7-2187-4677-d4c887e9d31a-f13f242c w-input extra-guest tel" maxlength="256" name="Tel-fono" data-name="Teléfono" placeholder="Teléfono">
                </div>
                <div class="cont">
                  <a href="#" onclick="deleteCompanion('${companionCount}')" class="add-guest-link w-inline-block">
                    <div class="flex hor mid left small-gap">
                      <div>Eliminar acompañante</div>
                    </div>
                  </a>
                </div>
              </div>
            </div>`)
    $('#companion-' + companionCount).slideDown()
    companionCount++
}

function deleteCompanion(companion) {
    $('#companion-' + companion).slideUp()
    setTimeout(() => {
        $('#companion-' + companion).remove()
    }, 1000)
}

async function addNewGuest() {
    $('.loader-msg').text('Agregando invitado')
    var mainGuestName = $('#mim_name').val()
    var mainGuestLastName = $('#mim_lastName').val()
    var mainGuestEmail = $('#mim_email').val()
    var mainGuestTelCode = $('#mim_code_tel').val()
    var mainGuestTel = $('#mim_tel').val()
    var celebrated = $('#mim_celebrated').val()
    var group = $('#mim_grupo').val()
    var boletos = []
    var confirmados = []
    var events = []
    var mainId
    $('.events-check').each(function () {
        if ($(this).hasClass('w--redirected-checked')) {
            events.push($(this).attr('eventId'))
            if ($('#eventnmb' + $(this).attr('eventnmb')).val() != '' && $('#eventnmb' + $(this).attr('eventnmb')).val() != undefined && $('#eventnmb' + $(this).attr('eventnmb')).val() != null) {
                boletos.push($('#eventnmb' + $(this).attr('eventnmb')).val())
                confirmados.push($('#eventcnf' + $(this).attr('eventnmb')).val())
            }
        }
    })
    console.log('events')
    console.log(events)
    console.log(boletos)
    if (mainGuestName != '' && mainGuestLastName != '' && mainGuestEmail != '' && mainGuestTel != '' && celebrated != '' && group != '' && mainGuestTelCode != '' && events.length > 0 && boletos.length == events.length) {
        generalLoader.on()
        var eventsObjects = []
        for (let i = 0; i < events.length; i++) {
            eventsObjects.push(await createGuestInvitationObject(events[i], (confirmados[i] == '' ? 'Invitado' : 'Confirmado'), celebrated, group, boletos[i], (confirmados[i] == '' ? 0 : confirmados[i])))
        }
        var custId
        var metafield = [{ "namespace": "custom", "key": "mis_eventos", "type": "list.metaobject_reference", "value": JSON.stringify(eventsObjects) }]

        await verifyCustomer(mainGuestEmail, mainGuestName.replaceAll("'", ""), mainGuestLastName.replaceAll("'", ""), mainGuestTelCode, mainGuestTel).then(async function (newUser) {
            if (newUser.status) {
                var hasMetafield = false
                var metafieldValue
                var CustomerId
                var newTags = []
                var cId = await getCustomerData(newUser.customer.id)
                console.log(cId)
                active = false
                CustomerId = 'gid://shopify/Customer/' + cId.data.customer.legacyResourceId
                mainId = 'gid://shopify/Customer/' + cId.data.customer.legacyResourceId
                if (cId.data.customer.tags.length > 0) {
                    newTags = cId.data.customer.tags
                }
                newTags.push(guestColl + '-i')
                await updateCustomerTag(CustomerId, newTags)
                if (cId.data.customer.metafields.edges.length > 0) {
                    for (metafield of cId.data.customer.metafields.edges) {
                        if (metafield.node.key == "mis_eventos") {
                            hasMetafield = true
                            metafieldValue = JSON.parse(metafield.node.value)
                        }
                    }
                }
                if (hasMetafield) {
                    for (let i = 0; i < eventsObjects.length; i++) {
                        metafieldValue.push(eventsObjects[i])
                    }
                    await addCustomerMetafield(cId.data.customer.legacyResourceId, { "namespace": "custom", "key": "mis_eventos", "type": "list.metaobject_reference", "value": JSON.stringify(metafieldValue) })
                } else {
                    await addCustomerMetafield(cId.data.customer.legacyResourceId, { "namespace": "custom", "key": "mis_eventos", "type": "list.metaobject_reference", "value": JSON.stringify(eventsObjects) })
                }
            }
        })
        $('#manualGuestForm').slideUp()
        $('#manualGuestError').slideUp()
        $('#manualGuestDone').slideDown()
        generalLoader.off()
        console.log('antes del reload')
        setTimeout(() => {
            console.log('a 3')
            //location.reload()
        }, 3000)
    } else {
        $('#manualGuestError').slideDown()
    }
    return 0
}
async function setGuestRows(collectionId, guestLoader, guestsData, type) {

    const typeElement = `guests_container-${type}-${collectionId}`
    guestLoader.on();
    //const eventsData = JSON.parse($('#se_data' + collectionId).attr('data'));
    //const eventsIds = JSON.parse($('#se_data_ids' + collectionId).attr('data'));

    if (guestsData.length < 1) {
        $(`#no_guests_container-${type}-${collectionId}`).removeClass('d-none');
        return
    }
    //const eventNames = eventsData.map((event) => event.nombre_del_evento);
    let guests;
    const filterEventsByType = (guestsData, type) => {
        return guestsData.filter((guest) => {
            return guest.eventos.some((event) => event.status === type);
        });
    }

    if (type === 'confirmed') {
        guests = filterEventsByType(guestsData, "Confirmado");
        document.getElementById(`comfirmed_guest-${collectionId}-count`).textContent = `(${guests.length})`;
        if (guests.length < 1) {
            $(`#no_guests_container-${type}-${collectionId}`).removeClass('d-none');
        }
    } else if (type === 'pending') {
        guests = filterEventsByType(guestsData, "Invitación Enviada");
        document.getElementById(`pending_guest-${collectionId}-count`).textContent = `(${guests.length})`;
        if (guests.length < 1) {
            $(`#no_guests_container-${type}-${collectionId}`).removeClass('d-none');
        }
    } else if (type === 'no-invite') {
        guests = filterEventsByType(guestsData, "Invitado");
        document.getElementById(`no-invite_guest-${collectionId}-count`).textContent = `(${guests.length})`;
        if (guests.length < 1) {
            $(`#no_guests_container-${type}-${collectionId}`).removeClass('d-none');
        }
    } else if (type === 'rejected') {
        guests = filterEventsByType(guestsData, "Rechazado");
        document.getElementById(`rejected_guest-${collectionId}-count`).textContent = `(${guests.length})`;
        if (guests.length < 1) {
            $(`#no_guests_container-${type}-${collectionId}`).removeClass('d-none');
        }
    } else if (type === 'manual') {
        guests = filterEventsByType(guestsData, "Manual RSVP");
        document.getElementById(`manual_guest-${collectionId}-count`).textContent = `(${guests.length})`;
        if (guests.length < 1) {
            $(`#no_guests_container-${type}-${collectionId}`).removeClass('d-none');
        }
    } else {
        guests = guestsData;
        document.getElementById(`all_guest-${collectionId}-count`).textContent = `(${guests.length})`;
    }
    const eventsData = await fetchData(
        `${productionUrl}${candidateVersion}/collections/events/get?collection_id=${currentCollectionId}`
    );;
    guests.forEach((guest) => {
        const row = createGuestRow(guest, collectionId, type, eventsData);
        const container = document.getElementById(typeElement)
        if (row) {
            container.appendChild(row);
        }

    });
    $('#guest-loading-' + collectionId).addClass('d-none');
    guestLoader.off();
}
function createGuestRow(guest, collectionId, type = "all", { data: eventsData }) {
    //const eventsData = JSON.parse($('#se_data' + collectionId).attr('data'));
    const eventNames = eventsData.map((event) => event.nombre_del_evento.trim());
    const row = document.createElement('div');
    const { eventos: events } = guest;
    if (events.length === 0) return;
    const firstCelebrated = events[0]?.festejado;
    const firstGroup = events[0]?.grupo;
    const customerId = guest.gid.split('/').pop();
    row.style.cssText = 'border-bottom: 1px solid #e0e0e0;';
    const guestEventNames = eventNames
        .filter((eventName) => {
            return events.some((event) => event.nombre_evento === eventName);
        })
        .map((eventName) => {
            row.classList.add(handleString(eventName));
            return handleString(eventName);
        });
    const status = events.map((event) => {
        row.classList.add(handleString(event.status));
        return event.status;
    });
    const eventTickets = events.map((event) => event.boletos);
    const confirmTickets = events.map((event) => event.boletos_confirmados);
    const eventIds = events.map((event) => event.evento);
    const note = events[0].mensaje ? 'Nota: ' + events[0].mensaje : '';
    row.classList.add('db-invite-table-row', 'data-row', `guest${collectionId}`, 'todos', 'result');
    row.innerHTML = `
        <div class="table-col name">
            <div class="flex ver left mid mini-gap">
                <label class="w-checkbox table-check" onclick="showActions(event,'${collectionId}', '${type}')" data-checkbox-type="guest-row" data-guest-type="${guest.type ?? 'customer'}">
                    <div class="w-checkbox-input w-checkbox-input--inputType-custom check-btn guest_check check_guests_${collectionId} todos ${guestEventNames.map(name => handleString(name))}" customerid="${customerId}" name="${guest.nombre}" lname="${guest.apellido}" events='${JSON.stringify(eventIds)}' email="${guest.email != null ? guest.email : ''}" tel="${guest.telefono != null ? guest.telefono : ''}" festejado="${firstCelebrated}" grupo="${firstGroup}" tickets="[${eventTickets}]" confirmados="[${confirmTickets.join(',')}]" collectionId="${collectionId}" guest-type="${guest.type ?? 'customer'}" guest-events='${JSON.stringify(events)}'></div>
                    <input type="checkbox" id="user-name-3" name="user-name-3" data-name="User Name 3" style="opacity:0;position:absolute;z-index:-1">
                    <span class="check-label w-form-label guest_name" for="user-name-3">${guest.nombre} ${guest.apellido ?? ''}</span>
                </label>
                <p class="guest-note">${note ? note : ''}</p>
            </div>
        </div>
        <div class="table-col">
            ${firstCelebrated && firstGroup ? `${firstCelebrated} | ${firstGroup}` : ''}
        </div>
        <div class="table-col">
            <div class="flex ver cen mid mini-gap">
                <a href="mailto:${guest.email}">${guest.email != null ? guest.email : ''}</a>
                <a href="tel:${guest.telefono}">${guest.telefono != null ? guest.telefono : ''}</a>
            </div>
        </div>
        <div class="table-col">
            <div class="flex ver cen mid small-gap">
        ${setEventTickets(events).join('')}
            </div>
        </div>
        <div class="table-col">
            <div class="flex ver cen mid small-gap">
        ${setEventConfirmed(events).join('')}
            </div>
        </div>
        <div class="table-col status-col">
            <div class="flex ver cen mid small-gap">
        ${setEventStatus(events).join('')}
            </div>
        </div>
        `;
    return row;
}
async function GetAllGuestEvents(collectionId) {
    const guestsData = await getMetaobjectsAndCustomerLists(collectionId);
    return guestsData.map(guest => {
        const { eventos: events } = guest
        return events.map((event, index) => {
            const main = index === 0 ? true : false
            return {
                "event": event.nombre_evento,
                "principal": main,
                "guest": guest.nombre,
                "status": event.status,
                "grupo": event.grupo,
                "festejado": event.festejado,
                "boletos": event.boletos,
                "confirmados": event.boletos_confirmados
            }
        })
    })
}
const setEventTickets = (events) => {
    return events.map(event => {
        return `<div class="cont">
                <div class="flex ver cen mini-gap">
                    <div>${event.nombre_evento}</div>
                        <div class="status-tag">
                        <div>${event.boletos ?? 0} Boletos</div>
                    </div>
                </div>
            </div>`
    })
}
const setEventConfirmed = (events) => {
    return events.map(event => {
        return `<div class="cont">
            <div class="flex ver cen mini-gap">
            <div>${event.nombre_evento}</div>
            <div class="status-tag">
                <div>${event.boletos_confirmados ?? 0} Confirmados</div>
            </div>
            </div>
        </div>`
    })
}
const setEventStatus = (events) => {
    const eventStatus = {
        'Invitado': { className: 'no-invite', text: 'Sin Invitación' },
        'Invitación Enviada': { className: 'pending', text: 'Pendiente' },
        'Confirmado': { className: 'confirmed', text: 'asistirá' },
        'No asistirá': { className: 'cancelled', text: 'No asistirá' },
        'Rechazado': { className: 'cancelled', text: 'No asistirá' },
        'Manual RSVP': { className: 'manual', text: 'Invitado Manual' },
    }
    return events.map(event => {
        const { status, nombre_evento } = event
        // console.log('event', event)
        return `
        <div class="cont">
            <div class="flex ver cen mini-gap">
                <div>${nombre_evento}</div>
                <div class="status-tag ${eventStatus[status].className}">
                <div class="tag-icon"></div>
                <div>${eventStatus[status].text}</div>
                <div
                    title="${eventStatus[status].text}"
                    tooltipster="top"
                    class="tooltip-icon"
                >
                    ?
                </div>
                </div>
            </div>
        </div>
        `
        return `<div class="cont">
            <div class="flex ver cen mini-gap">
            <div>${nombre_evento}</div>
            <div class="status-tag ${eventStatus[status].className}">
                <div class="tag-icon ${eventStatus[status].className}"></div>
                <div>${eventStatus[status].text}</div>
            </div>
            </div>
        </div>`
    })
}
function handleString(string) {
    return string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
}
async function setGuestsData(collId, guestLoader) {
    let guestsStatus = []
    $('#guest-loading-' + collId).removeClass('d-none')
    guestLoader.on()
    var guestsData = ''
    $('#no_guests_container' + collId).addClass('d-none')
    var eventsData = JSON.parse($('#se_data' + collId).attr('data'))
    var eventsids = JSON.parse($('#se_data_ids' + collId).attr('data'))
    var guestCount = 0
    guestsData = await customersList(collId)
    if (guestsData.data.length == 0) {
        $('#noGuests' + collId).removeClass('d-none')
    }
    for (let i = 0; i < guestsData.data.length; i++) {
        var guest = guestsData.data[i]
        console.log(guest)
        guestsStatus.push([])
        console.log(guestsStatus)
        var events = guest.eventos
        var boletos = events.map((event) => event.boletos)
        var confirm = events.map((event) => event.boletos_confirmados == null ? 0 : event.boletos_confirmados)
        console.log(events)
        if (events.length > 0) {
            var nota = 'Nota: ' + events[0].mensaje
            if (nota == 'Nota: null' || nota == null || nota == undefined) {
                nota = ''
            }
        } else {
            var nota = ''
        }
        var events_data = ''
        var boletos_data = ''
        var allStatus = []
        var guestFestejado = ''
        var guestGrupo
        var eventsNames = []
        var customerEventsNames = []
        var generalCount = 0
        var confirm_data = ''
        console.log('eventos -------------------------------------------')
        for (const event of events) {
            console.log(event)
            var status
            var eventName
            var principal = false
            guestFestejado = event.festejado
            guestGrupo = event.grupo
            for (let i = 0; i < eventsids.length; i++) {
                if (eventsids[i] == event.evento) {
                    eventName = eventsData[i].nombre_del_evento
                    if (eventsData[i].jerarquia_de_evento == "Principal") {
                        principal = true
                    }
                }
            }
            guestsStatus[guestCount].push({ "event": eventName, "principal": principal, "guest": guest.nombre, "status": event.status, "grupo": event.grupo, "festejado": event.festejado, "boletos": event.boletos, "confirmados": event.boletos_confirmados })
            eventsNames.push(JSON.stringify(event.evento))
            if (event.status == 'Invitado') {
                status = `<div class="status-tag no-invite">
                                  <div class="tag-icon no-invite"></div>
                                  <div>Sin Invitación</div>
                                </div>`
            } else if (event.status == 'Invitación Enviada') {
                status = `<div class="status-tag pending">
                                  <div class="tag-icon pending"></div>
                                  <div>Pendiente</div>
                                </div>`
            } else if (event.status == 'Confirmado') {
                status = `<div class="status-tag confirmed">
                                  <div class="tag-icon confirmed"></div>
                                  <div>asistirá</div>
                                </div>`
            } else {
                status = `<div class="status-tag cancelled">
                                  <div class="tag-icon cancelled"></div>
                                  <div>No asistirá</div>
                                </div>`
            }
            allStatus.push(event.status)
            events_data = events_data + '<div>' + eventName + '</div>' + status
            boletos_data = boletos_data + `<div class="cont">
          <div class="flex ver cen mini-gap">
            <div>${eventName}</div>
            <div class="status-tag">
              <div>${boletos[generalCount]} Boletos</div>
            </div>
          </div>
        </div>`
            confirm_data = confirm_data + `<div class="cont">
        <div class="flex ver cen mini-gap">
          <div>${eventName}</div>
          <div class="status-tag">
            <div>${confirm[generalCount]} Confirmados</div>
          </div>
        </div>
      </div>`
            customerEventsNames.push(eventName)
            generalCount++
        }
        console.log(guest)
        if (guestGrupo == undefined || guestGrupo == null) {
            guestGrupo = ''
        }
        $('#guests_container' + collId).append(`<div id="customerRow${guest.gid.replace('gid://shopify/Customer/', '')}" class="db-invite-table-row data-row guest${collId} todos result ${customerEventsNames.join().replaceAll(' ', '-').replaceAll('(', '-').replaceAll(')', '-').replaceAll('.', '-').replaceAll('|', '-').replaceAll(':', '-').replaceAll(',', ' ')} ${guestFestejado.replaceAll(' ', '-').replaceAll('(', '-').replaceAll('|', '-').replaceAll(')', '-').replaceAll('.', '-').replaceAll(':', '-').replaceAll(',', ' ')} ${guestGrupo.replaceAll(' ', '-')} ${allStatus.join().replaceAll(' ', '-').replaceAll(',', ' ')}">
                      <div class="table-col name">
                      <div class="flex ver left mid mini-gap">
                      <label class="w-checkbox table-check" onclick="verifyGuestsCheck('${collId}')">
                          <div class="w-checkbox-input w-checkbox-input--inputType-custom check-btn guest_check check_guests_${collId} todos ${customerEventsNames.join().replaceAll(' ', '-').replaceAll('(', '-').replaceAll(')', '-').replaceAll('.', '-').replaceAll('|', '-').replaceAll(':', '-').replaceAll(',', ' ')}" customerid="${guest.gid}" name="${guest.nombre}" lname="${guest.apellido}" events='[${eventsNames}]' email="${guest.email != null ? guest.email : ''}" tel="${guest.telefono != null ? guest.telefono : ''}" festejado="${guestFestejado}" grupo="${guestGrupo}" tickets="[${boletos}]" confirmados="[${confirm}]"></div>
                          <input type="checkbox" id="user-name-3" name="user-name-3" data-name="User Name 3" style="opacity:0;position:absolute;z-index:-1">
                          <span class="check-label w-form-label guest_name" for="user-name-3">${guest.nombre} ${guest.apellido}</span>
                        </label>
                        <p class="guest-note">${nota} </p>
                        </div>
                        </div>
                      <div class="table-col">
                        ${guestFestejado} | ${guestGrupo}
                      </div>
                      <div class="table-col">
                        <div class="flex ver cen mid mini-gap">
                          <a href="mailto:${guest.email}">${guest.email != null ? guest.email : ''}</a>
                          <a href="tel:${guest.telefono}">${guest.telefono != null ? guest.telefono : ''}</a>
                        </div>
                      </div>
                      <div class="table-col">
                        <div class="flex ver cen mid small-gap">
                          ${boletos_data}
                        </div>
                      </div>
                      <div class="table-col">
                        <div class="flex ver cen mid small-gap">
                          ${confirm_data}
                        </div>
                      </div>
                      <div class="table-col">
                        <div class="flex ver cen mid small-gap">
                          <div class="cont">
                            <div class="flex ver cen mini-gap">
                              ${events_data}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>`)
        guestCount++
    }

    $('#guest-loading-' + collId).addClass('d-none')
    guestLoader.off()
    console.log('guestsStatus', guestsStatus)
    return guestsStatus
}


async function setGiftsData(colId) {
    console.log('entra al query:" ' + colId)
    var currentColId = colId
    query = `query:"tag:'${currentColId}'"`
    var orderData = ''
    var cenOrders = true
    console.log('sigue' + currentColId)
    do {
        console.log('entra')
        await new Promise((resolve) => {
            setTimeout(async function () {
                console.log('sigue2' + currentColId)
                var orders = []
                if (orderData != '') {
                    cursor = orderData.data.orders.pageInfo.endCursor
                    query = `query:"tag:'${currentColId}'", after:"${cursor}"`
                }
                console.log('sigue3' + currentColId)
                orderData = await getOrdersData(query)
                console.log('sigue4' + currentColId)
                console.log(query + 'col ' + currentColId)
                console.log(orderData)
                for (let i = 0; i < orderData.data.orders.edges.length; i++) {
                    console.log('entra a agregar row')
                    await addGiftRow(currentColId, orderData.data.orders.edges[i].node)
                    console.log('termina los rows')
                }
                resolve();
            }, 30)
        });
        console.log('sale')
    } while (orderData.data.orders.pageInfo.hasNextPage)

}

async function addGiftRow(colId, order) {
    console.log('entra al row' + colId)
    console.log('la orden es ')
    console.log(order)
    $('#retiro-btn' + colId).removeClass('d-none')
    $('#gift_no_table' + colId).addClass('d-none')
    $('.gift-chart' + colId).removeClass('d-none')
    var orderInfo = order
    var orderDe
    var orderPara
    var orderDedicatoria
    var orderAgradecimiento
    var note = []
    orderInfo.metafields.edges.forEach(metafield => {
        if (metafield.node.key == 'quien_regala') {
            orderDe = metafield.node.value
        }
        if (metafield.node.key == 'para') {
            orderPara = metafield.node.value
        }
        if (metafield.node.key == 'dedicatoria') {
            orderDedicatoria = metafield.node.value
        }
        if (metafield.node.key == 'agradecimiento') {
            orderAgradecimiento = metafield.node.value
        }
        if (metafield.node.key == 'informaci_n_de_productos') {
            note = JSON.parse(metafield.node.value)
        }
        console.log(metafield.node.key)
        console.log(metafield.node.value)
        console.log(note)
    })
    console.log(orderInfo.id)
    var gratitude
    var orderCustomerEmail = orderInfo.email
    var product_count = -1
    var productArrayIds = []
    var productArrayPrices = []
    for (let i = 0; i < orderInfo.lineItems.edges.length; i++) {
        product_count++
        if (orderInfo.lineItems.edges[i].node.product != null) {
            productArrayPrices.push(orderInfo.lineItems.edges[i].node.originalUnitPriceSet.shopMoney.amount)
            productArrayIds.push(orderInfo.lineItems.edges[i].node.product.legacyResourceId)
        }
    }
    if ($('#isAdmin' + colId).attr('data') == 'true') {
        if (orderDe != undefined && orderPara != undefined && orderDedicatoria != undefined) {
            gratitude = `<div>De: ${orderDe}</div>
                    <div>Para: ${orderPara}</div>
                    <a onclick="showCongratulationModal([${productArrayIds}],'${orderDe}','${orderPara}','${orderDedicatoria.replace(/(?:\r\n|\r|\n)/g, '. ')}','${orderCustomerEmail}','${orderInfo.legacyResourceId}','${orderInfo.customer.displayName}','${colId}',[${productArrayPrices}])" href="#">Ver Mensaje</a>`
        } else {
            gratitude = `<div class="light-grey-txt">De: ${orderInfo.customer.displayName}</div><div class="light-grey-txt">Sin Mensaje</div>
      <a onclick="agradecimientoSinMensaje('${orderInfo.legacyResourceId}','${colId}','${orderCustomerEmail}','${orderInfo.customer.displayName}')" href="#">Agradecer</a>`
        }
    } else {
        if (orderDe != undefined && orderPara != undefined && orderDedicatoria != undefined) {
            gratitude = `<div>De: ${orderDe}</div>
                    <div>Para: ${orderPara}</div>`
        } else {
            gratitude = `<div class="light-grey-txt">De: ${orderInfo.customer.displayName}</div><div class="light-grey-txt">Sin Mensaje</div>
            <a onclick="agradecimientoSinMensaje('${orderInfo.legacyResourceId}','${colId}','${orderCustomerEmail}','${orderInfo.customer.displayName}')" href="#">Agradecer</a>`
        }
    }
    var products_content = []
    var count = -1
    for (let i = 0; i < orderInfo.lineItems.edges.length; i++) {
        if (orderInfo.lineItems.edges[i].node.product != null) {
            var productData = orderInfo.lineItems.edges[i].node.product
            if (productData.productType != "Comisión de Servicio") {
                count++
                var productCashout = ""
                var productFisico = ""
                console.log(note)
                var clase = ''
                if (orderInfo.displayFinancialStatus == 'REFUNDED') {
                    clase = 'refunded'
                }
                for (let i = 0; i < note.length; i++) {
                    if (note[i].id == productData.legacyResourceId) {
                        if (note[i].modalidad == 'fisico') {
                            productFisico = 'w--redirected-checked'
                        } else {
                            productCashout = 'w--redirected-checked'
                        }
                        break
                    }
                }
                var agradecimiento = ''
                if ($('#isAdmin' + colId).attr('data') == 'true') {
                    if (orderInfo.displayFinancialStatus != 'REFUNDED') {
                        if (orderAgradecimiento != null && orderAgradecimiento != undefined && orderAgradecimiento != "") {
                            agradecimiento = '<a onclick="showGratitudeModal(`' + orderAgradecimiento + '`)" href="#">Ver Agradecimiento</a>'
                        } else {
                            agradecimiento = `<div class="light-grey-txt">Sin Agradecimiento</div>`
                        }
                    } else {
                        agradecimiento = `<div></div>`
                    }
                }
                var lastColumns = ''
                if (orderInfo.displayFinancialStatus != 'REFUNDED') {
                    if (count == 0) {
                        lastColumns = `<div style="grid-row-end: span ${product_count + 1};" class="table-col">
                      <div class="flex ver cen mid mini-gap">
                        ${gratitude}
                      </div>
                    </div>
                    <div style="grid-row-end: span ${product_count + 1};" class="table-col">
                      <div class="flex ver cen mid mini-gap">
                        ${agradecimiento}
                      </div>
                    </div>`
                    } else {
                        lastColumns = ''
                    }
                } else {
                    lastColumns = `<div style="grid-row-end: span ${product_count + 1};" class="table-col">
                      <div class="flex ver cen mid mini-gap">
                      <div>De: ${orderInfo.customer.displayName}</div>
                      </div>
                    </div>
                    <div style="grid-row-end: span ${product_count + 1};" class="table-col">
                      <div class="flex ver cen mid mini-gap">
                      </div>
                    </div>`
                }
                if (productData.featuredImage != null) {
                    var image = productData.featuredImage.url
                } else {
                    var image = ''
                }
                var inputs = ''
                var qtts
                if (orderInfo.displayFinancialStatus != 'REFUNDED') {
                    qtts = `<div class="table-col">
          <div class="table-input-wrap">
            <div class="flex ver small-gap">
              <p>Pediste: <span class="want_${colId}${productData.legacyResourceId}"></span></p>
              <p>En este regalo: <span class="gift_${colId}${productData.legacyResourceId}">${orderInfo.lineItems.edges[i].node.currentQuantity}</span></p>
              <p>En total tienes: <span class="have_${colId}${productData.legacyResourceId}"></span></p>
            </div>
          </div>
        </div>`
                } else {
                    qtts = `<div class="table-col"></div>`
                }
                if (orderInfo.displayFinancialStatus != 'REFUNDED') {
                    inputs = `<label onclick="changeProductmodality('fisico','${orderInfo.legacyResourceId}','${productData.legacyResourceId}')" class="table-radio w-radio">
          <div id="fisico_${orderInfo.legacyResourceId}${productData.legacyResourceId}" product="${productData.legacyResourceId}" class="w-form-formradioinput w-form-formradioinput--inputType-custom ${orderInfo.legacyResourceId}${productData.legacyResourceId} table-radio-btn w-radio-input check-fisico-${colId} ${productFisico}" price="${parseFloat(orderInfo.lineItems.edges[i].node.originalUnitPriceSet.shopMoney.amount) * parseInt(orderInfo.lineItems.edges[i].node.currentQuantity)}" qty="${orderInfo.lineItems.edges[i].node.currentQuantity}"></div>
          <input type="radio" id="radio-3" name="radio" value="Radio" data-name="Radio 3" style="opacity:0;position:absolute;z-index:-1">
          <span class="table-radio-label w-form-label" for="radio-3">Físico</span>
        </label>
        <label onclick="changeProductmodality('cashout','${orderInfo.legacyResourceId}','${productData.legacyResourceId}')" class="table-radio w-radio">
          <div id="cashout_${orderInfo.legacyResourceId}${productData.legacyResourceId}" product="${productData.legacyResourceId}" class="w-form-formradioinput w-form-formradioinput--inputType-custom ${orderInfo.legacyResourceId}${productData.legacyResourceId} table-radio-btn w-radio-input check-cashout-${colId} ${productCashout}" price="${parseFloat(orderInfo.lineItems.edges[i].node.originalUnitPriceSet.shopMoney.amount) * parseInt(orderInfo.lineItems.edges[i].node.currentQuantity)}" qty="${orderInfo.lineItems.edges[i].node.currentQuantity}"></div>
          <input type="radio" id="radio-3" name="radio" value="Radio 2" data-name="Radio 3" style="opacity:0;position:absolute;z-index:-1">
          <span class="table-radio-label w-form-label" for="radio-3">Cashout</span>
        </label>`
                } else {
                    inputs = `<div class="delete-btn">Reembolsado</div>`
                }
                var procDate = (orderInfo.processedAt).split('T')[0].split('-')
                products_content.push(`<div class="table-col name">
                    <div class="table-check">
                      <img loading="lazy" src="${image}" alt="" class="table-check-img">
                      <div class="flex ver left mid mini-gap">
                        <div class="table-check-label table_gift_name">${productData.title}</div>
                        <div class="mini-par light-grey-txt">${productData.vendor}</div>
                        <div class="mini-par">${productData.productType}</div>
                        <div class="mini-par">${orderInfo.displayFinancialStatus === 'PARTIALLY_REFUNDED' ? 'Rembolso Parcial' : ''}</div>
                      </div>
                    </div>
                  </div>
                  <div class="table-col">
                    <div>${Shopify.formatMoney(orderInfo.lineItems.edges[i].node.originalUnitPriceSet.shopMoney.amount * 100)}</div>
                  </div>
                  <div class="table-col">
                    <div>${procDate[2] + '/' + procDate[1] + '/' + procDate[0]}</div>
                  </div>
                  <div class="table-col">
                    ${qtts}
                  </div>
                  <div class="table-col">
                    <div class="flex ver mid mini-gap">
                      ${inputs}
                    </div>
                  </div>
                  ${lastColumns}`)
            }
        } else {
            count++
            var productCashout = ""
            console.log(note)
            productCashout = 'w--redirected-checked'
            var agradecimiento
            if (orderAgradecimiento != null && orderAgradecimiento != undefined && orderAgradecimiento != "") {
                agradecimiento = '<a onclick="showGratitudeModal(`' + orderAgradecimiento + '`)" href="#">Ver Agradecimiento</a>'
            } else {
                agradecimiento = `<div class="light-grey-txt">Sin Agradecimiento</div>`
            }
            var lastColumns
            if (count == 0) {
                lastColumns = `<div style="grid-row-end: span ${product_count + 1};" class="table-col">
                    <div class="flex ver cen mid mini-gap">
                      ${gratitude}
                    </div>
                  </div>
                  <div style="grid-row-end: span ${product_count + 1};" class="table-col">
                    <div class="flex ver cen mid mini-gap">
                      ${agradecimiento}
                    </div>
                  </div>`
            } else {
                lastColumns = ''
            }
            var procDate = (orderInfo.processedAt).split('T')[0].split('-')
            products_content.push(`<div class="table-col name">
                    <div class="table-check">
                      <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0665/4636/8751/files/230403_-_Sellos_-_Comprobante_Artboard_13_copy_2.png?v=1680547953" alt="" class="table-check-img">
                      <div class="flex ver left mid mini-gap">
                        <div class="table-check-label table_gift_name">Certificado de Regalo</div>
                        <div class="mini-par light-grey-txt">Zépika</div>
                        <div class="mini-par">Certificado de Regalo</div>
                      </div>
                    </div>
                  </div>
                  <div class="table-col">
                    <div>${Shopify.formatMoney(orderInfo.lineItems.edges[i].node.originalUnitPriceSet.shopMoney.amount * 100)}</div>
                  </div>
                  <div class="table-col">
                    <div>${procDate[2] + '/' + procDate[1] + '/' + procDate[0]}</div>
                  </div>
                  <div class="table-col">
                    <div class="table-col">
                      <div class="table-input-wrap">
                        <div class="flex ver small-gap">
                          <p>Pediste: <span >${orderInfo.lineItems.edges[i].node.currentQuantity}</span></p>
                          <p>En este regalo: <span >${orderInfo.lineItems.edges[i].node.currentQuantity}</span></p>
                          <p>En total tienes: <span >${orderInfo.lineItems.edges[i].node.currentQuantity}</span></p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table-col">
                    <div class="flex ver mid mini-gap">
                      <label class="table-radio w-radio">
                        <div class="w-form-formradioinput w-form-formradioinput--inputType-custom ${orderInfo.legacyResourceId} table-radio-btn w-radio-input check-cashout-${colId} check-cashout ${productCashout}" product="" price="${parseFloat(orderInfo.lineItems.edges[i].node.originalUnitPriceSet.shopMoney.amount) * parseInt(orderInfo.lineItems.edges[i].node.currentQuantity)}" qty="${orderInfo.lineItems.edges[i].node.currentQuantity}"></div>
                        <input type="radio" id="radio-3" name="radio" value="Radio 2" data-name="Radio 3" style="opacity:0;position:absolute;z-index:-1">
                        <span class="table-radio-label w-form-label" for="radio-3">Cashout</span>
                      </label>
                    </div>
                  </div>
                  ${lastColumns}`)
        }
    }
    var content_formated = ''
    for (let j = 0; j < products_content.length; j++) {
        content_formated += products_content[j]
    }
    $('#gift_table' + colId).append(`<div class="db-mesa-table-row data-row table_gift${colId} ${clase}">${content_formated}</div>`)
    console.log('sale de la funcion de row')
}

function showGratitudeModal(message) {
    $('.modal-fix.gratitude').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.gratitude').css('opacity', '1')
    $('#gratitude_message').text(message)
}

function filterData(input, collId) {
    console.log('filtra ' + input)
    $('.guest' + collId).each(function () {
        if ($(this).hasClass('result')) {
            if (!$(this).find('.guest_name').text().toLowerCase().includes(input.toLowerCase())) {
                $(this).slideUp()
            } else {
                $(this).slideDown()
            }
        }
    })
}
function searchGuestRows(input, collectionId, type) {
    $(`#guests_container-${type}-${collectionId} .guest${collectionId}`).each(function () {
        if ($(this).hasClass('result')) {
            if (!$(this).find('.guest_name').text().toLowerCase().includes(input.toLowerCase())) {
                $(this).slideUp()
            } else {
                $(this).slideDown()
            }
        }
    })
}

var cen_guests = true
function setGuestEditing(guestData) {

}

function selectAllGuestsByType(event, collectionId, type) {
    const closetLabel = event.target.closest('.w-checkbox')
    const checkbox = closetLabel.querySelector('.w-checkbox-input')
    const container = document.querySelector(`#guests_container-${type}-${collectionId}`)
    const inputs = container.querySelectorAll('.check_guests_' + collectionId)
    if (!checkbox.classList.contains('w--redirected-checked')) {
        inputs.forEach(input => {
            input.classList.add('w--redirected-checked')
            $(`#delete_guest-${type}-${collectionId}`).slideDown()
            $(`#evnInv-${type}-${collectionId}`).slideDown()
            $(`#edit_guest-${type}-${collectionId}`).slideUp()
        })
    } else if (checkbox.classList.contains('w--redirected-checked')) {
        inputs.forEach(input => {
            input.classList.remove('w--redirected-checked')
            $(`#delete_guest-${type}-${collectionId}`).slideUp()
            $(`#evnInv-${type}-${collectionId}`).slideUp()
        })
    }
    return
}
function showActions(event, collectionId, type) {
    const closetLabel = event.target.closest('.w-checkbox')
    const checkboxType = closetLabel.getAttribute('data-checkbox-type')
    const checkbox = closetLabel.querySelector('.w-checkbox-input')
    const rowsContainer = document.querySelector(`#guests_container-${type}-${collectionId}`)
    const inputs = rowsContainer.querySelectorAll(`.check_guests_${collectionId}`)
    let currentActive = Array.from(inputs).filter(input => {
        return input.classList.contains('w--redirected-checked')
    })
    if (!checkbox.classList.contains('w--redirected-checked')) {
        $(`#delete_guest-${type}-${collectionId}`).slideDown()
        $(`#evnInv-${type}-${collectionId}`).slideDown()
        if (currentActive.length === 0) {
            $(`#edit_guest-${type}-${collectionId}`).slideDown()
        } else {
            $(`#edit_guest-${type}-${collectionId}`).slideUp()
        }
    } else if (checkbox.classList.contains('w--redirected-checked')) {
        if (currentActive.length <= 1) {
            $(`#edit_guest-${type}-${collectionId}`).slideUp()
            $(`#delete_guest-${type}-${collectionId}`).slideUp()
            $(`#evnInv-${type}-${collectionId}`).slideUp()
        }
    }
    // if (currentActive.length <= 1) {
    //     if (!checkbox.classList.contains('w--redirected-checked') && checkboxType === 'guest-row') {
    //         $(`#edit_guest-${type}-${collectionId}`).slideDown()
    //         $(`#delete_guest-${type}-${collectionId}`).slideDown()
    //         return
    //     }
    // } else {
    //     $(`#edit_guest-${type}-${collectionId}`).slideUp()
    //     $(`#delete_guest-${type}-${collectionId}`).slideUp()
    // }
    // if (currentActive.length > 1) {
    //     $(`#delete_guest-${type}-${collectionId}`).slideDown()
    //     $(`#evnInv-${type}-${collectionId}`).slideDown()
    //     return
    // } else {
    //     $(`#delete_guest-${type}-${collectionId}`).slideUp()
    //     $(`#evnInv-${type}-${collectionId}`).slideUp()
    //     return
    // }
    // const checkbox = event.querySelector('.w-checkbox-input')
    // const closetLabel = event.target.closest('.w-checkbox')
    // 
    // console.log(checkboxType)
    return
    const actionContainer = document.querySelector(`#actions-${type}-${collectionId}`)
    const deleteBtn = actionContainer.querySelector(`#delete_guest-${type}-${collectionId}`)
    if (!checkbox.classList.contains('w--redirected-checked')) {
        if (inputs.length > 1) {
            $(`#edit_guest-${type}-${collectionId}`).slideDown()
        } else {
            $(`#edit_guest-${type}-${collectionId}`).slideUp()
        }
    }
    return
    setTimeout(() => {
        if (cenGuestsCheck) {
            var showDelete = false
            var selected = 0
            var table_guests_checks = $('.check_guests_' + colId)
            table_guests_checks.each(function () {
                if ($(this).hasClass('w--redirected-checked')) {
                    showDelete = true
                    selected++
                }
            })
            if (selected == 1) {
                $('#edit_guest' + colId).slideDown()
            } else {
                $('#edit_guest' + colId).slideUp()
            }
            if (showDelete) {
                $('#delete_guest' + colId).slideDown()
                $('#evnInv' + colId).slideDown()
            } else {
                $('#delete_guest' + colId).slideUp()
                $('#evnInv' + colId).slideUp()
            }
            cenGuestsCheck = false
        } else {
            cenGuestsCheck = true
        }
    }, 300)
}

function selectAllGuests(e, colId, type) {
    if (cen_guests) {
        if (e.classList.contains('w--redirected-checked')) {
            $('.check_guests_' + colId).each(function () {
                if ($(this).closest(".db-invite-table-row").is(":visible")) {
                    $(this).removeClass('w--redirected-checked')
                }
            })
            cen_guests = false
            e.classList.remove('w--redirected-checked')
        } else {
            $('.check_guests_' + colId).each(function () {
                if ($(this).closest(".db-invite-table-row").is(":visible")) {
                    $(this).addClass('w--redirected-checked')
                }
            })
            cen_guests = false
            e.classList.add('w--redirected-checked')
        }
    } else {
        cen_guests = true
    }
    verifyGuestsCheck(colId)
}

var cenGuestsCheck = true
var cenGuestsCheck = true

function verifyGuestsCheck(colId) {
    setTimeout(() => {
        if (cenGuestsCheck) {
            var showDelete = false
            var selected = 0
            var table_guests_checks = $('.check_guests_' + colId)
            table_guests_checks.each(function () {
                if ($(this).hasClass('w--redirected-checked')) {
                    showDelete = true
                    selected++
                }
            })
            if (selected == 1) {
                $('#edit_guest' + colId).slideDown()
            } else {
                $('#edit_guest' + colId).slideUp()
            }
            if (showDelete) {
                $('#delete_guest' + colId).slideDown()
                $('#evnInv' + colId).slideDown()
            } else {
                $('#delete_guest' + colId).slideUp()
                $('#evnInv' + colId).slideUp()
            }
            cenGuestsCheck = false
        } else {
            cenGuestsCheck = true
        }
    }, 300)
}
var deleteGuestColId
async function showDeleteGuestModal(collectionId, type) {
    $('#deleteGuestError').slideUp()
    $('#deleteGuestDone').slideUp()
    $('#deleteGuestForm').slideDown()
    $('.modal-fix.deleteGuest').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.deleteGuest').css('opacity', '1')
    const guestContainer = document.querySelector(`#guests_container-${type}-${collectionId}`)
    const inputs = guestContainer.querySelectorAll(`.check_guests_${collectionId}.w--redirected-checked`)
    document.querySelector('#comfirm-delete-check div.w-checkbox-input').classList.remove('w--redirected-checked')
    $('#deleteGuestsCount').text(inputs.length)
    if (inputs.length > 0) {
        document.querySelector('#submit-delete-button').onclick = () => deleteGuest(collectionId, type)
    } else {
        $('#deleteGuestError').text('Debe selecionar al menos 1 Invitado para eliminar de tu lista').slideDown()
    }
    return
    let deleteCount = 0
    let table_guests_checks = $('.check_guests_' + collectionId)
    table_guests_checks.each(function () {
        if ($(this).hasClass('w--redirected-checked')) {
            deleteCount++
        }
    })
    $('#deleteGuestsCount').text(deleteCount)
    deleteGuestColId = colId
}

async function deleteGuest(collectionId, type) {
    generalLoader.on()
    $('.loader-msg').text('Eliminando invitados')
    $('#deleteGuestError').text('Debes confirmar la acción').slideUp()
    const guestContainer = document.querySelector(`#guests_container-${type}-${collectionId}`)
    const inputs = guestContainer.querySelectorAll(`.check_guests_${collectionId}.w--redirected-checked`)
    const comfirm = document.querySelector(`#comfirm-delete-check .w-checkbox-input`)
    if (!comfirm.classList.contains('w--redirected-checked')) {
        $('#deleteGuestError').text('Debes confirmar la acción').slideDown()
        generalLoader.off()
        return
    }
    const guestToDelete = Array.from(inputs).map(input => {
        return {
            id: input.getAttribute('customerid'),
            events: input.getAttribute('events'),
            type: input.getAttribute('guest-type')
        }
    })
    const body = {
        collection_id: collectionId,
        guests: guestToDelete
    }
    const url = `${productionUrl}${candidateVersion}/collections/inviation/delete`
    const response = await fetchData(url, 'POST', body)
    //const response = { status: true }
    if (response.status) {
        inputs.forEach(input => {
            input.closest('.db-invite-table-row').remove()
        })
        $('#deleteGuestForm').slideUp()
        $('#deleteGuestDone').slideDown()
        generalLoader.off()
    }
    return
    generalLoader.on()
    $('.loader-msg').text('Eliminando invitados')
    var table_guests_checks = $('.check_guests_' + deleteGuestColId)
    var eventsids = JSON.parse($('#se_data_ids' + deleteGuestColId).attr('data'))
    table_guests_checks.each(async function () {
        if ($(this).hasClass('w--redirected-checked')) {
            var customerId = $(this).attr('customerid')
            var metafields = await getCustomerMetafield(customerId.replace('gid://shopify/Customer/', ''))
            var newEvents = []
            for (met of metafields) {
                if (met.key == "mis_eventos") {
                    newEvents = JSON.parse(met.value)
                }
            }
            for (const event of newEvents) {
                var eventData = await getMetaObjectData(event)
                if (eventsids.includes(eventData.data.metaobject.fields[0].value)) {
                    newEvents.splice(newEvents.indexOf(event), 1)
                }
            }
            await addCustomerMetafield(customerId.replace('gid://shopify/Customer/', ''), { "namespace": "custom", "key": "mis_eventos", "type": "list.metaobject_reference", "value": JSON.stringify(newEvents) })
            var customerData = await getCustomerData(customerId)
            var tags = []
            if (customerData.data.customer.tags.length > 0) {
                tags = customerData.data.customer.tags
            }
            tags.splice(tags.indexOf(deleteGuestColId + '-i'), 1)
            await updateCustomerTag(customerId, tags)
            $('#customerRow' + customerId.replace('gid://shopify/Customer/', '')).remove()
        }
    })
    $('#deleteGuestForm').slideUp()
    setTimeout(() => {
        $('#deleteGuestDone').slideDown()
    }, 300)
    generalLoader.off()
}

var editGuestColId
var editCustomerEvents
var editCustomerId
async function showEditGuestModal(colId) {
    $('#editGuestForm').slideDown()
    $('#editGuestDone').slideUp()
    $('#editGuest-event-container').empty()
    $('#mei_celebrated').empty()
    $('.modal-fix.editGuest').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.editGuest').css('opacity', '1')
    editGuestColId = colId
    var festejados = []
    var festejadosData = ''
    var adminsData = ''
    var cursor = ''
    var query
    do {
        query = 'query: "tag:' + colId + '-f"'
        if (festejadosData != '') {
            cursor = festejadosData.data.customers.pageInfo.endCursor
            query = 'query: "tag:' + colId + '-f", after:"' + cursor + '"'
        }
        festejadosData = await getGuestsData(query)
        for (let i = 0; i < festejadosData.data.customers.edges.length; i++) {
            festejados.push(festejadosData.data.customers.edges[i])
        }
    } while (festejadosData.data.customers.pageInfo.hasNextPage)
    do {
        query = 'query: "tag:' + colId + '-admin"'
        if (adminsData != '') {
            cursor = adminsData.data.customers.pageInfo.endCursor
            query = 'query: "tag:' + colId + '-admin", after:"' + cursor + '"'
        }
        adminsData = await getGuestsData(query)
        if (adminsData.data.customers.edges.length > 0) {
            for (let i = 0; i < adminsData.data.customers.edges.length; i++) {
                festejados.push(adminsData.data.customers.edges[i])
            }
        }
    } while (adminsData.data.customers.pageInfo.hasNextPage)
    console.log('ya va a mostrar la data')
    console.log(festejados)
    for (let i = 0; i < festejados.length; i++) {
        $('#mei_celebrated').append(`<option value="${festejados[i].node.displayName}">${festejados[i].node.displayName}</option>`)
    }
    var table_guests_checks = $('.check_guests_' + colId)
    var cEvents = []
    var tickets
    var confirmados
    table_guests_checks.each(function () {
        if ($(this).hasClass('w--redirected-checked')) {
            console.log('entra con ' + $(this))
            $('#mei_name').val($(this).attr('name'))
            $('#mei_lastName').val($(this).attr('lname'))
            $('#mei_email').val($(this).attr('email'))
            $('#mei_tel').val($(this).attr('tel'))
            $('#mei_celebrated').val($(this).attr('festejado'))
            $('#mei_group').val($(this).attr('grupo'))
            tickets = JSON.parse($(this).attr('tickets'))
            confirmados = JSON.parse($(this).attr('confirmados'))
            cEvents = $(this).attr('events').split(',')
            editCustomerId = $(this).attr('customerid')
            editCustomerEvents = cEvents
        }
    })
    var events = JSON.parse($('#se_data' + colId).attr('data'))
    var eventsids = JSON.parse($('#se_data_ids' + colId).attr('data'))
    for (let i = 0; i < cEvents.length; i++) {
        cEvents[i] = cEvents[i].replaceAll('[', '').replaceAll(']', '').replaceAll('"', '')
    }
    console.log(cEvents)
    console.log(eventsids)
    ticketCount = 0
    for (let i = 0; i < events.length; i++) {
        if (cEvents.includes(eventsids[i])) {
            $('#editGuest-event-container').append(`<div class="event-invite-grid">
                          <label id="w-node-a78daa43-b702-7faa-ff83-b02a6e53d2bf-f13f242c" class="w-checkbox check">
                            <div name="${events[i].nombre_del_evento}" eventnmb="${i}" eventId="${eventsids[i]}" class="w-checkbox-input w-checkbox-input--inputType-custom check-btn events-check-edit w--redirected-checked"></div>
                            <input eventnmb="${i}" type="checkbox" id="checkbox" class="events-check-edit-input" name="checkbox" data-name="Checkbox" style="opacity:0;position:absolute;z-index:-1" checked>
                            <span class="check-label w-form-label" for="checkbox">${events[i].nombre_del_evento}</span>
                          </label>
                          <div id="w-node-f15189a6-6e08-0800-6768-1c10d1aa9c8d-f13f242c">
                            <input id="edit-eventnmb${i}" value="${tickets[ticketCount]}" type="number" class="input w-node-ac55f77c-38e7-2187-4677-d4c887e9d31a-f13f242c w-input ticket-edit-input" maxlength="256" name="Tel-fono" data-name="Teléfono" min="0" placeholder="Boletos">
                          </div>
                          <div id="w-node-_01237c90-c33b-e446-dfb4-c2a4a77a1330-f13f242c">
                            <input id="edit-eventcnf${i}" value="${confirmados[ticketCount]}" type="number" class="input w-node-ac55f77c-38e7-2187-4677-d4c887e9d31a-f13f242c w-input ticket-input" maxlength="256" name="Tel-fono" data-name="Teléfono" min="0" placeholder="Confirmados">
                          </div>
                        </div>
                      `)
            ticketCount++
        } else {
            $('#editGuest-event-container').append(`<div class="event-invite-grid">
                  <label id="w-node-a78daa43-b702-7faa-ff83-b02a6e53d2bf-f13f242c" class="w-checkbox check">
                    <div name="${events[i].nombre_del_evento}" eventnmb="${i}" eventId="${eventsids[i]}" class="w-checkbox-input w-checkbox-input--inputType-custom check-btn events-check-edit"></div>
                    <input eventnmb="${i}" type="checkbox" id="checkbox" class="events-check-edit-input" name="checkbox" data-name="Checkbox" style="opacity:0;position:absolute;z-index:-1">
                    <span class="check-label w-form-label" for="checkbox">${events[i].nombre_del_evento}</span>
                  </label>
                  <div id="w-node-f15189a6-6e08-0800-6768-1c10d1aa9c8d-f13f242c">
                    <input id="edit-eventnmb${i}" type="number" class="input w-node-ac55f77c-38e7-2187-4677-d4c887e9d31a-f13f242c w-input ticket-edit-input" maxlength="256" name="Tel-fono" data-name="Teléfono" min="0" disabled placeholder="Boletos">
                  </div>
                  <div id="w-node-_01237c90-c33b-e446-dfb4-c2a4a77a1330-f13f242c">
                    <input id="edit-eventcnf${i}" type="number" class="input w-node-ac55f77c-38e7-2187-4677-d4c887e9d31a-f13f242c w-input ticket-input" maxlength="256" name="Tel-fono" data-name="Teléfono" min="0" disabled placeholder="Confirmados">
                  </div>
                </div>`)

        }
    }

    $('.events-check-edit-input').each(function () {
        $(this).on('change', function () {
            if ($(this).prop('checked')) {
                $('#edit-eventnmb' + $(this).attr('eventnmb')).prop('disabled', false)
                $('#edit-eventnmb' + $(this).attr('eventnmb')).val($('#mei_tickets').val())
            } else {
                $('#edit-eventnmb' + $(this).attr('eventnmb')).prop('disabled', true)
                $('#edit-eventnmb' + $(this).attr('eventnmb')).val(0)
            }
        })
    })
    if ($('#mei_tickets').length > 0) {
        $('#mei_tickets').on('change', function () {
            $('.ticket-edit-input').each(function () {
                if (!$(this).prop('disabled')) {
                    $(this).val($('#mei_tickets').val())
                }
            })
        })
    }
}


async function addOldGuest() {
    var mainGuestName = $('#mei_name').val()
    var mainGuestLastName = $('#mei_lastName').val()
    var mainGuestEmail = $('#mei_email').val()
    var mainGuestTel = $('#mei_tel').val()
    var celebrated = $('#mei_celebrated').val()
    var group = $('#mei_group').val()
    var guestId = $('#col_guest' + editGuestColId).attr('valueId')
    var eventos = []
    var events = []
    var boletos = []
    var events = []
    var confirmados = []
    $('.events-check-edit').each(function () {
        if ($(this).hasClass('w--redirected-checked')) {
            events.push($(this).attr('eventId'))
            if ($('#edit-eventnmb' + $(this).attr('eventnmb')).val() != '' && $('#edit-eventnmb' + $(this).attr('eventnmb')).val() != undefined && $('#edit-eventnmb' + $(this).attr('eventnmb')).val() != null) {
                boletos.push($('#edit-eventnmb' + $(this).attr('eventnmb')).val())
                confirmados.push($('#edit-eventcnf' + $(this).attr('eventnmb')).val())
            }
        }
    })
    console.log('events')
    console.log(events)
    console.log(boletos)
    for (sEvent of editCustomerEvents) {
        if (!events.includes(sEvent)) {
            editCustomerEvents.splice(editCustomerEvents.indexOf(sEvent), 1)
        }
    }
    if (mainGuestName != '' && mainGuestLastName != '' && mainGuestEmail != '' && mainGuestTel != '' && celebrated != '' && group != '' && events.length > 0 && boletos.length == events.length) {
        $('#manualGuestError').slideUp()
        generalLoader.on()
        $('.loader-msg').text('Guardando cambios')
        eventsObjects = []
        var metafields = await getCustomerMetafield(editCustomerId.replace('gid://shopify/Customer/', ''))
        var newEvents = []
        for (met of metafields) {
            if (met.key == "mis_eventos") {
                newEvents = JSON.parse(met.value)
            }
        }
        var data = []
        for (const ne of newEvents) {
            data.push(await getMetaObjectData(ne))
        }
        var newEvents2 = []
        for (let k = 0; k < data.length; k++) {
            if (!events.includes(data[k].data.metaobject.fields[0].value)) {
                newEvents2.push(newEvents[k])
            }
        }
        newEvents = newEvents2
        console.log(newEvents)
        eventCount = 0
        for (sEvent of events) {
            newEvents.push(await createGuestInvitationObject(sEvent, (confirmados[eventCount] == '' || confirmados[eventCount] == 0 ? 'Invitado' : 'Confirmado'), celebrated, group, boletos[eventCount], (confirmados[eventCount] == '' ? 0 : confirmados[eventCount])))
            eventCount++
        }
        console.log(newEvents)
        await updateGuest(editCustomerId, mainGuestName, mainGuestLastName, mainGuestEmail, mainGuestTel)
        await addCustomerMetafield(editCustomerId.replace('gid://shopify/Customer/', ''), { "namespace": "custom", "key": "mis_eventos", "type": "list.metaobject_reference", "value": JSON.stringify(newEvents) })
        $('#editGuestForm').slideUp()
        $('#editGuestDone').slideDown()
        $('#editGuestError').slideUp()
        generalLoader.off()
    } else {
        $('#editGuestError').slideDown()
    }
    return 0
}

//Funciones para el Carrito

function showDedicationModal() {
    $('.modal-fix.dedication').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.dedication').css('opacity', '1')
}

function setCartNote(customerName, dedication) {
    let name = ""

    const fromNote = document.querySelector('#CN_from').value
    const toNote = document.querySelector('#CN_to').value
    const dedicationNote = document.querySelector('#CN_note').value
    const cartNote = document.querySelector('#CartNote')
    const lineItemCID = document.querySelector('.cart-item').getAttribute('colid')
    let collectionID
    if (lineItemCID != "") {
        collectionID = lineItemCID
        console.log("getting from lineItemCID")
    } else {
        collectionID = window.localStorage.getItem('collectionID')
        console.log("getting from localStorage")
    }
    if (fromNote != "") {
        name = $('#CN_from').val()
    } else {
        name = customerName
    }
    const jsonData = JSON.stringify({
        "De": name,
        "Productos": [],
        "Para": toNote,
        "Dedicatoria": dedicationNote,
        "Enviado": false,
        "Collection": collectionID
    })
    if (dedication) {
        cartNote.value = `De: ${name} LineBreak
    Para: ${toNote} LineBreak
    Dedicatoria: ${dedicationNote} LineBreak
    ${jsonData}`
    } else {
        cartNote.value = jsonData
    }

    console.log(cartNote.value)
    //     $('#CartNote').val(`De: ${name} LineBreak
    //   Para: ${$('#CN_to').val()} LineBreak
    //   Dedicatoria: ${$('#CN_note').val()}
    //   ` + JSON.stringify({
    //         "De": name,
    //         "Productos": [],
    //         "Para": $('#CN_to').val(),
    //         "Dedicatoria": $('#CN_note').val(),
    //         "Enviado": false,
    //         "Collection": $('.cart-item').first().attr('colid')
    //     }))
    document.getElementById('submitCart').click()
}

//Funciones del tab de mesa de regalos

var cen_table_products = true

function selectAllTableProducts(e, colId) {
    if (cen_table_products) {
        if (e.classList.contains('w--redirected-checked')) {
            $('.check_table_products_' + colId).each(function () {
                if (!$(this).hasClass('result')) {
                    $(this).removeClass('w--redirected-checked')
                }
            })
            cen_table_products = false
            e.classList.remove('w--redirected-checked')
        } else {
            $('.check_table_products_' + colId).each(function () {
                if (!$(this).hasClass('result')) {
                    $(this).addClass('w--redirected-checked')
                }
            })
            cen_table_products = false
            e.classList.add('w--redirected-checked')
        }
    } else {
        cen_table_products = true
    }
    verifyProductsCheck(colId)
}

var cenProductsCheck = true

function verifyProductsCheck(colId) {
    setTimeout(() => {
        if (cenProductsCheck) {
            var showButton = false
            var table_products_checks = $('.check_table_products_' + colId)
            table_products_checks.each(function () {
                if ($(this).hasClass('w--redirected-checked')) {
                    showButton = true
                }
            })
            console.log(showButton)
            /*
                  if(showButton){
                    $('#delete_product'+colId).slideDown()
                  }
                  else{
                    $('#delete_product'+colId).slideUp()
                  }*/
            cenProductsCheck = false
        } else {
            cenProductsCheck = true
        }
    }, 300)
}
var deletedProductsColId

function showDeleteProductModal(colId) {
    $('#form_done_delete_product').slideUp()
    $('#form_text_delete_product').slideDown()
    $('.modal-fix.delete_product').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.delete_product').css('opacity', '1')
    window.localStorage.setItem('deleteCollectionId', colId)

    let selectedProductsToDelete = 0
    let table_products_checks = $('.check_table_products_' + colId)
    table_products_checks.each(function () {
        if ($(this).hasClass('w--redirected-checked')) {
            selectedProductsToDelete++
        }
    })
    if (selectedProductsToDelete > 1) {
        $('#deleteProductsCount').text(selectedProductsToDelete + ' productos')
    } else {
        $('#deleteProductsCount').text(selectedProductsToDelete + ' producto')
    }
}

async function deleteTableProducts() {
    generalLoader.on()
    $('.loader-msg').text('Eliminando productos')
    const collectionId = window.localStorage.getItem('deleteCollectionId')

    const collectionMetafields = await getCollectionMetafield(collectionId)
    const productMetafield = collectionMetafields.find((metafield) => metafield.key == "productos")
    const products = JSON.parse(productMetafield.value)
    const selectedProducts = document.querySelectorAll(`.check_table_products_${collectionId}.w--redirected-checked`)
    const selectedProductsArray = Array.from(selectedProducts);

    if (selectedProductsArray.length <= 0) {
        generalLoader.off()
        $('#deletedProductsCount').text(selectedProductsArray.length)
        $('#cant_delete_delete_product').addClass('d-none')
        $('#form_done_delete_product').slideDown()
        $('#form_text_delete_product').slideUp()
        return
    }

    let productWithGift = 0
    const productsToDelete = products.filter((product) => {
        if (product == null) return false
        return selectedProductsArray.find((selectedProduct) => {
            const itsTheProduct = parseInt(product.id) === parseInt(selectedProduct.getAttribute('product'))
            if (itsTheProduct && product.recibidos >= 1) {
                productWithGift += 1
                return false;
            }
            return itsTheProduct
        });
    })

    if (productsToDelete.length <= 0) {
        if (productWithGift > 0) {
            $('#cant_delete_delete_product').removeClass('d-none')
            $('#noDeletedProductsCount').text(productWithGift)
        } else {
            $('#cant_delete_delete_product').addClass('d-none')
        }
        $('#deletedProductsCount').text(productsToDelete.length)
        $('#form_done_delete_product').slideDown()
        $('#form_text_delete_product').slideUp()
        generalLoader.off()
        return
    }
    const productsToJson = products.filter((product) => {
        return !productsToDelete.find((productToDelete) => productToDelete.id === product.id)
    })

    const productToDeleteIds = productsToDelete.map((product) => {
        const productQuery = `[data-product="${product.id}"]`
        document.querySelector(productQuery).remove()
        return `gid://shopify/Product/${product.id}`
    })

    const removeProductsResponse = await removeProductFromCollection(`gid://shopify/Collection/${collectionId}`, productToDeleteIds)

    if (removeProductsResponse.status) {
        if (productsToJson.length > 0) {
            const updateCollection = await addCollectionMetafield(collectionId, { "namespace": "custom", "key": "productos", "type": "json", "value": JSON.stringify(productsToJson) })

        } else {
            const updateCollection = await addCollectionMetafield(collectionId, { "namespace": "custom", "key": "productos", "type": "json", "value": JSON.stringify([null]) })

        }

    }
    if (productWithGift > 0) {
        $('#cant_delete_delete_product').removeClass('d-none')
        $('#noDeletedProductsCount').text(productWithGift)
    } else {
        $('#cant_delete_delete_product').addClass('d-none')
    }
    $('#deletedProductsCount').text(productsToDelete.length)
    $('#form_done_delete_product').slideDown()
    $('#form_text_delete_product').slideUp()
    generalLoader.off()
    if (productsToJson.length === 0) {
        window.location.reload(true)
    }
    return
}

function filterProductsData(input, collId) {
    $('.table_product' + collId).each(function () {
        if (!$(this).find('.table_product_name').text().toLowerCase().includes(input.toLowerCase())) {
            $(this).find('.table_product_check').addClass('result')
            $(this).slideUp()
        } else {
            $(this).find('.table_product_check').removeClass('result')
            $(this).slideDown()
        }
    })
}
function filterCustomerGift(input, collId) {
    $('.table_gift' + collId).each(function () {
        const gifterAttr = $(this).attr('gifter');
        if (gifterAttr && gifterAttr.toLowerCase().includes(input.toLowerCase())) {
            $(this).slideDown();
        } else {
            $(this).slideUp();
        }
    });
}

function filterGiftsData(input, collId) {
    $('.table_gift' + collId).each(function () {
        if (!$(this).find('.table_gift_name').text().toLowerCase().includes(input.toLowerCase())) {
            $(this).slideUp()
        } else {
            $(this).slideDown()
        }
    })
}

var congratulationsOrderId
var gratitudeEmail
var gratitudeName
var gratitudeCol
async function showCongratulationModal(products, de, para, dedicatoria, customerEmail, order, name, colId, prices) {
    console.log(products)
    $('#gratitude-form').slideUp()
    $('#felicitacion-grid').empty()
    $('.modal-fix.congratulation').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.congratulation').css('opacity', '1')
    $('#gratitude-done').slideUp()
    $('#gift-form').slideDown()
    gratitudeEmail = customerEmail
    gratitudeName = name
    gratitudeCol = colId
    var count = 1
    for (const product of products) {
        var productData = await getProductData("gid://shopify/Product/" + product)
        if (productData.data.product.productType != "Comisión de Servicio") {
            $('#felicitacion-grid').append(`<div class="flex ver cen mini-gap">
              <div class="cont narrow-cont">
                <div class="img-wrap prod-img-wrap">
                  <img id="congratulation_img" src="${productData.data.product.featuredImage.url}" loading="lazy" alt="" class="cover-img">
                </div>
              </div>
              <div id="congratulation_vendor" class="inconsolata">${productData.data.product.vendor}</div>
              <div id="congratulation_product" class="med-par">${productData.data.product.title}</div>
              <div id="congratulation_price" class="med-par">${Shopify.formatMoney(prices[count] * 100)}</div>
            </div>`)
            count++
        }
    }
    //console.log(dedicatoria)
    //console.log(de)
    //console.log(para)
    if (de) {
        $('#congratulation_from').text("De: " + de)
    }
    if (dedicatoria) {
        $('#congratulation_message').text(dedicatoria)
    }
    if (para) {
        $('#congratulation_to').text("Para: " + para)
    }
    congratulationsOrderId = order
}

function showGratitudeForm(value) {
    if (value == 1) {
        $('#gift-form').slideUp()
        $('#gratitude-form-input').slideDown()
        $('#gratitude-form').slideDown()
    } else {
        $('#gift-form').slideDown()
        $('#gratitude-form').slideUp()
    }
}

function agradecimientoSinMensaje(orderId, colId, email, name) {
    showGratitudeForm(1)
    $('#felicitacion-grid').empty()
    $('.modal-fix.congratulation').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.congratulation').css('opacity', '1')
    $('#gratitude-done').slideUp()
    congratulationsOrderId = orderId
    gratitudeCol = colId
    gratitudeEmail = email
    gratitudeName = name
}

async function sendGratitude() {
    console.log(congratulationsOrderId)
    congratulationsOrderId.replace('gid://shopify/Order/', '')
    console.log(congratulationsOrderId)
    addOrdernMetafield(congratulationsOrderId, { "namespace": "custom", "key": "agradecimiento", "type": "multi_line_text_field", "value": $('#gratitude_input').val() })
    $('#gratitude-form-input').slideUp()
    $('#gratitude-done').slideDown()
    await sendEmailGratitude($('#customerName' + gratitudeCol).attr('data'), $('#gratitude_input').val(), gratitudeEmail, gratitudeName)
    setTimeout(() => {
        location.reload()
    }, 2000)
}
var csvContentOriginal
$(document).ready(function () {
    if (document.getElementById('gratitude_input')) {
        document.getElementById('gratitude_input').addEventListener('input', (e) => {
            $('#gratitude_caracter_count').text(e.target.value.length)
        })
    }
    var inputFile = document.getElementById('csvFile');
    if (inputFile) {
        // Manejar el evento 'change' del elemento 'input'
        inputFile.addEventListener('change', () => {
            // Obtener la lista de archivos seleccionados
            var fileList = inputFile.files;

            // Si no se seleccionó ningún archivo, salir de la función
            if (fileList.length === 0) return;

            // Obtener la referencia al primer archivo seleccionado
            var file = fileList[0];

            // Crear un objeto 'FileReader' para leer el archivo
            var fileReader = new FileReader();

            // Manejar el evento 'load' del objeto 'FileReader'
            fileReader.addEventListener('load', () => {
                // Obtener el contenido del archivo
                var fileContent = fileReader.result;
                console.log(fileContent)

                console.log('entra al load')
                // Obtener el contenido del archivo
                fileContent = fileContent.split(/\r?\n|\r|\n/g)
                for (let i = 0; i < fileContent.length; i++) {
                    fileContent[i] = fileContent[i].split(',')
                }
                console.log(fileContent)
                /* for(let i = 1 ; i < fileContent.length ; i++){
                  console.log(i)
                  console.log(fileContent[i])
                  console.log(fileContent[i][6])
                  if(fileContent[i][6].includes(';')){
                    fileContent[i][6] = fileContent[i][6].split(';')
                  }
                }
                console.log(fileContent) */
                csvContentOriginal = fileContent
            });

            // Leer el archivo como texto
            fileReader.readAsText(file);
        });
    }


})

async function uploadFileCustomers() {
    var csvContent = csvContentOriginal
    if (csvContent != undefined) {
        console.log(csvContent)
        generalLoader.on()
        $('.loader-msg').text('Agregando invitados')
        var eventsData = JSON.parse($('#se_data' + guestColl).attr('data'))
        var eventsIds = JSON.parse($('#se_data_ids' + guestColl).attr('data'))
        var eventsError = false
        var pasa = true
        for (let i = 1; i < csvContent.length; i++) {
            if (!pasa) {
                eventsError = true
                break
            }
            var eventsObjects = []
            var objectsIds = []
            console.log(csvContent)
            console.log(csvContent[i][7])
            if (!Array.isArray(csvContent[i][7])) {
                csvContent[i][7] = csvContent[i][7].split('|')
            }
            if (!Array.isArray(csvContent[i][8])) {
                csvContent[i][8] = csvContent[i][8].split('|')
            }
            for (let k = 0; k < csvContent[i][7].length; k++) {
                console.log(csvContent[i][7].length)
                console.log(csvContent[i][7])
                for (let j = 0; j < eventsData.length; j++) {
                    console.log(csvContent[i][7][k] + '=' + eventsData[j].nombre_del_evento)
                    if (csvContent[i][7][k].toLowerCase().replaceAll('�', 'ñ') == eventsData[j].nombre_del_evento.toLowerCase()) {
                        eventsObjects.push(eventsIds[j])
                    }
                }
                console.log(eventsObjects)
            }
            console.log('Eventos: ')
            console.log(eventsObjects)
            console.log('length 1: ' + csvContent[i][7].length)
            console.log('length 2: ' + eventsObjects.length)
            if (eventsObjects.length != csvContent[i][7].length) {
                eventsError = true
            }
            if (eventsError) {
                break;
            }
            if (eventsObjects.length > 0) {
                var metafield = [{ "namespace": "custom", "key": "mis_eventos", "type": "list.metaobject_reference", "value": JSON.stringify(objectsIds) }]
                console.log('Aquí está la info del invitado')
                console.log(csvContent[i][0], csvContent[i][1], csvContent[i][2], metafield, csvContent[i][4], guestColl + '-i', csvContent[i][3])


                await verifyCustomer(csvContent[i][2], csvContent[i][0].replaceAll("'", ""), csvContent[i][1].replaceAll("'", ""), csvContent[i][3], csvContent[i][4]).then(async function (newUser) {
                    await new Promise(resolve => setTimeout(resolve, 1000));
                    if (newUser.status) {
                        var hasMetafield = false
                        var metafieldValue
                        var CustomerId
                        var newTags = []
                        var cId = await getCustomerData(newUser.customer.id)
                        console.log(cId)
                        console.log('----------------------------------------------------------------------')
                        var currentCustomerEventsObject = await verifyEvents(guestColl, cId.data.customer.legacyResourceId)
                        console.log(currentCustomerEventsObject.my_events)
                        if (currentCustomerEventsObject.my_events.length > 0) {
                            for (let n = 0; n < currentCustomerEventsObject.my_events.length; n++) {
                                console.log('Entra al loop de eventos')
                                console.log(currentCustomerEventsObject.my_events[n].evento)
                                console.log(eventsObjects)
                                eventsObjects.splice(eventsObjects.indexOf(currentCustomerEventsObject.my_events[n].evento), 1)
                            }
                        }
                        for (let j = 0; j < eventsObjects.length; j++) {
                            if (csvContent[i][5].toLowerCase() == 'familia') {
                                csvContent[i][5] = 'Familia'
                            }
                            if (csvContent[i][5].toLowerCase() == 'amigos') {
                                csvContent[i][5] = 'Amigos'
                            }
                            if (csvContent[i][5].toLowerCase() == 'amigos de la familia') {
                                csvContent[i][5] = 'Amigos de la Familia'
                            }
                            if (csvContent[i][5].toLowerCase() == 'trabajo') {
                                csvContent[i][5] = 'Trabajo'
                            }
                            objectsIds.push(await createGuestInvitationObject(eventsObjects[j], 'Invitado', csvContent[i][6], csvContent[i][5], (csvContent[i][8][j] == undefined ? 0 : csvContent[i][8][j]), 0))
                        }
                        active = false
                        CustomerId = 'gid://shopify/Customer/' + cId.data.customer.legacyResourceId
                        mainId = 'gid://shopify/Customer/' + cId.data.customer.legacyResourceId
                        if (cId.data.customer.tags.length > 0) {
                            newTags = cId.data.customer.tags
                        }
                        newTags.push(guestColl + '-i')
                        await updateCustomerTag(CustomerId, newTags)
                        if (cId.data.customer.metafields.edges.length > 0) {
                            for (metafield of cId.data.customer.metafields.edges) {
                                if (metafield.node.key == "mis_eventos") {
                                    hasMetafield = true
                                    metafieldValue = JSON.parse(metafield.node.value)
                                }
                            }
                        }
                        if (hasMetafield) {
                            console.log(metafieldValue)
                            console.log(objectsIds)
                            console.log(eventsObjects)
                            for (let i = 0; i < objectsIds.length; i++) {
                                metafieldValue.push(objectsIds[i])
                            }
                            await addCustomerMetafield(cId.data.customer.legacyResourceId, { "namespace": "custom", "key": "mis_eventos", "type": "list.metaobject_reference", "value": JSON.stringify(metafieldValue) })
                        } else {
                            await addCustomerMetafield(cId.data.customer.legacyResourceId, { "namespace": "custom", "key": "mis_eventos", "type": "list.metaobject_reference", "value": JSON.stringify(objectsIds) })
                        }
                    }
                })



                /* var cId = await getCustomerByEmail(csvContent[i][2])
                if(cId.data.customers.edges.length > 0){
                  var hasMetafield = false
                  var metafieldValue
                  var CustomerId
                  var newTags = []
                  CustomerId = cId.data.customers.edges[0].node.id
                  if(cId.data.customers.edges[0].node.tags.length > 0){
                    newTags = cId.data.customers.edges[0].node.tags
                  }
                  newTags.push(guestColl+'-i')
                  await updateCustomerTag(CustomerId,newTags)
                  if(cId.data.customers.edges[0].node.metafields.edges.length > 0){
                    for(metafield of cId.data.customers.edges[0].node.metafields.edges){
                      if(metafield.node.key == "mis_eventos"){
                        hasMetafield = true
                        console.log(metafield.node.value)
                        metafieldValue = JSON.parse(metafield.node.value)
                        console.log(metafieldValue)
                        for(let i = 0 ; i < metafieldValue.length ; i++){
                          var data = await getMetaObjectData(metafieldValue[i])
                          if(eventsObjects.includes(data.data.metaobject.fields[0].value)){
                            eventsObjects.splice(eventsObjects.indexOf(data.data.metaobject.fields[0].value), 1)
                          }
                        }
                        objectsIds = []
                        for(let j = 0 ; j < eventsObjects.length ; j++){
                          objectsIds.push(await createGuestInvitationObject(eventsObjects[j],'Invitado',csvContent[i][6],csvContent[i][5],(csvContent[i][8][j] == undefined ? 0 : csvContent[i][8][j]),0))
                        }
                      }
                    }
                  }
                  if(hasMetafield){
                    console.log(metafieldValue)
                    console.log(objectsIds)
                    console.log(eventsObjects)
                    for(let i = 0 ; i < objectsIds.length ; i++){
                      metafieldValue.push(objectsIds[i])
                    }
                    await addCustomerMetafield(cId.data.customers.edges[0].node.legacyResourceId,{"namespace": "custom","key": "mis_eventos","type": "list.metaobject_reference","value": JSON.stringify(metafieldValue)})
                  }
                  else{
                    await addCustomerMetafield(cId.data.customers.edges[0].node.legacyResourceId,{"namespace": "custom","key": "mis_eventos","type": "list.metaobject_reference","value": JSON.stringify(objectsIds)})
                  }
                } */
            }
        }
        if (eventsError) {
            generalLoader.off()
            $('#guestFile-form').slideUp()
            $('#guestFile-error').text('Hay un error en el archivo que intentaste subir, por favor intenta nuevamente.')
            $('#guestFile-error').slideDown()
        } else {
            $('#guestFile-form').slideUp()
            $('#guestFile-done').slideDown()
            setTimeout(() => {
                //location.reload()
                generalLoader.off()
            }, 5000)
        }
    } else {
        console.log('Hay un error')
        $('#guestFile-error').slideDown()
        $('#guestFile-error').text('Ingresa un archivo para continuar')
    }
}



//Funciones de Templates

async function selectTemplate(pageId, template, link, e) {
    generalLoader.on()
    $('.loader-msg').text('Cargando tu sitio')
    var homeContent = await getMetaObjectData(JSON.parse(e.getAttribute('home'))[0])
    var disenoContent = await getMetaObjectData(e.getAttribute('diseno'))
    var homeSecciones = JSON.parse(homeContent.data.metaobject.fields[1].value)
    var newSections
    var newSectionId
    var sectionsArray = []
    for (const section of homeSecciones) {
        newSections = await getMetaObjectData(section)
        for (field of newSections.data.metaobject.fields) {
            if (field.value == null) {
                field.value = ""
            }
            if (field.key == "eventos") {
                console.log('Eventos')
                //field.value = JSON.parse(field.value)
                console.log(field)
            }
        }
        sectionsArray.push(await createGeneralMetaobject(newSections.data.metaobject))
    }
    // PROTECCIÓN (contra pérdida de datos): solo sobreescribimos home_secciones si
    // TODAS las secciones de la plantilla se crearon. Si alguna falló, abortamos
    // para no dejar la página en blanco; no redirigimos y avisamos al usuario.
    if (sectionsArray.length !== homeSecciones.length || sectionsArray.includes(null) || sectionsArray.includes(undefined)) {
        console.error('selectTemplate abortado: se crearon ' + sectionsArray.filter(Boolean).length + ' de ' + homeSecciones.length + ' secciones.')
        $('.loader-msg').text('No se pudo aplicar la plantilla y no se hicieron cambios. Revisa tu conexión e intenta de nuevo.')
        setTimeout(() => { generalLoader.off() }, 7000)
        return
    }
    await updateMetaObject(JSON.parse(e.getAttribute('mainhome'))[0], [{ "key": "home_secciones", "value": JSON.stringify(sectionsArray) }])
    await updateMetaObject(e.getAttribute('maindiseno'), [{ "key": "color_primario", "value": disenoContent.data.metaobject.fields[0].value }, { "key": "color_secundario", "value": disenoContent.data.metaobject.fields[1].value }, { "key": "color_terciario", "value": disenoContent.data.metaobject.fields[2].value }, { "key": "tipografia_principal", "value": disenoContent.data.metaobject.fields[3].value }, { "key": "tipografia_de_apoyo", "value": disenoContent.data.metaobject.fields[4].value }])
    var metafield = { "key": "template", "value": template, "type": "single_line_text_field", "namespace": "custom" }
    await addPageMetafield(pageId, metafield)
    setTimeout(function () {
        window.location = link
    }, 4000);
    generalLoader.off()
}


async function selectInvitationTemplate(pageId, template, link, e) {
    generalLoader.on()
    $('.loader-msg').text('Cargando tu invitación')
    var disenoContent = await getMetaObjectData(e.getAttribute('diseno'))
    await updateMetaObject(e.getAttribute('maindiseno'), [{ "key": "color_primario", "value": disenoContent.data.metaobject.fields[0].value }, { "key": "color_secundario", "value": disenoContent.data.metaobject.fields[1].value }, { "key": "color_terciario", "value": disenoContent.data.metaobject.fields[2].value }, { "key": "tipografia_principal", "value": disenoContent.data.metaobject.fields[3].value }, { "key": "tipografia_de_apoyo", "value": disenoContent.data.metaobject.fields[4].value }])
    var metafield = { "key": "template_de_invitaci_n", "value": template, "type": "single_line_text_field", "namespace": "custom" }
    await addPageMetafield(pageId, metafield)
    setTimeout(function () {
        window.location = link
        generalLoader.off()
    }, 6000);
}

//Funciones de retiros

var retiroId
var monto
var montoTotal
var retirosIds
var retiroCol
var totalRegalado

async function showRetiroModal(element, collectionId) {
    $('#retiro-form').slideDown()
    $('#retiroDone').slideUp()
    $('#retiroFail').slideUp()
    $('.modal-fix.retiro').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.retiro').css('opacity', '1')
    const submitButton = document.querySelector(`#withdrawal_submit_button`)
    submitButton.setAttribute('disabled', 'true')
    //localStorage.setItem("withdraw_collectionId", collectionId)
    if ($('#bank_titular_' + collectionId).text() == '' && $('#bank_banco_' + collectionId).text() == '' && $('#bank_clabe_' + collectionId).text() == '' && $('#bank_cuenta_' + collectionId).text() == '') {
        $('#retiro-bad').removeClass('d-none')
        $('#retiro-form').addClass('d-none')
        return
    }
    $('#retiro-bad').addClass('d-none')
    $('#retiro-form').removeClass('d-none')
    const giftTableAmountString = document.querySelector('.table_value_table_' + collectionId).textContent
    const deliveryProductsId = 'total_fisicos' + collectionId
    const devliveryProductMoney = document.getElementById(deliveryProductsId).getAttribute('money')
    const giftTableAmount = getNumberFromString(giftTableAmountString)
    const withdrawAmount = document.querySelector(`#retirado${collectionId}`).getAttribute('money')

    console.log(giftTableAmount, withdrawAmount, devliveryProductMoney)
    const operationResult = giftTableAmount - withdrawAmount - devliveryProductMoney
    const currentTotalAmount = parseFloat(operationResult.toFixed(2))
    $('#modalRetirosHechos').text(parseInt($('#retirosDisponibles' + collectionId).text()) - parseInt($('#retirosHechos' + collectionId).text()))
    console.log(currentTotalAmount)
    $('#modalRetirosTotal').text(Shopify.formatMoney(currentTotalAmount * 100))
    const response = await getWithDrawals(collectionId);
    const withdrawIds = response.withdraws.filter((withdrawal) => !withdrawal.status).map((withdrawal) => withdrawal.id)
    // const withdrawIds = getCurrentWithdrawTables()
    localStorage.setItem("withdrawData", JSON.stringify({
        collectionId,
        currentTotalAmount,
        withdrawAmount,
        devliveryProductMoney,
        withdrawIds,
        giftTableAmount
    }))
    submitButton.removeAttribute('disabled')
    return
    retiroCol = value
    if ($('#bank_titular_' + value).text() != '' && $('#bank_banco_' + value).text() != '' && $('#bank_clabe_' + value).text() != '' && $('#bank_cuenta_' + value).text() != '') {
        $('#retiro-bad').addClass('d-none')
        $('#retiro-form').removeClass('d-none')
        $('#modalRetirosDisponibles').text($('#retirosDisponibles' + value).text())
        montoTotal = $('.table_value_' + value).first().text()
        totalRegalado = montoTotal

        //montoTotal = montoTotal.replace('$', '')
        //montoTotal = montoTotal.replace('.', '')
        //montoTotal = montoTotal.replace(',', '')
        //montoTotal = parseInt(montoTotal)
        //montoTotal = montoTotal / 100
        const deliveryProductsId = 'total_fisicos' + value
        const deliveryProductMoneyString = document.getElementById(deliveryProductsId).getAttribute('money')
        const devliveryProducMoney = getNumberFromString(deliveryProductMoneyString)
        montoTotal = getNumberFromString(montoTotal)
        var retirado = parseInt($('#retirado' + value).attr('data'))
        montoTotal = montoTotal - retirado
        montoTotal = montoTotal - devliveryProducMoney
        $('#modalRetirosHechos').text(parseInt($('#retirosDisponibles' + value).text()) - parseInt($('#retirosHechos' + value).text()))
        //$('#modalRetirosTotal').text(Shopify.formatMoney(montoTotal * 100))
        $('#modalRetirosTotal').text(Shopify.formatMoney(montoTotal * 100))
        document.getElementById('retiroQty').addEventListener('input', (e) => {
            monto = e.target.value
            $('#wantRetiro').text(Shopify.formatMoney(e.target.value * 100))
        })
        retiroId = value
        retirosIds = JSON.parse(e.getAttribute('retiros'))
    } else {

    }
}

// function showRetiroModal(value, e) {
//     $('#retiro-form').slideDown()
//     $('#retiroDone').slideUp()
//     $('#retiroFail').slideUp()
//     $('.modal-fix.retiro').css({
//         "display": "flex",
//         "opacity": "1"
//     })
//     $('.modal.retiro').css('opacity', '1')
//     retiroCol = value
//     if ($('#bank_titular_' + value).text() != '' && $('#bank_banco_' + value).text() != '' && $('#bank_clabe_' + value).text() != '' && $('#bank_cuenta_' + value).text() != '') {
//         $('#retiro-bad').addClass('d-none')
//         $('#retiro-form').removeClass('d-none')
//         $('#modalRetirosDisponibles').text($('#retirosDisponibles' + value).text())
//         montoTotal = $('.table_value_' + value).first().text()
//         totalRegalado = montoTotal

//         //montoTotal = montoTotal.replace('$', '')
//         //montoTotal = montoTotal.replace('.', '')
//         //montoTotal = montoTotal.replace(',', '')
//         //montoTotal = parseInt(montoTotal)
//         //montoTotal = montoTotal / 100
//         const deliveryProductsId = 'total_fisicos' + value
//         const deliveryProductMoneyString = document.getElementById(deliveryProductsId).getAttribute('money')
//         const devliveryProducMoney = getNumberFromString(deliveryProductMoneyString)
//         montoTotal = getNumberFromString(montoTotal)
//         var retirado = parseInt($('#retirado' + value).attr('data'))
//         montoTotal = montoTotal - retirado
//         montoTotal = montoTotal - devliveryProducMoney
//         $('#modalRetirosHechos').text(parseInt($('#retirosDisponibles' + value).text()) - parseInt($('#retirosHechos' + value).text()))
//         //$('#modalRetirosTotal').text(Shopify.formatMoney(montoTotal * 100))
//         $('#modalRetirosTotal').text(Shopify.formatMoney(montoTotal * 100))
//         document.getElementById('retiroQty').addEventListener('input', (e) => {
//             monto = e.target.value
//             $('#wantRetiro').text(Shopify.formatMoney(e.target.value * 100))
//         })
//         retiroId = value
//         retirosIds = JSON.parse(e.getAttribute('retiros'))
//     } else {
//         $('#retiro-bad').removeClass('d-none')
//         $('#retiro-form').addClass('d-none')
//     }
// }
const getNumberFromString = (moneyString) => {
    const number = moneyString.replace('$', '').replaceAll(',', '')
    return parseFloat(number)
}

async function withdrawal() {
    const defaultErroText = '<div>Hay un error en el formulario, por favor intenta nuevamente.</div>'
    $('#retiroFail').slideUp()
    if (!$('#retiroCheck').is(":checked")) return
    const withdrawInput = document.querySelector("#retiroQty")
    const amountToWithdraw = parseFloat(withdrawInput.value)
    if (amountToWithdraw <= 0 || !amountToWithdraw) return
    const withdrawData = JSON.parse(localStorage.getItem("withdrawData"))
    const { collectionId, currentTotalAmount, withdrawAmount, devliveryProductMoney, withdrawIds, giftTableAmount } = withdrawData
    if (currentTotalAmount < amountToWithdraw) {
        $('#retiroFail').html('<div>No tienes suficiente saldo para retirar esa cantidad</div>')
        $('#retiroFail').slideDown()
        return
    }

    generalLoader.on()

    $('.loader-msg').text('Solicitando retiro')
    // const withdrawMetaobjectPromises = withdrawIds.map(async (withdrawId) => {
    //     const metaobject = await getMetaObjectData(withdrawId)
    //     if (!metaobject.data.metaobject.fields[0].value) {
    //         return metaobject.data.metaobject
    //     }
    //     return null
    // })
    // const withdrawMetaobjectsResult = await Promise.all(withdrawMetaobjectPromises)
    // const withdrawMetaobjects = withdrawMetaobjectsResult.filter((withdrawMetaobject) => withdrawMetaobject)
    const firtsMetaobjectId = withdrawIds[0]
    const today = getTodayFormatDay()
    const updateCurrentMetaobjectResponse = await updateMetaObject(firtsMetaobjectId, [{ "key": "monto", "value": JSON.stringify({ "amount": amountToWithdraw, "currency_code": "MXN" }) }, { "key": "status", "value": "Pendiente" }, { "key": "fecha_del_retiro", "value": today }])
    // const updateCurrentMetaobjectResponse = {
    //     data: {
    //         metaobjectUpdate: {
    //             metaobject: { id: firtsMetaobjectId }
    //         }
    //     }
    // }
    if (updateCurrentMetaobjectResponse.data.metaobjectUpdate.metaobject.id) {
        const adminGuestData = await getAdminGuestData(collectionId)

        const emailData = {
            recipients: adminGuestData.names.join(),
            emails: adminGuestData.emails.join(),
            collectionId: collectionId,
            giftTableName: $('#customerName' + collectionId).attr('mesa'),
            remainingBalance: Shopify.formatMoney((currentTotalAmount - amountToWithdraw) * 100),
            openingBalance: Shopify.formatMoney(currentTotalAmount * 100),
            amountToWithdraw: Shopify.formatMoney(amountToWithdraw * 100),
            totalTableGift: Shopify.formatMoney(giftTableAmount * 100),
            movementNumber: $('#customerName' + collectionId).attr('count'),
            movementTotal: $('#customerName' + collectionId).attr('disponibles'),
            banKName: $('#bank_banco_' + collectionId).text().trim(),
            account: $('#bank_cuenta_' + collectionId).text().trim(),
            clabe: $('#bank_clabe_' + collectionId).text().trim(),
            bankHolder: $('#bank_titular_' + collectionId).text().trim(),
            metaobjectId: firtsMetaobjectId.replace('gid://shopify/Metaobject/', ''),
        }
        const sendEmailsResponse = await sendEmailRetiro(
            emailData.recipients,
            emailData.giftTableName,
            emailData.emails,
            emailData.movementNumber,
            emailData.amountToWithdraw,
            emailData.remainingBalance,
            emailData.openingBalance,
            emailData.movementTotal,
            emailData.bankHolder,
            emailData.banKName,
            emailData.clabe,
            emailData.account,
            emailData.metaobjectId,
            emailData.collectionId,
            emailData.totalTableGift
        )
        if (sendEmailsResponse.status) {
            $('#retiro-form').slideUp()
            $('#retiroDone').slideDown()
            localStorage.removeItem('withdrawData')
            setTimeout(() => {
                generalLoader.off()
                location.reload()
            }, 3000)
        } else {
            $('#retiroFail').html(defaultErroText)
            $('#retiroFail').slideDown()
        }

    } else {
        $('#retiroFail').html(defaultErroText)
        $('#retiroFail').slideDown()
    }

    generalLoader.off()
    return
    if ($('#retiroCheck').is(":checked") && monto > 0) {
        if (montoTotal < monto) {
            $('#retiroFail').slideDown()
        } else {
            generalLoader.on()
            $('.loader-msg').text('Solicitando retiro')
            $('#retiroFail').slideUp()
            var retiroObject
            for (const retiro of retirosIds) {
                var retiroData = await getMetaObjectData(retiro)
                console.log(retiroData.data.metaobject.fields[0])
                if (retiroData.data.metaobject.fields[0].value == '' || retiroData.data.metaobject.fields[0].value == null || retiroData.data.metaobject.fields[0].value == undefined) {
                    retiroObject = retiro
                    //var today = new Date();
                    var dd = String(today.getDate()).padStart(2, '0');
                    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                    var yyyy = today.getFullYear();
                    today = yyyy + '-' + mm + '-' + dd
                    updateMetaObject(retiro, [{ "key": "monto", "value": JSON.stringify({ "amount": monto + '', "currency_code": "MXN" }) }, { "key": "status", "value": "Pendiente" }, { "key": "fecha_del_retiro", "value": today }])
                    break
                }
            }
            var admins = await getGuestsData('query: "tag:' + retiroCol + '-admin"')
            var festejados = await getGuestsData('query: "tag:' + retiroCol + '-f"')
            var festejadosData = []
            for (const festejado of admins.data.customers.edges) {
                festejadosData.push(festejado.node)
            }
            for (const festejado of festejados.data.customers.edges) {
                festejadosData.push(festejado.node)
            }
            var names = []
            var emails = []
            for (const festejado of festejadosData) {
                names.push(festejado.firstName + ' ' + festejado.lastName)
                emails.push(festejado.email)
            }
            await sendEmailRetiro(names.join(), $('#customerName' + retiroCol).attr('mesa'), emails.join(), $('#customerName' + retiroCol).attr('count'), Shopify.formatMoney(monto * 100), Shopify.formatMoney((montoTotal - monto) * 100), Shopify.formatMoney(montoTotal * 100), $('#customerName' + retiroCol).attr('disponibles'), $('#bank_titular_' + retiroCol).text(), $('#bank_banco_' + retiroCol).text(), $('#bank_clabe_' + retiroCol).text(), $('#bank_cuenta_' + retiroCol).text(), retiroObject.replace('gid://shopify/Metaobject/', ''), retiroCol, totalRegalado)
            $('#retiro-form').slideUp()
            setTimeout(() => {
                $('#retiroDone').slideDown()
            }, 300)
            setTimeout(() => {
                generalLoader.off()
                location.reload()
            }, 3000)
        }
    }
}
async function getAdminGuestData(collectionId) {
    const admins = await getGuestsData('query: "tag:' + collectionId + '-admin"')
    const festejados = await getGuestsData('query: "tag:' + collectionId + '-f"')

    let festejadosData = []
    for (const festejado of admins.data.customers.edges) {
        festejadosData.push(festejado.node)
    }
    for (const festejado of festejados.data.customers.edges) {
        festejadosData.push(festejado.node)
    }
    let names = []
    let emails = []
    for (const festejado of festejadosData) {
        names.push(festejado.firstName + ' ' + festejado.lastName)
        emails.push(festejado.email)
    }
    names = removeRepetedElements(names)
    emails = removeRepetedElements(emails)
    return { names, emails }
}
function removeRepetedElements(array) {
    return array.filter((item, pos) => {
        return array.indexOf(item) === pos
    })
}
function getTodayFormatDay() {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    const year = today.getFullYear();
    return `${year}-${month}-${day}`
}
// async function withdrawal() {
//     if ($('#retiroCheck').is(":checked") && monto > 0) {
//         if (montoTotal < monto) {
//             $('#retiroFail').slideDown()
//         } else {
//             generalLoader.on()
//             $('.loader-msg').text('Solicitando retiro')
//             $('#retiroFail').slideUp()
//             var retiroObject
//             for (const retiro of retirosIds) {
//                 var retiroData = await getMetaObjectData(retiro)
//                 console.log(retiroData.data.metaobject.fields[0])
//                 if (retiroData.data.metaobject.fields[0].value == '' || retiroData.data.metaobject.fields[0].value == null || retiroData.data.metaobject.fields[0].value == undefined) {
//                     retiroObject = retiro
//                     var today = new Date();
//                     var dd = String(today.getDate()).padStart(2, '0');
//                     var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
//                     var yyyy = today.getFullYear();
//                     today = yyyy + '-' + mm + '-' + dd
//                     updateMetaObject(retiro, [{ "key": "monto", "value": JSON.stringify({ "amount": monto + '', "currency_code": "MXN" }) }, { "key": "status", "value": "Pendiente" }, { "key": "fecha_del_retiro", "value": today }])
//                     break
//                 }
//             }
//             var admins = await getGuestsData('query: "tag:' + retiroCol + '-admin"')
//             var festejados = await getGuestsData('query: "tag:' + retiroCol + '-f"')
//             var festejadosData = []
//             for (const festejado of admins.data.customers.edges) {
//                 festejadosData.push(festejado.node)
//             }
//             for (const festejado of festejados.data.customers.edges) {
//                 festejadosData.push(festejado.node)
//             }
//             var names = []
//             var emails = []
//             for (const festejado of festejadosData) {
//                 names.push(festejado.firstName + ' ' + festejado.lastName)
//                 emails.push(festejado.email)
//             }
//             await sendEmailRetiro(names.join(), $('#customerName' + retiroCol).attr('mesa'), emails.join(), $('#customerName' + retiroCol).attr('count'), Shopify.formatMoney(monto * 100), Shopify.formatMoney((montoTotal - monto) * 100), Shopify.formatMoney(montoTotal * 100), $('#customerName' + retiroCol).attr('disponibles'), $('#bank_titular_' + retiroCol).text(), $('#bank_banco_' + retiroCol).text(), $('#bank_clabe_' + retiroCol).text(), $('#bank_cuenta_' + retiroCol).text(), retiroObject.replace('gid://shopify/Metaobject/', ''), retiroCol, totalRegalado)
//             $('#retiro-form').slideUp()
//             setTimeout(() => {
//                 $('#retiroDone').slideDown()
//             }, 300)
//             setTimeout(() => {
//                 generalLoader.off()
//                 location.reload()
//             }, 3000)
//         }
//     }
// }
var cerrarId
var cerrarPageId
var cerrarPage
var cerrarHandle

function showCerrarMesaModal(colId, e, pageId, handle) {
    console.log(e)
    $('.modal-fix.cerrarMesa').css({
        "display": "flex",
        "opacity": "1"
    })
    cerrarId = colId
    cerrarPageId = e.getAttribute('pageid')
    cerrarPage = pageId
    cerrarHandle = handle
    localStorage.setItem('currentEditingCollection', colId)
    localStorage.setItem('currentEditingPageId', pageId)
    localStorage.setItem('currentEditingHandle', handle)
    $('.modal.cerrarMesa').css('opacity', '1')
    $('#modalCerrarTotal').text($('.table_value_resume_' + colId).first().text())
    $('#cerrarFisicos').text($('#total_fisicos' + colId).attr('money'))
    $('#cerrarCashout').text($('#total_cashout' + colId).attr('money'))

    const closestCloseForm = e.target.closest('#cerrarForm')
    console.log(closestCloseForm)
    if (closestCloseForm) {
        closestCloseForm.data['collection-id'] = colId
        closestCloseForm.data['page-id'] = pageId
        closestCloseForm.data['page-handle'] = handle
    }

}

async function cerrarMesa(event) {
    event?.preventDefault()
    if (typeof window.closeTable !== 'function') {
        console.error('El flujo validado para cerrar la mesa no está disponible.')
        return
    }
    return window.closeTable(event)
}


function createNewTable() {
    console.log('entra')
    $('#mainDashBoard').css("display", "none")
    $('#newTableContainer').removeClass('d-none')
}


async function payCart(product) {
    generalLoader.on()
    $('.loader-msg').text('Seleccionando producto')
    await $.ajax({
        url: "/cart.js",
        dataType: 'json',
        type: 'GET',
        success: function (itemData) { },
        error: function (XMLHttpRequest) {

        }
    }).done(() => {
        jQuery.getJSON('/cart.js', async function (cart) {
            for (item of cart.items) {
                if (product == 'plan') {
                    if (item.product_type != "Planes") {
                        await $.ajax({
                            method: 'POST',
                            url: '/cart/change.js',
                            data: { id: item.variant_id, quantity: 0 },
                            dataType: 'json'
                        })
                    }
                } else {
                    if (item.product_type == "Planes") {
                        await $.ajax({
                            method: 'POST',
                            url: '/cart/change.js',
                            data: { id: item.variant_id, quantity: 0 },
                            dataType: 'json'
                        })
                    }
                }
            }
        });
    })
    generalLoader.off()
    setTimeout(() => {
        location.reload()
    }, 1000)
}
async function uploadFileCustomersV2() {
    $('#guestFile-error').slideUp()
    generalLoader.on()
    $('.loader-msg').text('Subiendo archivo')
    const file = document.querySelector('#importCSV').files[0]
    if (!file) {
        $('#guestFile-error').slideDown()
        $('#guestFile-error div').text('Debes seleccionar un archivo')
        generalLoader.off()
        return
    }

    const formData = new FormData();
    formData.append('collection_id', $('#gift_table_' + sendInvColId).attr('collection'));
    formData.append('file', file);

    const url = `http://127.0.0.1:8000/api/v2/dashboard/gift-table/import-guest`;
    const response = await fetch(url, {
        method: 'POST',
        body: formData,
    });

    if (!response.ok) {
        $('#guestFile-done .flex.ver.small-gap h2').text('Error al enviar');
        $('#guestFile-done .flex.ver.small-gap p').append('Ha ocurrido un error al importar a los invitados. Si el error persiste, contacta a soporte.<br>');
        generalLoader.off();
        return;
    }

    const responseData = await response.json();
    const batchId = responseData.batch_id;
    if (!localStorage.getItem('batch_id')) {
        localStorage.setItem('batch_id', batchId)
    }
    const sendingInvitations = document.querySelector('#sending-invitations-container')
    sendingInvitations.classList.remove('d-none')
    const batchStatus = await checkBatchStatus(batchId)
    document.querySelector('#invitations-tabs-menu').classList.add('d-none')
    document.querySelector('#invitations-tabs-content').classList.add('d-none')
    sendingInvitations.querySelector('#sending-progress').value = batchStatus.progress
    document.querySelector('#sending-message').textContent = 'Importando invitados'
    generalLoader.off();
    $('#guestFile-form').slideUp();
    $('#guestFile-done').slideDown();
    $('#guestFile-done .flex.ver.small-gap h2').text('Importando invitados');
    $('#guestFile-done .flex.ver.small-gap p').text('Puedes seguir editando personalizando tu mesa en lo que terminamos de importar tus invitados');
    generalLoader.off();
    refreshBatchStatus()
}
async function sendInvitations() {
    try {
        generalLoader.on();
        const loaderMessage = document.querySelector('.loader-msg')
        loaderMessage.textContent = 'Enviando invitaciones';
        const sendCount = document.createElement('div')


        let subject = $('#ei_subject').val() || 'Te invito a mi evento';
        let message = $('#ei_message').val() || 'Te invito a mi evento';

        const guests = document.querySelectorAll(`.check_guests_${sendInvColId}.w--redirected-checked`);
        //sendCount.innerHTML = `<div>Enviando <span id="invCount">1</span> de <span id="invToSend">${guests.length}</span></div>`
        //loaderMessage.appendChild(sendCount)
        let invitations = []
        const pageURL = $('#invitacionLink' + sendInvColId).attr('pagina');
        for (const guest of Array.from(guests)) {
            const fullname = `${guest.getAttribute('name')} ${guest.getAttribute('lname')}`;
            const email = guest.getAttribute('email');
            invitations.push({
                "mailto": email,
                "recipient": fullname,
                "link_to_invitation": $('#invitacionLink' + sendInvColId).attr('data') + '&customer=' + guest.getAttribute('customerid'),
                "customer_id": guest.getAttribute('customerid'),
                "events": JSON.parse(guest.getAttribute('guest-events'))
            })
        }
        const body = {
            "collection_id": $('#gift_table_' + sendInvColId).attr('collection'),
            "collection_title": $('#gift_table_' + sendInvColId).attr('collection-title'),
            "date_event": $('#invitacionLink' + sendInvColId).attr('eventdate'),
            "sender": $('#invitacionLink' + sendInvColId).attr('sendername'),
            "subject": subject,
            "message": message,
            "link_to_page": pageURL,
            "invitations": invitations,
        };
        const url = `https://api-zepika.panorama.works/public/api/v2/collections/invitations/send`;
        //const url = `http://127.0.0.1:8000/api/v2/collections/invitations/send`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        })
        generalLoader.off();
        if (!response.ok) {
            // $('#sendInvDone .flex.ver.small-gap h2').text('Error al enviar');
            // $('#sendInvDone .flex.ver.small-gap').append('Ha ocurrido un error al enviar las invitaciones. Si el error persiste, contacta a soporte.<br>');
            $('#sendInvForm').slideUp();
            $('#sendInvFail').slideDown();
            return
        }
        const responseData = await response.json();
        $('#sendInvForm').slideUp();
        $('#sendInvDone').slideDown();
        guests.forEach(guest => {
            console.log(guest)
            const row = guest.closest('.db-invite-table-row');
            const statusCol = row.querySelector('.status-col');
            const statusTags = statusCol.querySelectorAll('.status-tag');
            guest.classList.remove('w--redirected-checked');
            statusTags.forEach(tag => {
                tag.classList.remove('no-invite')
                tag.classList.add('pending')
                tag.innerHTML = `<div class="tag-icon pending"></div><div>Pendiente</div><div title="Pendiente" tooltipster="top" class="tooltip-icon">?</div>`
            })
        })
    } catch (error) {
        generalLoader.off();
        console.error('Error al enviar las invitaciones:', error);
        $('#sendInvForm').slideUp();
        $('#sendInvFail').slideDown();
    }
    //const batchId = responseData.batch_id
    // if (!localStorage.getItem('batch_id')) {
    //     localStorage.setItem('batch_id', batchId)
    // }
    //const sendingInvitations = document.querySelector('#sending-invitations-container')
    //sendingInvitations.classList.remove('d-none')
    //const batchStatus = await checkBatchStatus(batchId)
    // document.querySelector('#invitations-tabs-menu').classList.add('d-none')
    // document.querySelector('#invitations-tabs-content').classList.add('d-none')
    // sendingInvitations.querySelector('#sending-progress').value = batchStatus.progress
    // $('#sendInvDone .flex.ver.small-gap h2').text('Las invitaciones se estan enviando');
    // $('#sendInvDone .flex.ver.small-gap').append('Puedes seguir editando personalizando tu mesa en lo que terminamos de enviar tu invitaciones');
    // refreshBatchStatus()
    //setTimeout(() => alert('Todo enviado'), 1000);
}
async function refreshBatchStatus() {
    const batchId = localStorage.getItem('batch_id', doneMessage = 'Las invitaciones han sido enviadas. Recarga la página para actualizar los estados.')
    if (!batchId) return
    const batchStatus = await checkBatchStatus(batchId)
    document.querySelector('#sending-progress').value = batchStatus.progress
    console.log(batchStatus.progress)
    if (batchStatus.progress == 100) {
        document.querySelector('#sending-message').textContent = doneMessage
        localStorage.removeItem('batch_id')
        return
    }
    setTimeout(refreshBatchStatus, 3000)
}
async function checkBatchStatus(batchId) {
    const url = `https://api-zepika.panorama.works/public/api/v2/collections/invitations/batch/${batchId}`;
    //const url = `http://127.0.0.1:8000/api/v2/collections/invitations/batch/${batchId}`;
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
    }
}


var sendInvColId
var sendInvUrl
async function showSendInvitationsModal(colId, e) {
    $('#sendInvForm').slideDown()
    $('#sendInvDone').slideUp()
    $('#sendInvFail').slideUp()
    $('.modal-fix.enviarInv').css({
        "display": "flex",
        "opacity": "1"
    })
    sendInvColId = colId
    $('.modal.enviarInv').css('opacity', '1')
    // var invitaciones = JSON.parse(e.getAttribute('invitaciones'))
    // var name
    // var url
    // var image
    // var i = 0
    // for (const invitacion of invitaciones) {
    //     i++
    //     var data = await getMetaObjectData(invitacion)
    //     for (field of data.data.metaobject.fields) {
    //         if (field.key == "nombre_de_invitacion") {
    //             name = field.value
    //             if (name == null) {
    //                 name = "Invitación " + i
    //             }
    //         }
    //         if (field.key == "link_de_la_invitacion") {
    //             url = field.value
    //         }
    //     }
    //     sendInvUrl = url
    // }
    setupCheckboxListener();
}

function setupCheckboxListener() {
    const checkbox = document.getElementById('checkbox-2');
    const sendButton = document.getElementById('send-invitation-button');

    if (checkbox && sendButton) {
        checkbox.addEventListener('change', () => {
            if (checkbox.checked) {  // Habilitar el btn
                sendButton.disabled = false;
                sendButton.classList.remove('disabled');
                sendButton.style.opacity = '1';
            } else { // Deshabilitar el btn
                sendButton.disabled = true;
                sendButton.classList.add('disabled');
                sendButton.style.opacity = '0.5';
            }
        });

        // Estado inicial
        if (checkbox.checked) {
            sendButton.disabled = false; // HAB
            sendButton.classList.remove('disabled');
            sendButton.style.opacity = '1';
        } else {
            sendButton.disabled = true; // DESHAB
            sendButton.classList.add('disabled');
            sendButton.style.opacity = '0.5';
        }
    }
}

var newTemplateElement
var newTemplateTemplate

function showTemplateModal(template, e) {
    $('.modal-fix.template').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.template').css('opacity', '1')
    newTemplateElement = e
    newTemplateTemplate = template
}

async function selectNewTemplate() {
    generalLoader.on()
    $('.loader-msg').text('Cambiando diseño')
    var pageId = $('#mpw_collection').val()
    var homeContent = await getMetaObjectData(JSON.parse(newTemplateElement.getAttribute('home'))[0])
    var disenoContent = await getMetaObjectData(newTemplateElement.getAttribute('diseno'))
    var homeSecciones = JSON.parse(homeContent.data.metaobject.fields[1].value)
    var newSections
    var newSectionId
    var sectionsArray = []
    for (const section of homeSecciones) {
        newSections = await getMetaObjectData(section)
        for (field of newSections.data.metaobject.fields) {
            if (field.value == null) {
                field.value = ""
            }
        }
        sectionsArray.push(await createGeneralMetaobject(newSections.data.metaobject))
    }
    // PROTECCIÓN (contra pérdida de datos): solo sobreescribimos home_secciones si
    // TODAS las secciones de la plantilla se crearon. Si alguna falló, abortamos
    // para no dejar la página en blanco; no redirigimos y avisamos al usuario.
    if (sectionsArray.length !== homeSecciones.length || sectionsArray.includes(null) || sectionsArray.includes(undefined)) {
        console.error('selectNewTemplate abortado: se crearon ' + sectionsArray.filter(Boolean).length + ' de ' + homeSecciones.length + ' secciones.')
        $('.loader-msg').text('No se pudo aplicar la plantilla y no se hicieron cambios. Revisa tu conexión e intenta de nuevo.')
        setTimeout(() => { generalLoader.off() }, 7000)
        return
    }
    await updateMetaObject(JSON.parse($('#data-' + pageId).attr('mainhome'))[0], [{ "key": "home_secciones", "value": JSON.stringify(sectionsArray) }])
    await updateMetaObject($('#data-' + pageId).attr('maindiseno'), [{ "key": "color_primario", "value": disenoContent.data.metaobject.fields[0].value }, { "key": "color_secundario", "value": disenoContent.data.metaobject.fields[1].value }, { "key": "color_terciario", "value": disenoContent.data.metaobject.fields[2].value }, { "key": "tipografia_principal", "value": disenoContent.data.metaobject.fields[3].value }, { "key": "tipografia_de_apoyo", "value": disenoContent.data.metaobject.fields[4].value }])
    var metafield = { "key": "template", "value": newTemplateTemplate, "type": "single_line_text_field", "namespace": "custom" }
    await addPageMetafield(pageId, metafield)
    setTimeout(function () {
        window.location = $('#data-' + pageId).attr('url')
    }, 2000);
    generalLoader.off()
}

var changeTemplatePageId
var changeTemplateKey
var changeTemplateDiseno

function showTemplateModal1(pageId, key, diseno) {
    console.log('entra al modal')
    $('#changeTempFail').slideUp()
    $('#changeTempDone').slideUp()
    $('#changeTempForm').slideDown()
    $('.containerTemplates').addClass('d-none')
    $('#' + key).removeClass('d-none')
    $('.modal-fix.changeTemp').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.changeTemp').css('opacity', '1')
    changeTemplatePageId = pageId
    changeTemplateKey = key
    changeTemplateDiseno = diseno
}

async function changeTemplate(template, color1, color2, color3, font1, font2) {
    generalLoader.on()
    $('.loader-msg').text('Cambiando diseño')
    console.log(template)
    if (template != '') {
        await addPageMetafield(changeTemplatePageId, { "key": changeTemplateKey, "value": template, "type": "single_line_text_field", "namespace": "custom" })
        await updateMetaObject(changeTemplateDiseno, [{ "key": "color_primario", "value": color1 }, { "key": "color_secundario", "value": color2 }, { "key": "color_terciario", "value": color3 }, { "key": "tipografia_principal", "value": font1 }, { "key": "tipografia_de_apoyo", "value": font2 }])
        $('#changeTempForm').slideUp()
        $('#changeTempDone').slideDown()
        $('#changeTempFail').slideUp()
        setTimeout(() => {
            location.reload()
        }, 3000)
    } else {
        $('#changeTempFail').slideDown()
    }
    generalLoader.off()
}




//addOrdernMetafield()
async function createProductFieldInOrder() {
    var a = 'eyJsYXN0X2lkIjo1MTU0MDkzNTY0MTQzLCJsYXN0X3ZhbHVlIjoiMjAyMy0wMS0xMSAxMDozNDoyNi4wMDAwMDAifQ=='
    var query = ''
    var orderData = a
    do {
        await new Promise((resolve) => {
            setTimeout(async function () {
                var productsArray = []
                var pasa = true
                if (orderData != a) {
                    cursor = orderData.data.orders.pageInfo.endCursor
                    query = `,after:"${cursor}"`
                } else {
                    console.log('entra al nuevo')
                    query = `,after:"${a}"`
                }
                orderData = await getOrdersDataBorrar(query)
                console.log(orderData)
                for (let i = 0; i < orderData.data.orders.edges.length; i++) {
                    for (let j = 0; j < orderData.data.orders.edges[i].node.metafields.edges.length; j++) {
                        console.log(orderData.data.orders.edges[i].node.metafields.edges[j].node)
                        if (orderData.data.orders.edges[i].node.metafields.edges[j].node.key == "informaci_n_de_productos") {
                            pasa = false
                        }
                    }
                    if (pasa) {
                        for (let j = 0; j < orderData.data.orders.edges[0].node.lineItems.edges.length; j++) {
                            var lineItem = orderData.data.orders.edges[0].node.lineItems.edges[j]
                            if (lineItem.node.product != null) {
                                productsArray.push({ "id": lineItem.node.product.id.replace('gid://shopify/Product/', ''), "Producto": lineItem.node.product.title, "modalidad": "Cashout" })
                            } else {
                                productsArray.push({ "id": "", "Producto": "Certificado de regalo", "modalidad": "Cashout" })
                            }
                        }
                        console.log(orderData.data.orders.edges[0].node.legacyResourceId)
                        var x = addOrdernMetafield(orderData.data.orders.edges[0].node.legacyResourceId, { "key": "informaci_n_de_productos", "value": JSON.stringify(productsArray), "type": "json", "namespace": "custom" })
                        /*if(x.error == ''){
                          alert(a)
                        }*/
                    }
                }
                resolve();
            }, 250)
        });
        console.log('sale')
    } while (orderData.data.orders.pageInfo.hasNextPage)
}


//addOrdernMetafield()
async function assignCustomersTags() {
    var a = 'eyJsYXN0X2lkIjo2NzQxNTc5NDMyMTc1LCJsYXN0X3ZhbHVlIjoiNjc0MTU3OTQzMjE3NSJ9'
    var query = ''
    var orderData = a
    do {
        await new Promise((resolve) => {
            setTimeout(async function () {
                var productsArray = []
                var pasa = true
                if (orderData != a) {
                    cursor = orderData.data.customers.pageInfo.endCursor
                    query = `,after:"${cursor}"`
                } else {
                    query = `,after:"${a}"`
                }
                orderData = await getGuestsDataBorrar(query)
                console.log(orderData)
                for (let i = 0; i < orderData.data.customers.edges.length; i++) {
                    for (let j = 0; j < orderData.data.customers.edges[i].node.metafields.edges.length; j++) {
                        console.log(orderData.data.customers.edges[i].node.metafields.edges[j].node)
                        if (orderData.data.customers.edges[i].node.metafields.edges[j].node.key == "mis_mesas") {
                            var mesas = JSON.parse(orderData.data.customers.edges[i].node.metafields.edges[j].node.value)
                            var tags = []
                            for (const mesa of mesas) {
                                var mesaData = await getMetaObjectData(mesa)
                                console.log(mesaData.data.metaobject.fields[0].value)
                                var colId = mesaData.data.metaobject.fields[0].value
                                colId = colId.replace('gid://shopify/Collection/', '')
                                var rol = mesaData.data.metaobject.fields[1].value
                                if (rol == 'Administrador') {
                                    tags.push(colId + '-admin')
                                } else {
                                    tags.push(colId + '-f')
                                }
                            }
                            updateCustomerTag(orderData.data.customers.edges[i].node.id, tags)
                        }
                    }
                }
                resolve();
            }, 200)
        });
        console.log('sale')
    } while (orderData.data.customers.pageInfo.hasNextPage)
}

async function exportCsv(colId, email) {
    generalLoader.on()
    $('.loader-msg').text('El archivo se mandará a tu Email.')
    await exportCsvFile(email, colId, $('#customerName' + colId).attr('data'))
    generalLoader.off()
}

var mecCol
var mecPage

function showeditColModal(value, pageId) {
    $('#mec_name').val($('#colTitle' + value).text())
    $('#mec_date').val($('#colDate' + value).text())
    $('#mec_preurl').text($('#colUrl' + value).text().split('pages/')[0] + 'pages/')
    $('#mec_url').val($('#colUrl' + value).text().split('pages/')[1])
    $('#editColForm').slideDown()
    $('#editColDone').slideUp()
    $('.modal-fix.editCol').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.editCol').css('opacity', '1')
    mecCol = value
    mecPage = pageId
}

async function updateColData() {
    generalLoader.on()
    $('.loader-msg').text('Guardando cambios')
    var date = $('#mec_date').val()
    date = date.split('-')
    date = date[2] + '-' + date[1] + '-' + date[0]
    console.log(date)
    var data = { "key": "fecha_del_evento", "value": date, "type": "date", "namespace": "custom" }
    await addCollectionMetafield(mecCol, data)
    await updateCollectionTitle($('#mec_name').val(), mecCol)
    await updateHandle(mecCol, mecPage, $('#mec_url').val())
    $('#editColForm').slideUp()
    $('#editColDone').slideDown()
    $('#colTitle' + mecCol).text($('#mec_name').val())
    $('#colDate' + mecCol).text($('#mec_date').val())
    setTimeout(() => {
        location.reload()
        generalLoader.off()
    }, 3000)
}

function filterGuests(colId) {
    $('#filters-cont-parent-' + colId).addClass('d-none')
    $('#filters-cont-' + colId).empty()
    let filters = []
    let exists_group_1 = false
    let exists_group_2 = false
    let exists_group_3 = false
    let exists_group_4 = false
    $('.filter-' + colId).each(function () {
        if ($(this).prop('checked')) {
            $('#filters-cont-parent-' + colId).removeClass('d-none')
            filters.push({ "class": $(this).attr('name'), "group": $(this).attr('group') })
            if ($(this).attr('group') == 1) { exists_group_1 = true }
            if ($(this).attr('group') == 2) { exists_group_2 = true }
            if ($(this).attr('group') == 3) { exists_group_3 = true }
            if ($(this).attr('group') == 4) { exists_group_4 = true }
            $('#filters-cont-' + colId).append(`
        <a href="#" onclick="removeGuestFilter(${colId},$(this),'${$(this).attr('name')}')" class="filter-tag w-inline-block">
          <div>${$(this).attr('filter')}</div><img src="https://zepika.com/cdn/shop/t/3/assets/Close-Icon.svg?v=179867824219862906291670261857" loading="lazy" alt="" class="filter-tag-icon">
        </a>`)
        }
    })
    $('.guest' + colId).each(function () {
        var grupo_1 = false
        var grupo_2 = false
        var grupo_3 = false
        var grupo_4 = false
        for (let i = 0; i < filters.length; i++) {
            if ($(this).hasClass(filters[i].class)) {
                if (filters[i].group == 1) { grupo_1 = true }
                if (filters[i].group == 2) { grupo_2 = true }
                if (filters[i].group == 3) { grupo_3 = true }
                if (filters[i].group == 4) { grupo_4 = true }
            }
        }
        if (!exists_group_1) { grupo_1 = true }
        if (!exists_group_2) { grupo_2 = true }
        if (!exists_group_3) { grupo_3 = true }
        if (!exists_group_4) { grupo_4 = true }
        if (grupo_1 && grupo_2 && grupo_3 && grupo_4) {
            $(this).slideDown()
            $(this).addClass('result')
        } else {
            $(this).slideUp()
            $(this).removeClass('result')
        }
    })
}

function removeGuestFilter(colId, e, name) {
    $('.filter-' + colId).each(function () {
        if ($(this).attr('name') == name) {
            $(this).prop('checked', false)
            $(this).parent().find(">:first-child").removeClass('w--redirected-checked')
        }
    })
    e.remove()
    filterGuests(colId)
}
var countColProdCen = true

function countColProd(e) {
    if (countColProdCen) {
        console.log('entra')
        var qty = parseInt($('#col-products-count').text())
        if (e.querySelector('input').checked) {
            console.log('resta')
            qty--
            $('#col-products-count').text(qty)
        } else {
            console.log('suma')
            qty++
            $('#col-products-count').text(qty)
        }
        countColProdCen = false
    } else {
        countColProdCen = true
    }
}

function showeditInfoModal(name, lastName, email) {
    $('#einf_name').val(name)
    $('#einf_email').val(email)
    $('#einf_last_name').val(lastName)
    $('#editInfoForm').slideDown()
    $('#editInfoDone').slideUp()
    $('#editInfoError').slideUp()
    $('.modal-fix.editInfo').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.editInfo').css('opacity', '1')
}

async function updateCustomerInfo(cId) {
    generalLoader.on()
    $('#editInfoError').slideUp()
    $('.loader-msg').text('Actualizando información')
    var name = $('#einf_name').val()
    var email = $('#einf_email').val()
    var last_name = $('#einf_last_name').val()
    if (name != '' && email != '' && last_name != '') {
        updateCustomer('gid://shopify/Customer/' + cId, name, last_name, email)
        $('#editInfoForm').slideUp()
        $('#editInfoDone').slideDown()
        setTimeout(() => {
            generalLoader.off()
            location.reload()
        }, 2000)
    } else {
        $('#editInfoForm').slideUp()
        $('#editInfoError').slideDown()
    }
}

var colAddressMO

function normalizeAddressValue(value) {
    return String(value ?? '').replace(/\s+/g, ' ').trim()
}

function showColAddressModal(colId, MOID) {
    populateCountries("col-country", "col-province");
    colAddressMO = MOID
    $('#col-forname').val(normalizeAddressValue($('#adName' + colId).text()))
    $('#col-address1').val(normalizeAddressValue($('#adStreet' + colId).text()))
    $('#col-address2').val(normalizeAddressValue($('#adCol' + colId).text()))
    $('#col-postcode').val(normalizeAddressValue($('#adZip' + colId).text()))
    $('#col-city').val(normalizeAddressValue($('#adAlc' + colId).text()))
    $('#col-phone').val(normalizeAddressValue($('#adTel' + colId).text()))

    $('#col-country').val(normalizeAddressValue($('#adCountry' + colId).text())).trigger('change')
    $('#col-province').val(normalizeAddressValue($('#adEstado' + colId).text()))

    $('#address-colForm').slideDown()
    $('#address-colDone').slideUp()
    $('#address-colFail').slideUp()
    $('.modal-fix.address-col').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.address-col').css('opacity', '1')
}

async function saveColAddress() {
    var nombre = normalizeAddressValue($('#col-forname').val())
    var calle = normalizeAddressValue($('#col-address1').val())
    var colonia = normalizeAddressValue($('#col-address2').val())
    var zip = normalizeAddressValue($('#col-postcode').val())
    var ciudad = normalizeAddressValue($('#col-city').val())
    var pais = normalizeAddressValue($('#col-country').val())
    var estado = normalizeAddressValue($('#col-province').val())
    var telefono = normalizeAddressValue($('#col-phone').val())
    var requiredFields = [
        { value: nombre, label: 'nombre', selector: '#col-forname' },
        { value: calle, label: 'calle y número', selector: '#col-address1' },
        { value: colonia, label: 'colonia', selector: '#col-address2' },
        { value: zip, label: 'código postal', selector: '#col-postcode' },
        { value: ciudad, label: 'municipio/alcaldía', selector: '#col-city' },
        { value: pais && pais !== '-1', label: 'país', selector: '#col-country' },
        { value: estado, label: 'estado', selector: '#col-province' },
        { value: telefono, label: 'teléfono', selector: '#col-phone' }
    ]
    var missingFields = requiredFields.filter(field => !field.value)
    if (missingFields.length === 0) {
        $('#address-colFail').slideUp()
        generalLoader.on()
        $('.loader-msg').text('Actualizando información')
        try {
            await updateMetaObject(colAddressMO, [{ "key": "nombre_de_quien_recibe", "value": nombre }, { "key": "calle_y_numeros", "value": calle }, { "key": "colonia", "value": colonia }, { "key": "codigo_postal", "value": zip }, { "key": "alcaldia_o_municipio", "value": ciudad }, { "key": "estado", "value": estado }, { "key": "telefono", "value": telefono }, { "key": "pais", "value": pais }])
        } catch (error) {
            console.error('No se pudo guardar la dirección', error)
            $('#address-colFail div').text('No se pudieron guardar los cambios. Intenta nuevamente.')
            $('#address-colFail').slideDown()
            generalLoader.off()
            return
        }
        $('#address-colForm').slideUp()
        $('#address-colDone').slideDown()
        setTimeout(() => {
            generalLoader.off()
            location.reload()
        }, 3000)
    } else {
        $('#address-colFail div').text('Completa los siguientes campos: ' + missingFields.map(field => field.label).join(', ') + '.')
        $('#address-colFail').slideDown()
        $(missingFields[0].selector).trigger('focus')
    }
}

var cartColsIds = []

function sendColId(colId) {
    console.log('Entra')
    if (cartColsIds.length == 0) {
        cartColsIds.push(colId)
    } else {
        if (!cartColsIds.includes(colId)) {
            console.log('collection-id:', colId)
            $('#tc-button').remove()
            $('#tc-button-2').removeClass('d-none')
            showMultipleColsModal()
        }
    }
}

function showMultipleColsModal() {
    $('.modal-fix.cmc').css({
        "display": "flex",
        "opacity": "1"
    })
    $('.modal.cmc').css('opacity', '1')
}

async function rdlxp_gszmpkq1_f7e2wq0f4d87_hiyjt(colId) {
    var customers = await customersList(colId)
}
//giftables tool functions
const getCustomerGiftTables = () => {
    return JSON.parse(localStorage.getItem('customerGiftTables'))
}
const getCurrentEditingTable = () => {
    return localStorage.getItem('currentEditingCollection')
}
document.addEventListener('DOMContentLoaded', function () {
    const pathString = window.location.pathname.split('/')
    const metaRobots = document.createElement('meta')
    const metaGoogle = document.createElement('meta')
    metaGoogle.name = 'robots'
    metaGoogle.content = 'noindex'
    metaRobots.name = 'robots'
    metaRobots.content = 'noindex'

    if (pathString[1] === 'collections') {
        document.head.appendChild(metaRobots)
        document.head.appendChild(metaGoogle)
    }
    if (pathString[1] === 'pages') {
        document.head.appendChild(metaRobots)
        document.head.appendChild(metaGoogle)
    }
})
// Functions 2.0
function createDoughnutChart(element, labels, dataset, tooltip) {
    const callback = tooltip ? {
        label: function (tooltipItem, data) {
            let dataset = data.datasets[tooltipItem.datasetIndex];
            let valor = dataset.data[tooltipItem.index];
            return '$' + valor.toLocaleString();
        }
    } : {}
    new Chart(element, {
        type: 'doughnut',
        data: {
            labels: labels,
            datasets: dataset
        },
        options: {
            scales: {
                y: { beginAtZero: true }
            },
            tooltips: {
                callbacks: callback
            }
        }
    })
}
